/*
 * @Author: yusha
 * @Date: 2024-04-19 14:04:40
 * @LastEditors: yusha
 * @LastEditTime: 2024-07-30 18:36:17
 * @Description:
 */
export default {
  清算后扣除: 'Deduction after settlement',
  未清算: 'Unliquidated',
  已经清算: 'Liquidation Completed',
  结算状态: 'Liquidation Status',
  //   '第{day}期': '',
  //   未结算: 'Unliquidated',
  //   结算中: 'Liquidating',
  //   已结算: 'Liquidation Completed',

  部分清算: 'Partial settlement',
  扣费明细: 'Deduction details',
  实际扣除: 'Actual deduction',
  待生成: 'To be generated',
  '已退押金/押金': 'Deposit refunded/deposit',
  合计费用: 'Total cost',
  '当商品状态更改为“已检”和“已取消”，则会清算指定的商品金额，订单的所有商品状态更改为“已清算”，则订单清算完成': 'When the status of a product changes to "Inspected" or "Cancelled", the amount of the product will be settled. When the status of all products in the order is "Settled", the order is considered "Cleared"',
  //   ------------------------------------
  实物图片: 'Real Pictures',
  1688: '1688',
  简易检品: 'Detailed inspection (front side only)',
  详细检品: 'Detailed inspection (front + back)',
  开扣眼: 'Make buttonholes',
  缝布标: 'Sew on fabric tag',
  缝水洗标: 'Sew on laundry tag',
  '去原标（水洗标、布标、吊牌）': 'Remove original tags (laundry tags, fabric tags, hang tags)',
  首饰台纸: 'Replace accessory mounts',
  检针服务: 'Needle inspection',
  熨烫: 'Ironing',
  除味: 'Deodorizing',
  '感谢卡（检品时放在每件商品内）': 'Thank you card insertion (into each item during inspection)',
  '丝带包装（检品时放在每件商品内）': 'Ribbon wrapping (placed in each product during inspection)',
  '雪梨纸包装（检品时放在每件商品内）': 'Thin paper sheet wrapping (placed in each product during inspection)',
  穿吊牌: 'Hanging tags (thread locks)',
  通电检查: 'Energizing test',
  '刮刮卡（检品时放在每件商品内）': 'Scratch card wrapping (placed in each item during inspection)',
  '优惠券（检品时放在每件商品内）': 'Coupon card (placed in each item during inspection)',
  '保证卡（检品时放在每件商品内）': 'Warranty card (placed in each item during inspection)',
  说明书: 'Instruction Manual',
  普通OPP袋: 'Replace (standard OPP bag)',
  定制OPP袋: 'Replace (own-brand OPP bags)',
  特殊收纳袋: 'Replacement of special storage bags',
  '其他物料放置（检品时放在每件商品内）': 'Other accessories (placed in each product during inspection)',
  尺寸测量服务: 'Product measurements',
  气泡膜: 'Bubble Wrap packing',
  商品缠绕膜服务: 'Stretch film packing',
  商品缓冲垫服务: 'Cushion packing',
  剪原标: 'Original tag removal',
  剪布标: 'Cloth tag removal',
  剪水洗标: 'Laundry tag removal',
  剪吊牌: 'Hanging tag removal',
  '尺寸变更(缝尺码标)': 'Size change (size tag sewn on)',
  '尺寸变更(尺码贴)': 'Size change (size sticker notation)',
  宽松检品: 'Loose inspection (front only)',
  圧縮袋梱包: 'Compressed bag packing',
  新商品服务: 'New product confirmation (product photography + product measurements)',
  '感谢卡（发货时放在每个包裹里）': 'Thank you card insertion (into each package when packing)',
  '丝带包装（发货时放在每个包裹里）': 'Ribbon wrapping (placed in each package when packing)',
  装箱服务: 'Cardboard packing',
  贴标: 'Affixing Amazon labels',
  打托盘: 'Pallet packing',
  '雪梨纸包装（发货时放在每个包裹里）': 'Thin paper sheet packaging (placed in each package during packaging)',
  '刮刮卡（发货时放在每个包裹里）': 'Scratch card packaging (placed in each package during packaging)',
  '优惠券（发货时放在每个包裹里）': 'Coupon card (in each package during packaging)',
  '保证卡（发货时放在每个包裹里）': 'Warranty card (in each package when packing)',
  '其他物料放置（发货时放在每个包裹里）': 'Other accessories (in each package when packing)',
  '发货袋-普通快递袋': 'Standard shipping bag',
  商品打木架: 'Wooden crate packaging',
  贴箱唛: 'Box labels',
  组合返工: 'Re-work fee',
  '国/地区': 'Country/Region',
  '都道府県/州/地域': 'State / Province / Region',
  国际料金表: 'International Price List',
  '订单商品代金(预估)': 'Product Price (Estimate)',
  '订单商品附加项(预估)': 'Optional Costs (Estimate)',
  '订单本次实付金额(预估)': 'Total Payment (Estimate)',
  国家不能为空: 'Nationality cannot be left blank.',
  国家填写有误: 'There is an error in the nationality field.',
  待确认报价: 'Waitting for confirmation',
  s: 'Pending',
  是否有异常联络: 'Abnormal Contact',
  支付信息: 'Payment Status',
  订单总金额: 'Total amount',
  'API 未链接': 'API not connected',
  转账金额: 'Transfer amount',
  提供的服务: 'Services offered',
  银行转帐: 'Bank account transfers',
  有缺陷的产品退货: 'Defective Product Returns',
  OEM批量生产: 'OEM Mass Production',
  OEM样品订单: 'OEM Sample Order',
  '* 只可办理资金充值、各店转账、缴纳会员费': '※Can only process fund replenishment, store-specific transfers, and membership fee payments',
  '订单将在商店下达，因此': 'Orders are fulfilled by the store.',
  '下单前，您必须先通过转账方式将资金转入商店。': 'you need to transfer funds to your store before you can place an order.',
  '产品价格/产品选择成本': 'Product price/selection cost',
  '可立即存款，转账费 3.4%': 'Instant deposit, 3.4% transfer fee',
  '付款反映：约1个工作日': 'Payment reflection: 1 business day',
  '*周末、公众假期和替代假期的转账将在下一个工作日处理。': '※Transfers on weekends, public holidays, and substitute holidays will be processed on the next business day.',
  '请提供包含转账日期、转账请求人、收件人姓名和转账金额信息的图片。': 'Please provide an image with the transfer date, transfer requestor, recipient name, and transfer amount.',
  '简单快捷；可立即存款；转账费 3.4%': 'Easy to use, instant deposit, 3.4% transfer fee',
  出借人的土地: "Borrower's land",
  银行网站: 'Bank website',
  '双字节片假名，名字和姓氏之间的双字节空格': 'Double-byte Katakana, double-byte space between first name and last name',
  '*必须与实际转账姓名一致。 请注意输入错误': '※Must match the actual name of the direct deposit, please pay attention to typing errors',
  注意: 'attention',
  '如果取消，所有输入的信息将被删除。': 'If you cancel, all the information you entered will be deleted.',
  '你确定你要继续吗？': 'Do you wish to continue?',
  '指定账户付款完成后，资金立即记入系统账户': 'After the payment from the specified account is completed, the funds will be deposited into your system account immediately.',
  请注意: 'Please note',
  '注册信息与实际账户信息必须完全一致。 只要信息中的一个字符不同，就无法验证支付筛选。': 'The registration information and the actual account information must match completely. As long as one character in the message is different, the payment cannot be validated.',
  货币: 'Currency',
  账户持有人姓名: 'Account holder name',
  帐号: 'Account number',
  银行代码: 'Bank code',
  分行代码: 'Branch code',
  银行名: 'Bank Name',
  银行国家: 'Bank country',
  银行地址: 'Bank address',
  往来账户: 'Checking account',
  复制银行信息: 'Copying bank information',
  预定转移日期: 'Expected Move Date',
  请选择: 'Please select',
  请选择1: 'Please select',
  请选择2: 'Please select',
  必填字段: 'Required field',
  '请注意，如果预定的转账日期与您输入的付款日期不匹配，则付款可能需要一些时间才能反映在系统帐户中。': 'Please note that if the expected date of transfer does not match the payment date you entered, it may take some time for the payment to be reflected in your system account.',
  '货币：日元': 'Currency：USD',
  搜索来源银行名称: 'Search for source bank name',
  '未找到银行名称 手动输入': 'No bank name found, please enter manually',
  输入转账来源银行名称: 'Enter source bank name',
  店铺配置: 'Order Related Settings',
  添加地址: 'Save',
  年: 'Year',
  月: 'Month',
  日: 'Day',
  押金退还: 'Return Deposit',
  修改附加项组合: 'Edit the combination of additional items',
  待确认运输方式: 'Shipping Anomalies(awaiting confirmation)',
  原运输方式: 'Designated shipping company',
  变更理由: 'Reasons for non-delivery.',
  建议运输方式: 'Recommended shipping company',
  收件人姓名: 'Receiver',
  费用明细: 'Cost Details',
  押金: 'Deposit',
  订单已清算完毕: 'Order settled',
  已返还: 'Refunded',
  未返金: 'Not Refunded',
  商品代金: 'Product Cost',
  未确认: 'Not confirmed',
  国内运费: 'Domestic Shipping Fee',
  代购手续费: 'Purchase Fees',
  '{day}期({rate})商品代金(押金)': 'Day {day} of the term Product price (deposit)({rate})',
  '商品附加项(押金)': 'Commodity Option (Deposit)',
  '商品代金(押金)': 'Commodity Price (Deposit)',
  返金: 'Refund',
  '商品附加项(返品不可不良品)': 'Merchandise Option (Non-Returnable Defective Merchandise)',
  国内运费退款: 'Domestic Shipping Refund',
  '这是提交订单时重新订购（缺货、出现缺陷时重新购买）的临时付款。 包括产品价格和产品选择成本。': 'This is the cost to be paid temporarily at the time of order submission or reordering (re-purchase in case of out-of-stock or defective products). This includes the cost of the product and product options.',
  '一旦最终费用确定，相关费用将全额退还。': 'All such fees will be refunded as soon as the final cost is determined.',
  '经检验、退货、换货等后，为最终产品价格及产品选择费用。': 'This is the finalized product price and product option cost after inspection, return, exchange, etc.',
  '这将是中国境内的最终运费和购买费用。': 'Finalized shipping and handling charges in China.',
  没有设置: 'No settings',
  下载收据: 'Download Receipt',
  质检区库存使用数量: 'Number of sets remaining in stock',
  成品区库存使用数量: 'Number of single items in stock',
  库存: 'Stock quantity',
  '使用单件库存组装套件时，将收取返工费。': 'Rework fees apply when using a la carte stock assembly kits.',
  '请检查价目表了解返工费。': 'Review your price list to understand the rework fee.',
  '（单品库存是已经存放在良品室的良品库存，使用单品库存制作套装时，良品库存必须退回检验室重新包装，因此会产生返工费收费。增加。）': "(A la carte inventory is inventory that's already in your inventory room; if you use a la carte inventory to build a set, then the inventory must be returned to your inventory room and repackaged, which incurs a rework fee).",
  商品基础信息: 'Product Basics',
  链接添加: 'Product URL',
  '您可以将多项附加项创建为一个组合，帮助您快速选择附加项': 'To improve efficiency, multiple options can be selected at the same time and set as a single option set.',
  主站: 'HOME',
  最新情報: 'Latest Information',
  '什么是THE CKB': 'What is THE CKB service?',
  费率计划: 'Price Plans',
  计划诊断: 'Plan Diagnosis',
  国际航运: 'International Shipping',
  代购服务: 'Purchasing Service',
  '- 购买现有产品': '- Existing Goods Purchase',
  '- FBA直送': '- FBA direct shipment',
  检验服务: 'Inspection Service',
  '- 检查': '- Inspection',
  '- 维修': '- Repair',
  物流服务: 'Logistics Service',
  '- 国际运输': '- International Freight Forwarding',
  '- 仓库储存': '- Warehousing',
  促销服务: 'Sales Promotion Services',
  '- 翻译': '- Translation',
  '- 照片': '- Photography',
  '- 导入文章': '- Articles of Importation',
  系统: 'System',
  库存系统: 'Inventory System',
  无库存系统: 'No-Inventory System',
  使用流程: 'Flow of Use',
  常问问题: 'Frequently Asked Questions',
  文件要求: 'Request for brochure',
  免费注册: 'New Registration',
  免费注册2: 'Free Registration',
  询问: 'Contact Us',
  采购来源: 'Sourcing in THE CKB',
  信息: 'Information',
  辅料选择: 'Please select materials',
  '客户资材必须得提前先下好，保存在仓库，否则无法对应': '【Please note 】\n Materials must be prepared in advance. If they are not in stock, we cannot support them. If you do not have the materials in stock, please submit an OEM quote request first.',
  新增寻源任务: 'New Quote Request',
  附加项管理: 'Option Set',
  '韩国站{value}级会员': 'Korea Station {value} level member',
  会员资格结束日期: 'Membership End Date',
  '韩国站{value}级会员等级说明': 'Korea Station {value} Level Member Level Description',
  费用详情: 'Cost Details',
  待付款提醒: '【Please note】',
  '您有{num}笔订单待付款，请及时支付，否则会影响订单履约': '【Please note】There is an order waiting for payment. Please check before making payment.',
  错误信息: 'Error message',
  购物车商品: 'Cart',
  我的商品: 'Order History',
  '转账金额（韩元）': 'Transfer amount (KRW)',
  '处理缺陷/异常': 'Defective or abnormal response in progress',
  商品问题原因: 'Reason for Contact',
  商品数量: 'Quantity',
  请选择处理方式: 'Select a Method of Response',
  只可选择一种: 'Choose only one',
  更换颜色: 'Color Change',
  取消商品: 'Cancel',
  换个链接: 'Change product URL',
  平台商品SKU: 'THE CKB SKU',
  'THE CKB订单编号': 'THE CKB Order NO.',
  申请售后时间: 'Application Date',
  售后进度: 'Response Status',
  售后原因: 'Application Reason',
  导出订单: 'Download',
  重新发起: 'Reapplication',
  撤销: 'Canceled',
  申请售后: 'After-sales Compensation Application',
  撤销售后: 'Cancellation of After-Career Compensation Application',
  申请时间: 'Application Date',
  取消进度: 'Cancellation Status',
  '该操作，会将已发起售后商品信息撤销，请确认是否撤销该商品售后？': 'If you cancel an after-sales compensation application, you will not be able to apply for a refund after receiving the product in question again. Do you wish to cancel the application?',
  撤销商品不可再次发起撤销: 'Withdrawal of the product cannot be withdrawn again.',
  请选择售后原因: 'Application Reason',
  详细说明: 'Details',
  申请售后数量: 'Quantity applied for',
  售后退款金额: 'Amount of refund',
  '点击上传图片（最多上传5张）(只能上传jpg/png文件，且不超过10M)': 'Upload images (up to 5 images. Format: jpg/png, 10M or less)',
  '点击上传图片（最多上传5张）(只能上传jpg/png文件，且不超过10000kb)': 'Upload images (up to 5 images. Format: jpg/png up to 10000kb))',
  撤销成功: 'After-compensation application Cancellation of submission',
  问题处理: 'Abnormal Order History',
  问题处理2: 'Abnormal Orders',
  售后: 'After-sales Application',
  申请取消: 'Cancellation request',
  商品取消履历: 'Canceled Orders',
  待处理: 'pending',
  业务处理中: 'Business processing',
  财务处理中: 'Financial Processing',
  已退款: 'Refunded',
  已拒绝: 'Rejected',
  已拒绝3: 'Payment Denied',
  已拒绝2: 'Payment Denials',
  已拒绝4: 'Payment Denials',
  '重新发起（处理中）': 'Reissue (processing)',
  已撤销: 'Cancelled',
  次品: 'Defective',
  次品2: 'Defective',
  相异品: 'Differing goods',
  数量不足: 'Insufficient quantity',
  处理中: 'Processing',
  处理中1: 'Processing',
  保留库存: 'In stock',
  取消成功: 'Cancelled',
  商品信息: 'Product Informations',
  '商品信息(CM)': 'Product Informations(CM)',
  问题生成时间: 'Contact Date',
  处理方式: 'Response Status',
  取消数量: 'Cancellation quantity',
  退款金额: 'Refund Amount',
  申请售后件数: 'Requested quantity',
  拒绝原因: 'Reason for Refusal',
  拒绝原因2: 'Reason for Refusal',
  退款总金额: 'Total Refund Amount',
  退款说明: 'Account statement',
  不可优先发货: 'Not available',
  '可优先发货(订单下部分商品已全部上架)': 'Priority shipping available (inspected items)',
  未处理: 'Unprocessed',
  已处理: 'Processed',
  商品sku: 'Product SKU',
  组合附加项: 'Set Option',
  下单组合数: 'Number of set-pack orders',
  组合完成数: 'Number of completed set-ups',
  '服务费（元）': 'Handling charge (CNY)',
  组合状态: 'Support Status',
  商品画像: 'Product Image',
  本单质检上架数: 'Number of Good Items',
  转结落单库存数: 'Number of remaining inventory available',
  组合落单库存处理情况: 'Remaining inventory on this order',
  国家: 'Country',
  都道府県: 'State/Province',
  序号: 'No.',
  商品单价: 'Merchandise Unit Price',
  '总价（RMB）': 'Total Amount (RMB)',
  总价2: 'Total Amount',
  商品状态: 'Status',
  详情费用: 'Cost Details',
  代买手续费: 'Agency Fee',
  入库手续费: 'Receiving fee',
  质检手续费: 'Inspection fee',
  发货手续费: 'Shipping fee',
  发货单号: 'Shipping Order No.',
  生成时间: 'Creation Date',
  国际运单号: 'Tracking number',
  重量g: 'Weight (g)',
  是否发货: 'Shipping Status',
  发货时间: 'Shipping date and time',
  商品番号: 'Product No.',
  其他费用: 'Other',
  费用类型: 'Fee Type',
  时间: 'Date and Time',
  时间1: 'Date and Time',
  地址详情: 'Detailed Address',
  客户订单编号: 'Customer Order No.',
  下单时间: 'Order Time',
  详情地址: 'Detailed address',
  编辑地址: 'Edit',
  取消并退款: 'Refunded',
  已上架: 'Inspected',
  检品中: 'Under Inspection',
  异常: 'Abnormal',
  国内运输中: 'In Domestic Transit',
  已发货: 'Shipped',
  已发货2: 'Shipped',
  已采购: 'Purchase Completed',
  采购中: 'Purchase in progress',
  已入库: 'Received',
  待采购: 'Waiting for purchase',
  查看: 'Details',
  发货单详情: 'Shipping Details',
  未发货: 'Not shipped',
  未发货2: 'Not shipped',
  编辑收货地址: 'Edit Shipping Address',
  请确认取消信息: 'Cancellation Information',
  '确认是否取消？': 'Please confirm',
  合: 'Total',
  订单编号: 'Customer Order No.',
  等待审核: 'Awaiting Review',
  下单成功: 'Order Completed',
  订单来源: 'Order From',
  订单类型: 'Order Type',
  国际物流信息详情: 'International Shipping Information',
  业务类型: 'Supplier',
  取消结果: 'Cancellation Status',
  所有订单: 'All',
  待付款: 'Pending Payment',
  可发货: 'Awaiting Shipment',
  部分发货: 'Partial Awaiting Shipment',
  已完成: 'Completed',
  已完成2: 'Completed',
  物流公司: 'Shipping company',
  国际物流单号: 'Shipping Requrest NO.',
  发货数量: 'Shipping Quantity',
  是否合单: 'Shipping Status',
  Base: 'Base',
  Shopify: 'Shopify',
  Stores: 'STORES',
  Amazon: 'Amazon',
  直发订单: 'Direct purchase orders',
  囤货订单: 'Stock Order',
  可优先发货: 'Available',
  未组合: 'Waiting',
  组合中: 'Processing',
  组合完成: 'Completed',
  取消组合: 'Canceled',
  日志: 'Operation Log',
  详情: 'Details',
  优先发货: 'Partial Shipment',
  去支付: 'Go to Payment',
  是否去支付: 'Go to Payment',
  国际物流单号信息: 'Shipping Requrest NO.',
  商品日志详情: 'Operation Log',
  支付成功: 'Payment Completed',
  结束时间: 'Due Date',
  商品搜索: 'Product Search',
  下单日: 'Order Date',
  发货日: 'Shipping Date',
  客户商品信息: 'Customer Item Information',
  客户商品SKU: 'Customer Product SKU',
  客户商品名称: 'Product Name',
  客户商品规格: 'Customer Specification',
  客户商品图片: 'Product Image',
  采购商品SKU: 'THE CKB SKU',
  采购商品信息: 'THE CKB Product Information',
  采购商品名称: 'THE CKB Product Name',
  采购商品规格: 'THE CKB Product Standard',
  采购商品图片: 'THE CKB Product Image',
  商品采购渠道: 'Supplier',
  商品状态变更日志: 'Status Change History',
  操作记录: 'Operation Log',
  变更时间: 'Modification date and time',
  '已上架（已清算）': 'Inspected',
  '你授权的xxx店铺取消授权后，店铺订单和商品将不再同步，是否继续取消？': 'xxx data cannot be read due to API linkage release.\n Do you want to cancel the API linkage?',
  是: 'Cancel linkage',
  否: 'Cancel',
  解绑成功: 'Cancel Completed',
  店铺名: 'Store Name',
  创建时间: 'Creation Date',
  状态: 'Status',
  店铺钱包可用余额: 'Balance',
  店铺账号: 'Account Information',
  api权限: 'Authorization',
  店铺管理: 'Stores',
  授权店铺管理: 'Store Management',
  添加新店铺: 'Add Store',
  激活子账号: 'Create Sub Account',
  配置店铺: 'Store Setup',
  开启自动同步下单: 'Auto Ordering',
  取消授权: 'Unlink',
  创建成功: 'Saved',
  创建成功2: 'Saved',
  保存成功: 'Save Complete',
  修改成功: 'Change Completed',
  店铺修改成功: 'Store Information Change Complete',
  物流配置修改成功: 'Change Succeeded',
  水洗标制作: 'Create Laundry Tag',
  日本配送公司: 'Shipping Company',
  国际发货单号: 'Shipping Requrest NO.',
  偏远地区附加费: 'Long Distance Shipping Fee',
  偏远地区附加费退回: 'Long Distance Shipping Fee Refund',
  '出账 / 入账': 'Transaction',
  余额: 'Balance',
  明细: 'Account statement',
  流水号: 'Receipt No.',
  日期: 'Date',
  可用余额: 'Available balance',
  直行发货单号: 'THE CKB Shipment Request No.',
  出账: 'Withdrawal',
  入账: 'Deposit',
  充值: 'Top Up',
  转账: 'Transfer',
  表格导出: 'Download',
  的钱包: 'Account List',
  主账号钱包: 'Master account Account List',
  我的店铺钱包: 'Account List',
  冻结金额: 'Amount Deposited',
  未入账金额: 'Charged Amount (under review)',
  查询: 'Search',
  收据下载: 'Download Deposit Receipt',
  金额: 'Transfer Amount',
  币种: 'Currency Type',
  上传凭证: 'Click to Upload',
  '振込金額(日本円)': 'Amount of money transferred (in Japanese Yen)',
  公司名称: 'Company Name',
  店铺主页入口: 'Home Page',
  姓氏: 'Last Name ',
  名字: 'First Name',
  邮箱地址: 'Email',
  国际: 'Nationality',
  存入金额: 'Amount of Money Transferred',
  '加载完成！': 'Loading Complete!',
  '充值成功！': 'Charge Complete!',
  充值成功: 'Charge Completed',
  收款账号: 'Select a transfer store',
  最多可转账金额: 'Amount available for transfer',
  '商品sku/店铺商品sku/海外仓sku': 'Product SKU/Customer Product SKU/Japan Warehouse SKU (FNSKU)',
  店铺商品sku: 'Customer Product SKU',
  选择地址: 'Select Address',
  输入的手机号位数不正确: 'Please enter correct phone number',
  区町村不能为空: 'District-town cannot be empty',
  最少3个文字以上: 'Please enter at least 3 letters',
  请输入正确的邮编: 'Please enter correct zip code',
  地址添加成功: 'New address has been added',
  'sku/平台商品信息': 'sku/product information',
  库存数量: 'Number of good items',
  代采商品良品数: 'Number of good items',
  客户商品sku: 'Customer SKU',
  海外仓sku: 'Japan Warehouse SKU',
  店铺名称: 'Store Name',
  需要填写清关地址: 'Enter the address of the Importer',
  选择清关地址: 'Select the address of the Importer',
  添加清关地址: "Add Importer's Address",
  补货批次标题: 'Delivery Title',
  箱唛上传: 'Box Label',
  物流方式: 'Shipping Company',
  kg: 'kg',
  计算: 'Calculate',
  预估物流价: 'Reference Shipping Cost',
  '注意：您可以在此输入预计的重量 大致估算出物流价格，货品发出前将根据实际扣除物流费用，请确保您的账户余额充足，余额不足无法扣款将影响您的发货进度。': '【Please note】 The shipping cost is an estimate. We will debit your account for the fixed international shipping fee based on the actual shipping weight.',
  填写: 'Enter',
  移除: 'Delete',
  请选择商品: 'Please select the item(s) you wish to ship.',
  '区町村-详细地址': 'City / Town / Village - Detailed Address',
  国际发货标题不能为空: '※Required field',
  必填: '※Required field',
  必填2: '※Required field',
  物流方式不能为空: '※Required field',
  '支持格式doc;excel;pdf;': 'Support format doc;excel;pdf;',
  '文件大小不超过50m；': 'File size not exceeding 50m;',
  箱唛上传不能为空: '※Required field',
  拣货中: 'Picking in progress',
  打标中: 'Labeling in progress',
  打包中: 'Packing in progress',
  打包完成: 'Packing completed',
  标题: 'Delivery title',
  运单号: 'Tracking No.',
  大件fba: 'Large lot delivery (FBA)',
  大件普通: 'Large lot delivery (non-FBA)',
  小件: 'Small Lot Delivery',
  次品退货: 'Defective Product Returns',
  次品退货2: 'Defective Product Returns',
  异常退货: 'Abnormal Item Returns',
  仓库调拨: 'Warehouse Procurement in Progress',
  创建补货计划: 'Create Amazon Delivery Plan',
  'Amazon sku': 'Amazon sku',
  sku: 'Sku',
  补货批次号: 'Amazon Delivery No.',
  国际运费号: 'Tracking No.',
  运输方式: 'Shipping Method',
  合计总额: 'Total Amount',
  AMAZON商品名称: 'Amazon Item Name',
  计划发货数量: 'Estimated Number of Shipments',
  基本详情: 'Shipping Information',
  发货重量: 'Gross weight (after packing)',
  计费重量: 'THE CKB invoice weight',
  国际发货状态: 'Delivery Status',
  '收货仓/地址': 'Delivery Destination',
  配送件数: 'Number of deliveries',
  箱数: 'Number of boxes',
  装箱清单: 'package',
  装箱清单2: 'package',
  商品内容: 'Item Details',
  创建国际发货: 'International Shipping Request',
  寻源表: 'Request for Quotation',
  寻源种类: 'Merchandise Items',
  类别: 'Plans',
  X类: 'Category X',
  类别注明: 'Service Details',
  产品名称: 'Product Name',
  参考图片: 'Reference Image',
  提供项: 'Reference Information',
  是否提供: 'Already provided',
  具体内容: 'Details',
  参考链接: 'Reference URL',
  样衣: 'Sample',
  物流单号: 'Tracking No.',
  需要改动的地方: 'Where you would like to make changes',
  '描述内容(材质，设计，颜色，尺寸等)': 'Design description (fabric, design, color, size, etc.)',
  附件: 'Attachments',
  式样书: 'Specification sheet',
  '附件(包含产品的色卡、尺寸、特殊工艺、面料信息等)': 'Attachment (Please provide information on product color, size, design, fabric, etc.)',
  面料: 'Fabric',
  需求描述: 'Description of any changes you would like to make',
  面料信息: 'Fabric Details',
  色卡信息: 'Color',
  Logo: 'Logo',
  '详细说明(颜色、尺寸、位置、工艺等)': 'Description (color, size, logo print position)',
  辅料种类: 'Material Type',
  'THE CKB预选方案选择': 'Select a recommendation for direct delivery',
  分类: 'Item',
  选择方案: 'Details',
  定制补充部分: 'Customer Request',
  文字描述: 'Description',
  材质方案: 'Select a recommendation from THE CKB',
  款式方案: 'Design Scheme',
  尺寸方案: 'Size scheme',
  颜色方案: 'Color Scheme',
  款式描述: 'Design details',
  材质描述: 'size details',
  尺寸描述: 'size description',
  颜色描述: 'Color Detail',
  设计图或参考图片: 'Image',
  产品信息: 'Product Details',
  具体尺码信息: 'Size Guide',
  对应关系: 'Details',
  自己提供: 'Submit Size Guide',
  尺码表: 'Size Guide',
  参考链接尺寸: 'Refer to the dimensions on the product page',
  'THE CKB提供': 'Suggestion by THE CKB',
  其他补充: 'Remarks',
  下单需求: 'Order Information',
  期望价格: 'Desired Price',
  期望交期: 'Desired Delivery Date',
  期望起订量范围: 'Desired lot size',
  侧重点: 'Important Considerations',
  品质: 'Quality',
  交期: 'Delivery date',
  Logo需求情况: 'Please describe your logo in detail',
  需要: 'Yes',
  不需要: 'No',
  '工厂、资质要求': 'Requests for factory and permit',
  特殊需求: 'Other Requests',
  服装: 'Apparel',
  杂货: 'Miscellaneous',
  辅料: 'Materials',
  内容: 'Details',
  备注说明: 'Remarks',
  操作人: 'User',
  报价信息: 'Quotation',
  是否加Logo: 'With Logo',
  是否为特殊面料: 'Special Fabric',
  次品处理方式: 'Defective Product Disposal',
  风险: 'Risk',
  打样费: 'Sample cost',
  打样时间: 'Sample delivery time',
  天: 'days',
  时: 'Time',
  分: 'Minutes',
  秒: 'Seconds',
  最小起订量: 'Minimum lot size',
  单尺码: 'One size',
  多尺码: 'Multiple sizes',
  商品数量区间: 'Number of items',
  阶梯价格: 'Price',
  报价有效期: 'Quotation expiration date',
  国际运费说明: '*Domestic delivery charges from the factory to our warehouse may be incurred for some products. If shipping charges are incurred, the cost will be deducted from your balance.',
  全部订单: 'Order List',
  未发布: 'Not submitted',
  等待报价: 'Waiting for quotation',
  已报价: 'Quotation confirmed',
  寻源成功: 'Quotation Completed',
  报价失效: 'Quotation expired',
  已取消: 'Payment Canceled',
  已取消2: 'Payment Cancellation',
  重新发布: 'Re-submit',
  再次买入单号: 'Re-purchase number',
  类型: 'Type',
  申请表: 'Application List',
  商品名: 'Product name',
  查看明细: 'Details',
  发起时间: 'Creation Date',
  寻源单编号: 'Request for Quotation No.',
  查看详情: 'Details',
  拒绝备注: 'Remarks',
  是否确认编辑: 'Do you want to re-edit',
  是否确认发布寻源单: 'Purchase Order',
  发布: 'Submit',
  是否确认取消待发布寻源单: 'Do you want to cancel?',
  是否确定下样品单: 'Do you want to place a sample order?',
  下样品单: 'Sample Order',
  是否确定下大货单: 'Do you want to mass produce?',
  下大货单: 'Mass production',
  是否确认申请退款: 'Do you want a refund?',
  申请退款: 'Refund Request',
  报价过期: 'Quotation expired',
  是否确认申请复购: 'Quotation has expired, would you like to request an updated quotation?',
  复购申请: 'Repurchase',
  是否确认重新编辑: 'Would you like to re-edit?',
  重新编辑: 'Re-edit',
  重新编辑2: 'Re-edit',
  操作日志: 'Operation Log',
  发布成功: 'Submission Complete',
  退款成功: 'Refund Complete',
  已提交申请复购: 'Application for re-purchase has been submitted',
  复购申请中: 'Requesting a quote',
  复购已拒绝: 'Rejected',
  复购已报价: 'Estimate Confirming',
  关联异常: 'Error in linking',
  待关联: 'Waiting for linkage',
  售卖价格: 'Customer Selling Price',
  关联状态: 'Link SKU',
  已关联SKU数量: 'Linked SKUs',
  采购商品名: 'THE CKB Product Name',
  采购价格: 'Purchase Price',
  采购商品图: 'THE CKB Product Image',
  '该店铺未授权同步数据功能，授权后可绑定商品，享受自动下单功能。': 'Not linked to API, order can be processed automatically by API linkage',
  '因采购链接发生变动，请重新绑定': 'Supplier URL has been changed, please re-connect to the supplier.',
  编辑关联: 'Change supplier URL',
  番号保存成功: 'Saved',
  组合商品SKU: 'Set Item Number',
  组合在库状态: 'Remaining inventory',
  '单价（元）': 'Unit price ( CNY )',
  '待组合库存数量（截止时间）': 'Remaining inventory of single item',
  组合商品管理: 'List of set combination products',
  扩大加购: 'Add to cart',
  完结: 'Manage as single item',
  加购: 'Add to cart',
  附加项修改成功: 'Option change completed',
  添加成功: 'Addition completed',
  完结成功: 'Completed Change to Manage as Single Item',
  存在待组合: 'Remaining in stock',
  不存在待组合: 'No remaining stock',
  找相似: 'Find Similar Products',
  断开: 'Unlinked',
  店铺商品sku解绑成功: 'Linkage has been removed.',
  选定: 'Select',
  已连接其他SKU: 'Already Linked',
  断开原有链接: 'Unlink',
  请选择采购商品sku: 'Please select THE CKB products',
  请选择店铺商品sku: 'Please select customer products',
  请选择商品附加项: 'Please select product options',
  店铺商品sku绑定成功: 'Your order has been connected to THE CKB item.',
  同步成功: 'Loading is complete.',
  '0-10元': '0-10 RMB',
  '10-20元': '10-20 RMB',
  '20-30元': '20-30 RMB',
  '30-50元': '30-50 RMB',
  '50-100元': '50-100 RMB',
  '100-150元': '100-150RMB',
  '200-300元': '200-300 RMB',
  '300元以上': 'More than 300 RMB',
  选择要链接的商品: 'Select Product',
  选择要链接商品的SKU: 'Link SKU',
  自动同步采购订单: 'Auto Import Order Info',
  '同步已授权的店铺内商品，并进行绑定': 'Import store lists link the match purchase links',
  搜索青蛙商品: 'Search products',
  商品链接或商品名: 'Search order by URL, product keywords, THE CKB SKU',
  类目筛选: 'Category Filter',
  价格筛选: 'Price Filter',
  采购商品: 'Supplier',
  店铺商品: 'Customer Products',
  重新选择商品: 'Re-establish stocking source',
  创建关联: 'Link SKU',
  系统查询到您有辅料未添加到附加项配置: 'Option not associated with material',
  平均单价: 'Average unit price',
  锁定: 'Scheduled to be used',
  可用: 'Available Inventory',
  待处理次品: 'Defective (non-returnable)',
  辅料图片: 'Image',
  辅料名称: 'Material Name',
  关联附加项: 'Link options',
  辅料规格: 'Standard',
  辅料skuid: 'Material SKU',
  待入库: 'Waiting for stocking',
  次品图: 'Image',
  说明: 'Details',
  说明2: 'Attention',
  丢弃: 'Dispose',
  转为正常商品: 'Goods in stock',
  我的商品库存: 'Product Inventory',
  我的物料: 'Accessory Inventory',
  未关联附加项: 'Unlinked',
  '未关联附加项的辅料，将不会再订单商品中自动使用': 'Option applied. Some materials are not set up.\n Material not available as an option when ordering.',
  下单时的附加项不可用: 'Additional items are not available when placing an order',
  配置附加项: 'Link options',
  辅料绑定提醒: 'Please set the option to be applied to the material',
  '物料名/sku': 'Product Name/SKU',
  已有关联附加项: 'Already Linked',
  未有关联附加项: 'Unlinked',
  可用库存数量筛选: 'Number of Items in Stock',
  至: '-',
  清空: 'Clear',
  批量加入购物车: 'Add to cart in bulk',
  '关闭自动续费后，您的会员将于': 'From canceling automatic payment of membership fee, the use of the current membership class is ',
  到期请前往paypal平台关闭自动续费: 'Please cancel the automatic payment setting on your account on the official Paypal website.',
  '到期是否现在关闭？': 'Ends on',
  '恭喜！！！已为您开启自动续费，记得保持余额充足': 'Membership fee auto-deduction is turned on',
  支付方式: 'Payment method',
  购买明细: 'Payment Details',
  会员信息: 'Membership Plan',
  原价: 'Regular Purchase Price',
  优惠金额: 'Collective Discount',
  ヶ月: 'Months',
  有效期: 'Term of Validity',
  总计: 'Total',
  立即支付: 'Immediate Payment',
  立即支付2: 'Immediate Payment',
  '购买会员到期后我们会为您自动续费，您可在工作台-会员管理中关闭自动续费服务': 'Membership fee can be automatically deducted from your account before the expiration date. Automatic withdrawal settings can be changed from the Member Information page.',
  月会员办理: 'Membership Plans',
  每月: 'Month',
  选择办理会员周期: 'Period of Use',
  请联系主账号更改会员等级: 'Only Master account can be changed',
  去充值: 'Go to Funds Charge',
  去充值2: 'Go to Funds Charge',
  您的账户余额不足: 'Insufficient Account Balance',
  确认支付: 'To Payment',
  '立即购买（自动续费）': 'To Payment',
  '购买后新会员等级立即生效，原有等级作废，如有疑问请联系客服': 'Immediate change of membership plan available',
  请选择会员套餐: 'Select Membership Plan',
  自动续费中: 'Automatic Membership Fee Withdrawal',
  开通自动续费: 'Automatic Membership Fee Payment ON',
  到期: 'End Date',
  关闭成功: 'Automatic Membership Fee Payment OFF. Change Completed.',
  我的消息: 'Message',
  全部已读: 'Mark all as read',
  已读: 'Read',
  '未读/已读': 'Unread/read',
  姓名: 'Full Name',
  请输入姓名: 'Please enter the requester',
  手机号: 'Number',
  请输入市区町村: 'Please enter city/town',
  请输入详细地址: 'Please enter a detailed address',
  请输入邮箱: 'E-mail address',
  '你的子账号没有修改权限，请联系主账号管理者修改你的密码': 'You cannot modify information in your sub-account. Please respond from the main account.',
  无效内容: 'Invalid value',
  无效的地址: 'Invalid address',
  收件人姓名不能为空: 'Please enter a recipient name',
  市不能为空: '※Required field',
  确定删除该商品: 'OK to delete this product',
  确定不再显示该商品: 'Make sure the product is no longer displayed',
  确定清空购物车: 'OK to empty cart',
  确定删除此配置: 'OK to delete this configuration',
  确定删除此地址: 'OK to delete this address',
  '当前页面的修改内容未保存，是否离开': 'The modified content of the current page has not been saved, whether to leave',
  请至少选择一个配置类目: 'Please select at least one category',
  请将收货人信息填写完整后提交订单: 'Required Field. Shipping Information.',
  '单笔订单价值不得超过XX元，请调整商品数量': 'Order Over Limit, D2C Direct Order Total Limit is XX RMB/shipment',
  添加附加项模板成功: 'Default option added',
  修改附加项模板成功: 'Default option has been changed',
  修改邮箱成功: 'Your email address has been changed',
  登录: 'Login',
  请登录: 'Login',
  请先登录: 'Login',
  密码登录: 'Username Login',
  邮箱验证登录: 'Email Login',
  获取验证码: 'Send Code',
  忘记密码: 'Forgot Password',
  '没有账号?去注册会员': 'New User Registration',
  '用户名或邮箱不正确。': 'The user name or mailbox is incorrect.',
  '请重新输入1-18位用户名或邮箱。': 'Please re-enter a 1-18 digit user name or email address.',
  '输入的密码格式不正确，密码由6-32位字母或数字组成': 'Password input error. Password must be within 6~32 alphanumeric characters',
  '邮箱格式不正确，请重新输入': 'Incorrect email address format.',
  '验证码格式不正确，请重新输入': 'Invalid authentication code. Please enter the latest code.',
  '验证码正在发送到您的邮箱，请注意查收。': 'The verification code is being sent to your email, please check it carefully.',
  '请确认后输入验证码。': 'Please enter the verification code after confirmation.',
  '密码不正确，请重新输入': 'Incorrect password.',
  '用户名或密码不正确，请重新输入': 'Invalid user name.',
  '邮箱或验证码错误，请重新输入': 'Invalid verification code. Please enter the correct verification number that we sent you.',
  密码不能为空: 'Please enter your password.',
  用户名不能为空: '※Required field.',
  输入用户名: 'Enter your user name',
  输入密码: 'Enter your password',
  输入邮箱: 'Enter your e-mail address',
  输入验证码: 'Enter verification code',
  找回密码: 'Forgot your password?',
  重设密码: 'Reset Password',
  注册邮箱: 'Email Address',
  邮箱验证码: 'Verification Code',
  新密码设置: 'New Password',
  再次确认新密码: 'Password Confirm',
  '密码修改成功。': 'The password was modified successfully.',
  '请使用刚才重新设定的密码登录。': 'Please login using the password you just reset.',
  提交: 'Confirmed',
  注册: 'New Registration',
  '已有会员，': 'There are members,',
  立即登录: 'Login',
  请选择适合你的业务类型: 'Please select a purchase method',
  适合想要进货到日本仓库的用户: 'Delivered to our warehouse in Japan (large lot delivery)',
  适合想要从中国直发商品到末端客户的用户: 'Direct delivery to end-user (small lot delivery)',
  立即进入: 'Go to home page',
  用户名: 'User Name',
  联系人姓名: 'Full Name',
  密码: 'Password',
  再次确认密码: 'Password (Confirm)',
  性别: 'Gender',
  先生: 'Male',
  女士: 'Female',
  邮箱: 'Email Address',
  验证码: 'Verification Code',
  联系电话: 'Phone Number',
  已发送: 'Already Sent',
  '已发送{X}S': 'Already Sent({X})',
  '该用户名已被注册，': 'The username has already been registered,',
  '请输入别的用户名。': 'Please enter a different user name.',
  '用户名不可用。': 'Username is not available.',
  '用户名不可用，请重新设置1-18位(特殊字符和标点符号不能使用)': 'User name must be within 1~18 characters (special characters and symbols are not allowed)',
  '用户名请设置为1~18以内的字符。': 'Please set the user name to within 1~18 characters.',
  '用户名请设置为1~18以内的字符(不支持特殊字符和标点符号)': 'Please set the user name to within 1~18 characters (special characters and punctuation marks are not supported)',
  联系人姓名不能为空: '※Required field',
  '格式不正确，请输入真实姓名，包括假名和文字及英文': 'Name format is incorrect. Please use only letters for your name.',
  '输入的密码格式不正确，请设置6-32位字母或数字，区分大小写': 'Password input error. Password must be within 6~32 alphanumeric characters',
  两次密码不一致: 'Password mismatch.',
  邮箱已被注册: 'Email address needs to be changed. Email address is already in use.',
  无效的手机号码: 'Please enter a valid phone number.',
  请确认您的手机号码为10到11位数字: 'Please enter your phone number with 10 or 11 half-width digits.',
  请设置用户名: 'Enter Username',
  '你的名字是？': 'Enter full name',
  设置你的登陆密码: 'Enter Password',
  请再次输入您的密码: 'Enter Password',
  '请输入您的手机号码（选填）': 'Enter Phone Number (Optional)',
  '请输入你的Chatwork ID （选填）': 'Chatwork ID (Optional)',
  '请输入你的Skype （选填）': 'Skype (Optional)',
  注册并登录: 'New Registration',
  同意以下条款: 'I agree to the Terms of Use',
  '已有账号，马上登录': 'Already have an account? Login',
  返回首页: 'Go to Home Page',
  默认业务类型: 'Default Purchase Method',
  新密码: 'New Password',
  原密码: 'Current login password',
  旧密码重置密码: 'Change using login password',
  邮箱重置密码: 'Change using email address',
  请输入原密码: 'Current login password',
  请输入新密码: 'New Password',
  输入Aucfan的注册邮箱: "Enter Aucfan's registered email address",
  '根据您输入的信息可以获得会员免费体验，所以请务必输入。': 'According to the information you enter, you can get a free membership experience, so please be sure to enter it.',
  提现渠道: 'Withdrawal address',
  银行名称: 'Bank of our beneficiary',
  银行名称3: 'Bank of our beneficiary',
  支店名: 'Name of the branch from which the payment was made',
  口座类别: 'Account Type',
  银行账号: 'Bank Account No.',
  银行账号3: 'Bank Account No.',
  收款人名称: 'Recipient Name',
  '提现金额（RMB）': 'Refund Amount (RMB)',
  汇率: 'Exchange Rate',
  费率: 'Rate',
  可提现金额: 'Refundable Amount',
  提现手续费: 'Withdrawal Fee',
  '提现金额（JPY）': 'Refund Amount(JPY)',
  提现原因: 'Cause of Withdrawal',
  电子邮件地址: 'Email Address',
  银行卡: 'Bank Account',
  普通: 'Ordinary',
  发送: 'Send',
  请选择提现渠道: 'Withdrawal address',
  请输入银行名称: 'Bank Name',
  请输入支店名: 'Branch No.',
  请选择口座类别: 'Account type',
  请输入银行账号: 'Bank Account',
  请输入收款人名称: "Enter recipient's name",
  请输入提现金额: 'Enter Withdrawal Amount',
  请输入验证码: 'Enter 4-digit authorization code',
  请输入提现原因: 'Enter reason for withdrawal',
  请输入邮箱验证码: 'Verification Code',
  个人中心: 'My Page',
  帮助: 'Help',
  客服: 'Service',
  历史订单: 'Order History',
  我的库存: 'Inventory',
  用户信息: 'User Information',
  OEM寻源单: 'OEM and Menuize',
  OEM发起寻源: 'OEM Quote Request',
  同步的订单: 'Order Management (API Ordering)',
  插件安装: 'KAERU Tools',
  购买会员等级: 'Membership Rank',
  我的店铺: 'Store Management',
  我的钱包: 'Wallet',
  登录账户管理: 'Member Info',
  授权店铺: 'Store Linkage',
  异常订单: 'Abnormal Orders',
  购物车: 'Cart',
  搜索: 'Search',
  最近加入的商品: 'Recently Added Products',
  选择你经常使用的功能: 'Adjust top menu structure',
  最多可选择X个: 'Please select up to X items',
  请选择你经常使用的类目: 'Please select your most frequently used categories',
  '欢迎来到THE CKB': 'Welcome to THE CKB System',
  会员等级: 'Membership Rank',
  切换账号: 'Switch Account',
  我的订单: 'All Orders',
  账号设置: 'Account Settings',
  我的收藏: 'My Favorites',
  登录账号管理: 'Profile',
  我收藏的商品和店铺: 'My Favorite',
  我买过的商品和店铺: 'Purchased Before',
  我看过的商品和店铺: 'Browse history',
  关联商品: 'Link SKU',
  退出登录: 'Logout',
  当前账号已退出: 'You are logged out',
  修改邮箱: 'Change email address',
  新邮箱地址: 'New email address',
  注销子账号: 'Delete child account',
  用户信息更新成功: 'Update Complete',
  更新成功: 'Update Complete',
  邮箱修改成功: 'Email address changed',
  子帐户创建完成: 'Subaccount creation complete',
  快速创建: 'Add store',
  店铺追加: 'Add a store',
  切换B2B囤货业务: 'Go to B2B (stocked) system',
  切换D2C代发业务: 'Go to D2C (stockless) system',
  店铺采购管理: 'Purchase Settings',
  我的地址: 'Receiving Address',
  店铺平台: 'Website',
  登录信息: 'My Profile',
  修改密码: 'Change Password',
  采购配置: 'Purchase Settings',
  附加项配置: 'Additional Services Settings',
  国际物流配置: 'International Shipping Settings',
  您能接受的采购价格上涨: 'Purchase Price Limit',
  次品付费重购: 'Defective Product Settings',
  接受次品重拍: 'Exchange',
  '指定“换货”的场合下，每件商品可以免费交换X次。': 'Each item can be exchanged X times free of charge on the occasion of "exchange.',
  'X次以上每次都会产生现有商品购买手续费 (最大换货次数为3次) 。': 'X times or more will incur a handling fee for the purchase of existing goods (the maximum number of exchanges is 3).',
  '自动换货次数达到上限 (3次) 时的对应方式可以通过“异常订单设定”来设定。': 'The corresponding method when the number of automatic exchanges reaches the upper limit (3 times) can be set by "abnormal order setting.',
  '如果您指定“退货退款”，一旦出现质量问题，我们会自动向您的店铺退款，并自动取消您的订单。': 'If you specify "return refund", once there is a quality problem, we will automatically refund your store and cancel your order automatically.',
  'D2C会员推荐“换货”。': 'D2C members recommend "exchange".',
  退货退款: 'Return Refund',
  '如果您指定“退货退款”，一旦出现质量问题，您可以自动向商店退还退货和货款。': 'If you specify "return refund", once there is a quality problem, you can automatically refund the return and payment to the store.',
  '未指定的情况下，出现次品时，每次的都会向您确认处理方式。': 'If not specified, when defective products occur, you will be confirmed each time.',
  '由于在收到指示之前商品会处于持续待机状态，会导致配送延迟，因此建议事先指定处理方式。': 'Since the item will be in a continuous standby state until the instruction is received, which will cause a delay in delivery, it is recommended to specify the handling method in advance.',
  '从购物车下单时，如果没有按类别设置默认选项，则使用适用于所有商品的默认选项': 'When placing an order from a shopping cart, if the default option is not set by category, the default option for all items is used',
  '从购物车下单时，如果已为每个类别设置默认选项，则可以自动设置该类别的订购商品选项。': 'When placing an order from a shopping cart, if you have set default options for each category, you can automatically set the ordering options for that category.',
  水洗标信息配置: 'The care label setting',
  配置品牌专属水洗标: 'Designation of laundry tag design',
  打开全部: 'Edit',
  去配置: 'Go to material linkage settings',
  使用类目: 'Specified Category',
  类目失效: 'Unavailable Categories',
  搜索地址: 'Search Addr',
  选择物流公司: 'Shipping Company',
  请选择物流公司: 'Shipping Company',
  国际面单主设定: 'Client Settings',
  国际面单依赖主设定: 'Client Settings',
  联系方式: 'Contact Information',
  发货附加项: 'Shipping Options',
  发货附加项2: 'Shipping Options',
  添加新地址: 'Add new address',
  会社编号: 'Corporate Number',
  日文收货地址: 'For Japanese',
  英文收货地址: 'For English',
  修改地址: 'Change Address',
  一键自动配置: "THE CKB's Recommendation",
  一键配置: "THE CKB's Recommendation",
  我的类目: 'Category',
  选择您要配置的类目: 'Select category - Search',
  选择商品附加服务: 'Options',
  选择发货附加服务: 'Select Shipping Options',
  选择我的物料: 'Select Materials',
  附加项: 'Option',
  附加项详情: 'Option',
  辅料sku: 'Material SKU',
  辅料名: 'Material Name',
  预计在库数: 'Stock Availability',
  去补货: 'Stock Replenishment',
  编辑国际物流附加项: 'Shipping Options',
  我的频道: 'MY Channel',
  市场购: 'Direct Market Buying',
  透明购: 'E-commerce site purchase',
  D2C无仓库代发: 'D2C (non-stock)',
  B2B仓库囤货: 'B2B (stocked)',
  采购平台: 'Purchasing website',
  类目: 'Category',
  类目1: 'Category',
  中国语入力: 'Chinese',
  日本语入力: 'Japanese input',
  详细检索: 'Special Conditions',
  去登录: 'Login',
  TaoBao: 'Taobao',
  Tmall: 'Tmall',
  搜款网: 'Search the net',
  网商园: 'Internet Business Park',
  全部类目: 'All Categories',
  搜索范围: 'Sourcing websites',
  搜索关键词: 'Keywords',
  重置条件: 'Clear',
  搜索历史: 'Search History',
  热门推荐词: 'Popular keywords',
  采购渠道: 'Purchasing Route',
  采购市场: 'Supplier',
  采购市场_: 'Supplier',
  关联我的商品: 'Link SKU',
  商品详情: 'Product Details',
  商品来源: 'Supplier',
  加入收藏夹: 'Add to favorites',
  取消收藏: 'Remove from Favorites',
  商品金额: 'Product Price',
  已选清单: 'Selected Item',
  手续费总额: 'Service Fee',
  国际运费: 'international shipping ',
  国际运费退款: 'International Shipping Refund',
  附加项费用: 'Optional Costs',
  单价预估成本: 'Purchase cost (approximate)',
  请选择附加项: 'Please select product options',
  请选择附加项2: 'Please select product options',
  单品预估成本价: 'Total Price(Estimate)',
  相似商品: 'Similar Merchandise',
  相似店铺: 'Similar Stores',
  加入购物车: 'Add to cart',
  传输到我的店铺: 'Upload to my store',
  下载商品图: 'Download product images',
  关联到我的店铺商品: 'Link SKU',
  X件可售: 'X Available',
  商品添加至购物车: 'Add to cart complete',
  该商品无法下载商品图: 'Product diagram cannot be downloaded for this item.',
  商品图下载成功: 'Download Complete',
  '部分图片读取失败，请按需手动下载。': 'Some pictures failed to read, please download manually as required.',
  '正在开启自动下载。': 'Turning on automatic download.',
  购买数量: 'Quantity',
  创建子账号: 'Create Sub Account',
  创建店铺: 'Create Store',
  开店平台: 'Website',
  平台名: 'Website',
  店铺品牌名: 'Store Brand Name',
  店铺URL地址: 'Store URL',
  店铺URL: 'Store URL',
  店铺密钥: 'Shop Key',
  创建并授权店铺数据: 'Create and authorize store data',
  请输入店铺所在的平台名称: 'Please enter the name of the platform where the store is located',
  请输入店铺或品牌名: 'Enter store name',
  请输入店铺访问链接: 'Enter store URL',
  如需授权店铺API请阅读并同意: 'I agree to the API Terms of Use',
  隐私权限: 'Privacy Policy',
  店铺地址不正确: 'Invalid store URL',
  创建店铺成功: 'Store creation complete',
  修改店铺成功: 'Store modification completed',
  店铺授权成功: 'Already Linked to API',
  修改店铺信息: 'Change store information',
  授权状态: 'Linkage Status',
  授权状态1: 'Linkage Status',
  保存店铺: 'Save',
  未授权: 'Unlinked',
  未授权_: 'Unlinked',
  未授权__: 'Unlinked',
  已授权: 'Already Linked to API',
  已授权3: 'Authorized Brands',
  已授权_: 'Already Linked to API',
  已授权__: 'Already Linked to API',
  应用密钥: 'Secret page for API linkage',
  应用ID: 'ID for API linkage',
  站外搜索: 'External site search',
  中国档口七日爆款: 'Best Selling Ranking (7 days)',
  推荐档口: 'Recommended Stores',
  进入店铺: 'View More',
  我收藏的店铺: 'Favorite Stores',
  我看过的店铺: 'Browsed Stores',
  我买过的店铺: 'Stores purchased before',
  '担当推荐店铺（含档口）': 'Stores recommended by staff (including market stores)',
  '推荐店铺（含档口）': 'Recommended Stores (including direct-to-market stores)',
  我看过的商品: 'Browsing History',
  我买过的商品: 'Purchased Items',
  我收藏的商品: 'Favorite Items',
  担当推荐商品: 'Staff recommended products',
  猜你喜欢的商品: 'Recommended Products',
  平台频道: 'Go to detail',
  去购买: 'Go to purchase',
  去选品: 'Go to detail',
  去看看: 'Go to detail',
  主题市场: 'Theme Market',
  猜你喜欢的店铺: 'Featured Stores',
  品类市场: 'Categories',
  市场: 'Markets',
  青蛙频道: 'KAERU MEDIA',
  更多最新文章: 'View More',
  采购相关: 'About Purchasing',
  物流相关: 'Logistics',
  优惠相关: 'About promotions',
  OME相关: 'About OEM',
  他社合作相关: 'Business Alliances with Other Companies',
  热门文章: 'Popular Articles',
  档案: 'Category',
  上一篇: 'Previous',
  下一篇: 'Next',
  采购到库存: 'In Stock',
  C端直发: 'Ship directly to end-user',
  选择店铺: 'Select Store',
  请选择店铺: 'Please select a store',
  检索平台: 'EC Website',
  价格浮动百分比: 'Upper Limit of Purchase Price',
  '原有的商品缺货时，我们会帮你查找新的采购链接，所以请告诉我您能接受的采购价格区间变动': 'If a purchase cannot be made at the specified store, another store will be searched based on the set unit price limit.',
  创建组合商品: 'Create a set of products',
  确认并支付: 'Go to Payment',
  收件人: 'Recipient',
  都道府县: 'State/Province',
  市区町村: 'City',
  市: 'City',
  区町村: 'City/Town/Village',
  详细地址: 'Detailed address',
  邮编: 'Postal Code',
  自定义订单编号: 'Customer Order No.',
  购买店铺: 'Store Name',
  购买类型: 'Order Type',
  收件人不能为空: '※Required Fields',
  联系电话不能为空: '※Required field',
  都道府县不能为空: 'Please enter State/Province',
  详细地址不能为空: 'Please enter a detailed address',
  邮编不能为空: 'Please enter zip code',
  商品预估价格: 'Product cost (estimate)',
  商品预估附加项价格: 'Optional cost (approximate)',
  订单预估总价: 'Total amount (approximate)',
  当前余额: 'Balance',
  提交订单: 'Submit',
  '提示：此金额为预估报价，您下单后，该部分金额将会被冻结。等到该订单采购处理全部完成后，我们会自动解冻这部分金额，并按照实际产生的金额进行扣费。实际扣费详情您可以后续在资金明细页面或订单详情页面查看。': 'We will receive the estimated cost indicated at the time of order request. (The deposit will be fully refunded and the official cost will be settled as soon as the ordered items are inspected.',
  组合商品名称不能为空: '※Required Fields',
  组合商品名称: 'Name of the product in the set',
  组合商品规格: 'Standard of the product in set',
  商品图片: 'Product Image',
  商品规格: 'Specifications',
  商品规格2: 'Standard',
  单组数量: 'Quantity of single item',
  保存并加入购物车: 'Save and Add to Cart',
  组合商品附加项: 'Set Options',
  选择附加项: 'Edit Options',
  组合详情: 'Set item details',
  组合图片: 'Main Image',
  组合: 'Set Items',
  全部: 'All',
  全部_: 'All',
  返回: 'Back',
  其他: 'Other',
  平台: 'Website',
  变更: 'Change',
  全选: 'Select All',
  商品名称: 'Product Name',
  规格: 'Standard',
  商品属性: 'Item Specification',
  在库数量: 'Number in Stock',
  '可用库存/采购数量': 'Number of Goods/Purchase',
  '使用库存/采购数量': 'Stock Available',
  下单数量: 'Quantity',
  起订量: 'MOQ',
  起订量件: 'MOQ Parts',
  单价: 'Unit Price',
  单价2: 'Unit price ( RMB )',
  单价元: 'Unit price CNY',
  总价元: 'Total price CNY',
  版费元: 'Edition fee CNY',
  小计: 'Total',
  商品附加项: 'Product Options',
  商品附加项费用: 'Option Cost',
  操作: 'Operation',
  编辑: 'Edit',
  修改: 'Edit',
  合计: 'Total',
  合计2: 'Total',
  支付: 'Payment',
  账号: 'My Account',
  工作台: 'My Page',
  OEM: 'OEM',
  意见反馈: 'Opinion',
  提示: 'Please note',
  提示1: 'Please note',
  提示2: 'Please note',
  提示3: 'Please note',
  创建: 'Create',
  确定: 'Confirm',
  确认: 'Confirm',
  保存: 'Save',
  保存1: 'Save',
  同意: 'I agree',
  取消: 'Cancel',
  撤回: 'Cancel',
  删除: 'Delete',
  元: 'CNY',
  元_1: 'CNY',
  件: 'items',
  价格区间: 'Price Range',
  风格: 'Style',
  风格_: 'Style',
  颜色: 'Fabric Color',
  颜色2: 'Fabric Color',
  尺码: 'Size',
  其他条件: 'Other Conditions',
  综合: 'Recommended',
  综合排序: 'Recommended',
  价格: 'Price(CNY)',
  成交额: 'Sales Results',
  信用: 'Sort by Review Rating',
  销量: 'Order of Popularity',
  数量: 'Quantity',
  排序: 'Sort by',
  自定义: 'Price Range',
  自定义_: 'Price Range',
  去结算: 'Go to Order Process',
  查看更多: 'View More',
  查看更多_: 'View More',
  默认: 'Default',
  '上传中...': 'Loading and syncing product data...',
  离开: 'Cancel',
  注意2: 'Please note',
  无: 'Other',
  暂无: 'None',
  选填: 'Choice',
  批量删除: 'Delete All',
  公司名: 'Company Name',
  收货地址: 'Delivery Address',
  清关地址: 'Importer Address',
  设为默认: 'Set as default address (default)',
  姓名En: 'Name of en',
  都道府县En: 'Prefectural En',
  市区町村En: 'Urban Town En',
  详细地址En: 'Detailed address En',
  添加商品: 'Add Item',
  图片: 'Image',
  商品类型: 'Order Type',
  至少选一个: 'Please select at least one',
  重置: 'Reset',
  '商品名称/SKU': 'Item Name/SKU',
  加入组合: 'Add',
  普通商品: 'Off-the-shelf product',
  OEM商品: 'OEM product',
  组合商品: 'Sets',
  购物车为空: 'No products in cart',
  上传图片: 'Upload Image',
  无法上传商品: 'Unable to upload product',
  '仅支持已授权店铺上传商品，该店铺未授权': 'Unable to upload products\n This store is not linked and cannot upload products',
  '请输入购买单价上限。在指定店铺无法购买的情况下，会以设定的单价上限为基准，来搜索其他店铺。': 'Please enter a maximum purchase unit price. If the specified store cannot be purchased, other stores will be searched based on the set unit price limit.',
  '指定“换货”的话，每件商品可以免费换货X次。X次以上按Y元/次收取换货手续费 (最大换货次数为Z次)': 'If "exchange" is specified, each item can be exchanged X times for free. Exchange fee shall be charged at Y CNY/time for more than X times (the maximum number of exchanges is Z times)',
  '如果您指定“退货退款”，一旦发生质量问题，会自动向您的店铺退货货款。': 'If you specify "return refund", once the quality problem occurs, it will automatically return the payment to your store.',
  '未指定的情况下，出现次品时，每次都会向您确认处理方式。': 'If not specified, the handling method will be confirmed to you every time when defective products occur.',
  创建寻源单: 'Request for Quotation',
  寻源单列表: 'Quotation Request Management',
  复购申请列表: 'Re-purchase quotation',
  待接单: 'Waiting for receipt',
  待报价: 'Waiting for quotation',
  待商榷: 'Awaiting Consultation',
  寻源失败: 'Refunded',
  发布时间: 'Date of request',
  起始日: 'Start Day',
  结束日: 'End Day',
  寻源单详情: 'Requisition',
  订单状态: 'Order',
  下一步: 'Next',
  拒绝: 'Refusal',
  拒绝2: 'Payment Refusal',
  确定下样品单: 'Do you want to place a sample order?',
  确定下大货单: 'Do you want to mass produce?',
  评价: 'Evaluation',
  有: 'Yes',
  没有: 'No',
  取消寻源单: 'Cancel',
  确认下单: 'Place Order',
  确认重新编辑: 'Do you want to re-edit?',
  确认申请退款: 'Do you want a refund?',
  确认申请复购: 'Quote expired, would you like to request an updated quote?',
  '发布此寻源单需要收取XXX元服务费，请问是否确定发布': 'XXX original response fee applies, would you like to submit a quote request?',
  '发布此寻源单无需收费，请问是否确定发布': 'Free service, do you want to submit a quote request?',
  示例: 'Example',
  以上没有我需要的: 'Other',
  '您想要一个什么类型的商品？': 'Please select a product category',
  '请问你要做什么辅料？': 'Please select the material(s) you are interested in',
  请填写您需要的辅料: 'Please select materials',
  文件上传: 'Upload your files',
  '请问你有自己的方案吗？': 'Do you have your own plan ready?',
  '我有自己的想法，请THE CKB根据我的要求帮我生产': 'I have my own idea, please produce it in response to my idea.',
  '我没有自己的想法，希望THE CKB帮我推荐方案': 'I do not have an idea of my own, I want THE CKB to suggest a plan to me.',
  '我有自己的想法，但是我也想看一下THE CKB的推荐方案': 'I have my own idea, but would also like to refer to a recommended plan from THE CKB.',
  请详细表述并上传您需要定制的辅料设计图或参考图片: 'Please enter the details of your request',
  请详细描述您需要定制的款式信息: 'Please describe the details of the design you would like',
  请详细描述您需要定制的材质信息: 'Please give details of the fabric you would like to use',
  请详细描述您需要定制的尺寸信息: 'Please state your preferred size',
  请查看我们的款式推荐方案: 'Please see the design recommendations from THE CKB',
  请查看我们的材质推荐方案: 'Please see the fabric recommendations from THE CKB',
  请查看我们的尺寸推荐方案: 'Please see the Size Recommendations from THE CKB',
  请查看我们的颜色推荐方案: 'Please see the color recommendations from THE CKB',
  请选择Logo印刷方案: 'Please select your logo printing plan',
  价格和起订量: 'Price and minimum order',
  总价: 'Total Price',
  版费: 'Mold Cost',
  选择色卡: 'Select Color Chart',
  搜索色号: 'Color Chart No. Search',
  色号或色卡名称: 'Color Chat No.',
  请至少选择一种色卡: 'Please select one or more color charts',
  已选色卡: 'Color Chart Already Selected',
  '请问你对本次杂货OEM的初步需求是怎样的？': 'What are your requirements for this sundries OEM?',
  '根据图片或样品，帮我生产出一模一样的产品。（包含加Logo）': 'Produce the product with matching fabric + design according to the picture or sample.',
  '在既成品的基础上，我有一些改良的需求 。（包括颜色、材质、 功能、尺寸、设计等的改良）': 'Produce a product with modifications from an existing product (Improvements in color, material, size, design, etc.)',
  '请联系本公司的对应担当。': 'Please contact the corresponding person in charge of our company.',
  '在本公司发起OEM生产需要提供样式书，详情请咨询您的对应担当。': 'To initiate OEM production in our company, we need to provide style books. Please consult your corresponding responsible person for details.',
  '请问您是否有样品可邮寄？': 'Could your company send us samples by mail?',
  '请问您需要附加Logo吗？': 'Do you want to print your logo?',
  请完善Logo信息: 'Please provide us with your logo design.',
  '请对logo颜色、尺寸、工艺、位置做说明': 'Please describe the color, size, and print location of your logo.',
  '请问您对本次寻源的工厂或产品资质有特殊要求吗？': 'Do you have a request for a quotation factory or permit?',
  资质要求: 'Requests for Permits',
  请上传您的参考链接或图片: 'Upload a reference URL or image',
  '请问您是否有式样书？': 'Do you have a specification document?',
  '我需要定制全新的产品，目前市场上没有既成品可参考。': 'I want to produce an original product. There are no ready-made products.',
  请上传式样书: 'Upload specifications',
  '式样书必须包含产品的色卡、尺寸、特殊工艺、面料信息等': '(Specification document) Please make sure to enter the color chart, size, fabric, etc. of the product.',
  '使用THE CKB帮助您制作式样书': 'Request a specification document to be prepared by THE CKB.',
  '由于信息不足，THE CKB暂时无法为您提供寻源服务': 'Due to incomplete information, we will not be able to provide a quote request service for a while.',
  请详细说明您需要改动的地方: 'Please explain where you would like to make changes.',
  '如果需要改动的点已经在式样书中完全展现，可以略过，否则可做补充说明': 'If you have already indicated what you would like to change on the specification sheet, you do not need to enter any information.',
  补充说明: 'Supplemental Explanation',
  上传文件: 'Upload file',
  请完善信息: 'Please send samples to the address below.',
  请问您是否可以提供样衣邮寄: 'Could your company send us a sample by mail?',
  我有样衣: 'There are samples available.',
  我没有样衣: 'No samples available.',
  'THE CKB地址': 'THE CKB Address',
  请填写物流单号: 'Please provide tracking number',
  请选择您想要的OEM商品生产模式: 'Please select the OEM product production mode you want',
  '我想生产只与产品图像或产品URL设计匹配的产品。': 'I want to produce products that only match the product image or product URL design.',
  '以对应速度为最优先，无需指定商品面料。': 'The corresponding speed is the highest priority, and there is no need to specify the commodity fabric.',
  '与其他方案相比，这是速度最快的应对方案。': 'Compared with other schemes, this is the fastest response.',
  '注重商品设计的一致性，样品确认不是实物确认，而是图片确认。': 'Pay attention to the consistency of commodity design, sample confirmation is not physical confirmation, but picture confirmation.',
  '商品仅保证款式一致，不保证面料和质感，敬请留意。': 'Products only guarantee the same style, do not guarantee the fabric and texture, please pay attention.',
  '※如果有尺寸、布料指定，请选择B或C方案。': '※ If there is a size, cloth specified, please choose B or C scheme.',
  '有商品样品，希望生产面料、尺寸等与样品相同的产品。': 'There are commodity samples, hoping to produce fabrics, sizes and other products with the same samples.',
  '有商品样品，希望更设计、面料、尺寸等进行生产。': 'There are commodity samples, hoping to produce more design, fabric, size, etc.',
  '没有商品样品，只有商品图片或商品URL。希望变更设计、面料、尺寸等。': 'There are no product samples, only product images or product URLs. Hope to change the design, fabric, size, etc.',
  '请提供样品或说明书以供参考。如果没有规格说明书，也可以委托本公司制作规格说明书。': 'Please provide samples or instructions for reference. If there is no specification, you can also entrust the company to produce specifications.',
  请填写你想定制产品的基本信息: 'Please enter information about the planned main order.',
  请填写产品名称: 'Please enter the product name.',
  '由于信息不足，无法进行报价单委托': 'Unable to commission quotation due to insufficient information',
  '请填写商品的尺寸分类。如果有多个尺寸，请按行输入尺寸。例M, L, XL, 30 cm*40 cm*20 cm等。': 'Please fill in the size classification of the goods. If there is more than one size, enter the size by line. For example, M, L, XL, 30cm * 40cm * 20cm, etc.',
  可以邮寄面料样布: 'Can mail fabric samples',
  面料信息说明: 'Fabric Information Description',
  请输入面料信息和颜色: 'Please enter fabric information and color',
  参考样品: 'Reference sample',
  '请输入所需的面料信息(材质、颜色)': 'Please enter the required fabric information (material, color)',
  请描述一下您对面料的需求: 'Please specify fabric',
  '请大致描述一下希望面料的外观或功能上的需求，如:弹性好，柔软等': 'Please roughly describe the appearance or functional requirements of the desired fabric, such as: good elasticity, softness, etc.',
  上传面料图片: 'Import an image of the fabric',
  '请大致描述一下希望改动哪些方面,如：材质、设计、颜色、尺寸等': 'Please describe roughly what you want to change, such as: material, design, color, size, etc.',
  '能提供商品的详细尺寸吗?': 'Can you provide the detailed size of the goods?',
  输入尺寸信息: 'Enter size information',
  '根据服装生产标准，尺寸相差 1-3cm 都属于正常现象，不作为不良品判断，请知悉': 'Please note that apparel quotation production may have an error of 1-3 cm in size, and will not be treated as a defective product.',
  请参考链接尺寸: 'Please refer to the link dimension',
  请提供尺码的具体尺寸: 'Please enter the detailed size of the product',
  尺码模板: 'Template File',
  模板下载: 'Download Template',
  模板下载2: 'Download Template',
  上传模板: 'Import',
  '请先下载对应模板，填写完成后上传。': 'Please download the corresponding template first and upload it after completing it.',
  请输入产品的下单需求: 'Please enter your order information',
  'THE CKB的报价与希望起订量和价格是否匹配，是我们判定是否为您寻源成功的判断依据。请您客观的填写。如果您的希望和市场行情差异过大，我们会之后先联系您，提出修改建议，再开始为您寻源报价。': 'We will find a factory according to the desired lot size and price you entered, but if your request is out of line with the actual market price, we will quote you according to the actual market price.',
  寻源备注: 'Remarks',
  '如果您对本次寻源还有其他特殊需求，请在以下输入您的需求': 'If you have any requests for a quotation request, please do not hesitate to enter them',
  已成功创建寻源单: 'Request for Quotation has already been made.',
  '尚未开始对应。请在管理界面确认内容后提交申请。': 'The correspondence has not yet started. Please submit the application after confirming the content in the management interface.',
  '式样书(例)': 'Specification document (example)',
  棉100: 'Cotton 100',
  可多选: 'Multiple selections available',
  尺码信息: 'Size',
  是否需要加logo: 'If you wish to imprint or print a logo, please submit the logo data.',
  期望交期时间: 'Desired delivery date',
  期望最低起订量: 'Desired lot size',
  关闭: 'Close',
  关闭2: 'Close',
  客户补充部分: 'Customer Request',
  附加说明: 'Description',
  您可以点击此处: 'Request Specifications',
  产品图片: 'Product Images',
  产品规格: 'Product Specifications',
  备注: 'Remarks',
  附加费选项: 'Product Option',
  订单标题: 'Order Title',
  品牌: 'Brand Name',
  品牌_: 'Brand Name',
  总计数量: 'Total Quantity',
  '总计(折扣前RMB)': 'Total (before discount)',
  '总计(折扣后RMB)': 'Total (after discount)',
  估计金额: 'Estimated Amount',
  购物车数量不能小于X: 'Does not meet minimum additional quantity of (X)',
  普通订单: 'Order off-the-shelf',
  组合商品订单: 'Paired Item(s)',
  OEM订单: 'Quoted Products',
  报价已过期: 'Quotation has expired',
  复购申请编号: 'Quote Renewal Request',
  申请状态: 'Status',
  请填写: 'Please enter',
  请上传: 'Upload a',
  请至少选择一种色卡或上传图片: 'Please select at least one color chart. If you do not have a color chart, please upload a photo.',
  链接和图片必须填一个: 'Please enter a link or photo',
  请提供面料材质和色卡信息: 'Please provide fabric material and color chart information',
  请填写具体的面料材质信息: 'Please provide fabric material information',
  '我没有数值，请参考样衣尺寸。': 'Sample dimensions for reference',
  '以上为参考报价，具体报价需要以最终报价为准 ': 'The above is a reference quotation, and the specific quotation shall be subject to the final quotation.',
  该订单不支持修改属性: 'We cannot modify the standard of the product in question.',
  请至少选择或上传一种色卡: 'Please select one or more color charts',
  请填写款式说明: 'Please state the design details you require',
  请填写材质详细说明: 'Please state the fabric details you require',
  请填写尺寸详细说明: 'Please state your preferred size',
  请上传Logo: 'Upload your brand logo',
  请上传尺码表: 'Upload your size',
  请填写期望价格: 'Please enter the desired price',
  请填写期望最低起订量: 'Please fill in the expected minimum order quantity',
  请选择期望交期时间: 'Please enter your desired delivery date',
  重新创建寻源单: 'Quote Update Request',
  查看寻源单列表: 'Please check the "Unsubmitted" page for completed quotation requests.',
  请输入您想要的详细信息: 'Please enter information about your current order',
  'THE CKB的款式推荐方案': 'Please see the Design Recommendation Draft of THE CKB',
  'THE CKB的材质推荐方案': 'Please see Fabric Recommendation of THE CKB',
  'THE CKB的尺寸推荐方案': 'Please see the size recommendation of THE CKB',
  印刷方案: 'Please select a logo printing pattern',
  请输入您的订单信息: 'Please enter your request',
  规格及起订量: 'Price and minimum order',
  '棉100%': '100% cotton',
  '上次寻源未完成，是否继续': 'You have an incomplete quote request, would you like to continue?',
  重新寻源: 'Re-quote request',
  店铺不存在: 'This store was not found',
  没有更多了: 'This is all',
  暂无平台: 'There are no platforms yet',
  输入FAQs关键词: 'Enter keywords',
  收藏商品: 'My favorite products',
  收藏店铺: 'Add to Favorite Stores',
  多为我推荐此类型商品: 'Set as recommended products',
  多为我推荐此类型店铺: 'Set as Recommended Stores',
  不再推荐此商品: 'Exclude from Recommended Stores',
  不再推荐此店铺: 'Exclud from Recommended Stores',
  商品收藏成功: 'Added to Favorite Products',
  店铺收藏成功: 'Added to Favorite Stores',
  '感谢反馈，我们将为你推荐更加准确的商品': 'Thank you for your feedback.\n We will recommend more related products in the future.',
  '感谢反馈，我们将为你推荐更加准确的店铺': 'Thank you for your feedback.\n We will recommend more related stores in the future.',
  注销账号: 'Delete Account',
  提现: 'Withdrawal',
  无法注销帐户: 'Unable to logout account',
  '您的账号中存在以下未处理完结事件，不能注销。': 'Account cannot be deleted.\n Account cannot be deleted due to items in process.',
  账户余额X元: 'Balance X RMB',
  提现申请: 'Withdrawal Request',
  X笔采购订单: 'Number of orders: X',
  X条充值任务未完成: 'X Deposit (Confirming)',
  批量编辑附加项: 'Batch Setup',
  工厂直营: 'Selected by THE CKB',
  组合商品不能再组合: 'Set combination supported. Repeated set combinations cannot be created.',
  '订单已生成，请随时关注订单动态': 'Order complete. Please check the progress from Order Status.　',
  '5s后跳转订单详情': 'Order status will be displayed in 5 seconds.',
  '15s后跳转订单详情': 'Order status will be displayed in 15 seconds.',
  '通过插件，您可以直接在中国购物网站上，将商品添加到THECKB系统的购物车中购买。': 'Through the plug-in, you can directly on the Chinese shopping website, add the goods to the THECKB system shopping cart.',
  '购买商品非常方便!': 'Buying goods is very convenient!',
  立即安装KAERU插件: 'Install the KAERU plug-in now',
  包邮: 'Free shipping within China',
  赠送退货运费险: 'China Return Shipping Insurance Provided',
  新品: 'Latest Products',
  正品保障: 'Genuine Products',
  公益宝贝: 'Products with donation',
  '7+天内退货': 'We accept returns within 7 days for any reason',
  折扣: 'Sale',
  搭配满减: 'Discounts when conditions are met',
  满就减: 'Discount when conditions are met',
  货到付款: 'Cash on Delivery',
  '48小时内发货': 'Ships within 48 hours',
  实力商家: 'Excellent Stores',
  超级工厂: 'Excellent suppliers',
  加工定制: 'Original production',
  人气: 'In order of sale',
  访问令牌: 'Access Token',
  请填写正确的访问令牌: 'Please enter the correct access code',
  组合商品规格不能为空: 'Required field. Please enter the set combination standard.',
  选择一张图片作为组合商品主图: 'Please select one image',
  查看组合列表: 'Check the list of set pairs',
  当前购物车共X种商品: 'Number of items in cart: X items',
  X件商品已添加至购物车: 'X items added successfully to your cart',
  '库存过低不能下单，请调整发货量或及时补充库存': 'The stock is too low to order. Please adjust the number of shipments or restock.',
  回到首页: 'Top page',
  同步商品: 'Synchronize products',
  fnsku: 'FNSKU',
  asin: 'ASIN',
  '请输入Amazon sku': 'Enter Amazon sku',
  '请搜索需要绑定的Amazon sku': 'Enter Amazon sku',
  附加项未配置箱唛: 'Add a box label option',
  附加项未配置贴标签: 'Please add item label options',
  '海外仓sku(fnsku)': 'Japan Warehouse SKU (FNSKU)',
  补货数量: 'Number of shipments',
  未提出: 'Not Submitted',
  已提出: 'Submitted',
  已作废: 'Discard Completed',
  'FNSKU/ASIN': 'FNSKU/ASIN',
  '商品名称/Amazon sku': 'Product Name/Amazon SKU',
  '品名/平台sku': 'Product Name/THE CKB SKU',
  计划发货量: 'Number of deliveries',
  是否确认提出: 'Would you like to submit it?',
  是否确认取消: 'Would you like to cancel it?',
  作废成功: 'It has been cancelled.',
  提交成功: 'Charge has been applied. The charge amount will be reflected after the screening is completed, so please wait for a while.',
  提交成功2: 'Submitted successfully',
  国际发货单标题: 'Delivery Title',
  发货状态: 'Status',
  发货类型: 'Type of delivery',
  批量加购: 'Bulk Repurchase',
  '点击完结 单品可以转普通商品库存': 'Click on the finished item to transfer to ordinary merchandise inventory.',
  '存在待组商品 请尽快加购组合。': 'There are goods to be grouped, please add the purchase combination as soon as possible.',
  物流信息: 'Shipping Information',
  国际单号回传后不可修改: 'Not reeditable. It has been shipped.',
  收件人邮箱: 'Email Address',
  选择订单时间: 'Select Order Time',
  订单付款日期区间: 'Payment date and time',
  未下单: 'Unordered',
  已下单: 'Ordered',
  店铺订单号: 'Customer Order No.',
  订单时间: 'Date',
  采购状态: 'Status',
  订单金额: 'Total',
  收货信息: 'Delivery Address',
  商品图: 'Images',
  '商品名/sku': 'Product name/SKU',
  采购链接sku: 'THE CKB SKU',
  同步订单数据: 'Import Orders',
  一键下单: 'Orders',
  '编辑物流/地址': 'Edit Address',
  是否删除: 'Would you like to delete it?',
  发货附加项编辑成功: 'Shipping options. Edit complete.',
  编辑成功: 'Edit complete.',
  留在此页: 'OK',
  开始时间: 'Start Date',
  质检中: 'Inspection',
  待发货: 'Awaiting shipment',
  '当前申请取消的商品，存在多个商品状态，确认取消后：': 'When the cancellation process is executed,',
  '“X”状态商品，申请取消成功后，系统将自动取消商品的采购与发货，冻结金额在订单结算后返回至可用余额内。': 'Items with "X" status will no longer be purchased or shipped and your deposit will be refunded in full.',
  '“X”状态，申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。': 'Items with "X" status will not be shipped and will be held in stock.',
  '请确认是否申请取消？': 'Do you wish to cancel the order?',
  '“X”状态商品，系统将自动取消商品的采购，冻结金额在订单结算后返回至可用余额内；': 'If you cancel an item with "X" status, we will stop purchasing and shipping the item(s) and refund your deposit in full.',
  '“X”状态商品，不可申请取消（系统将自动忽略）': 'Products with "X" status cannot be canceled.',
  '当前申请取消的商品，商品状态均为“X”状态,': 'Canceling an item in "X" status',
  '申请取消成功后，系统将自动取消商品的采购与发货，冻结金额在订单结算后返回至可用余额内。': 'Cancellation of an item in "X" status will result in suspension of the purchase and shipment of the item and a full refund of your deposit.',
  '当前申请取消的商品，商品状态均为“X”状态，不可申请取消！': 'Products with "X" status cannot be canceled.',
  '当前申请取消的商品，商品状态均为“X”状态，申请取消成功后，系统将自动取消商品的采购，冻结金额在订单结算后返回至可用余额内': 'If you cancel an item with "X" status, we will stop the purchase of the item and refund your deposit in full.',
  再次下单: 'Re-purchase',
  组合信息: 'Set Pair Information',
  结算中心查看明细: 'Check your account details from your account list',
  费用名称: 'Type',
  '结算总价（元）': 'Total Amount ( RMB )',
  问题联络: 'Issue Contact',
  冻结: 'Deposit',
  解冻: 'Deposit Refund',
  结算: 'Go to order process',
  重拍冻结: 'Deposit (replacement)',
  销售单价: 'Unit Price',
  结算数量: 'Quantity',
  结算总价: 'Total Price',
  点击上传凭证: 'Click to Upload',
  みずほ銀行: 'JP MORGAN CHASE BANK, N.A. ',
  商品代金结算: 'Item Price',
  国际物流费用: 'International Shipping',
  国际物流费用退回: 'International Shipping Refund',
  国际运费重量差补扣: 'Refund for International Shipping Difference',
  国际运费附加项补扣: 'Total amount of additional international shipping charges',
  销毁费补扣: 'Disposal fee',
  偏远地区费补扣: 'Distant shipping fee',
  仓储费补扣: 'Logistics warehousing fees',
  超长超重费补扣: 'Oversize charges',
  关税补扣: 'Customs duty',
  改派费补扣: 'Destination change fee',
  特殊处理费补扣: 'Special handling fees',
  扣件费补扣: 'Shipping stoppage fee',
  退件费补扣: 'Return shipping fee',
  冻结总价: 'Total purchase provisional payment amount',
  解冻总价: 'Total amount',
  重拍冻结商品代金: 'Refund of purchase provisional payment',
  冻结商品代金: 'Temporary Purchase Payment',
  解冻商品代金: 'Deposit Refund',
  冻结总数量: 'Total number of purchases',
  解冻总数量: 'Total Number',
  手续费: 'Agency Commission',
  次品重买总次数: 'Number of times defective products have been exchanged',
  纸箱总数量: 'Number of boxes',
  装箱总数量: 'Number of shipments',
  气泡膜总数量: 'Total number of bubble wrap',
  托盘总数量: 'Total number of pallets',
  箱子总数量: 'Number of boxes',
  结算总数量: 'Total number of boxes',
  我的默认附加项: 'Default option settings (all products)',
  我的类目附加项: 'Default option settings (for each product category)',
  商品总金额: 'Total Amount',
  发货单: 'Packing List',
  箱: 'box',
  钱包: 'Account List',
  收藏: 'Favorites',
  记录: 'Records',
  足迹: 'Browse History',
  浏览记录: 'Browse History',
  购买记录: 'Purchase History',
  没有可优先发货的商品: 'There are no items that can be shipped in installments.',
  是否确认优先发货: '【Please confirm】 Do you wish to ship this item in installments?',
  优先发货成功: 'Shipment in installments has been set up.',
  没有可申请取消的商品: 'There are no items available for cancellation.',
  是否确认删除: '【Please confirm】 Are you sure you want to remove this item from the list?',
  搜索商品: 'Search products',
  '您将要删除X条商品数据，删除后将无法恢复': '【Please confirm】 Once you delete the selected items, you cannot undo the deletion. Do you wish to delete the product?',
  请输入商品名: 'Please enter the product name',
  请输入商品名3: 'Please enter the product name',
  选择收货地址: 'Please select the delivery address',
  国际发货标题: 'Delivery Title',
  是否确定加购大货: '【Please confirm】Do you want to mass-produce this product?',
  加购大货: 'Mass production',
  确定加购样品: 'Sample Order',
  加购样品: 'Sample Order',
  库存还有X件商品或辅料: 'We have X number of products (materials) in stock',
  去处理: 'Details',
  '账号注销后我们将不再保存您的任何账号信息，是否注销？': '【Please check】 If I delete my account, all information in the direct delivery system will be deleted and cannot be restored. Do you want to delete your account?',
  直行台: 'Member Center',
  账户概览: 'Member Center',
  同步订单: 'Order Management (API Ordering)',
  订单详情: 'Order Details',
  购买过: 'Purchased Products/Store',
  消息: 'Message',
  商品管理: 'Products',
  关联商品库: 'Linkage Management',
  我的组合商品: 'Set Pairs',
  国际发货: 'International Shipping',
  国际发货列表: 'International Shipping List',
  国际发货详情: 'International Shipping Details',
  补货计划: 'Delivery Title',
  资金管理: 'Funds',
  授权管理: 'API Linkage',
  再购入: 'Request for Re-Quote',
  下单: 'Order',
  同步商品信息: 'Import Store Items',
  库存数: 'Goods in stock',
  可售: 'In Stock',
  可用库存: 'Goods Quantity',
  已锁定: 'Scheduled for Use',
  待处理次品数: 'Non-Returnable Defective Items',
  导出成功: 'Downloaded',
  'THE CKB发货单号': 'THE CKB Shipment Request No.',
  复购: 'Repurchase',
  筛选条件: 'Search Terms',
  '客户商品sku/海外仓sku': 'Your SKU/Japan Warehouse SKU',
  '平台客户sku/商品名称': 'Product SKU/Product Name',
  更新: 'Update',
  平台商品信息: 'Product Information',
  'AMAZON库存(可售)': 'Amazon (In Stock)',
  'AMAZON库存(入库)': 'Amazon (Waiting in stock)',
  'AMAZON库存(不可售)': 'Amazon (Not Available)',
  预计总库存: 'Total',
  绑定: 'SKU Linkage',
  绑定1: 'Bind',
  解绑: 'Remove linkage',
  确认签收: 'Receive',
  '是否确认签收？': 'Would you like to receive this item?',
  '是否确认取消国际发货？ 仓库已在作业中的发货单无法取消。': 'Cancellation is not possible. This delivery request is being processed in our warehouse. Please contact the person in charge for details.',
  '小计（元）': 'Subtotal ( RMB )',
  实际发货数量: 'Actual delivery quantity',
  提出: 'Submitted',
  已确认: 'Processing',
  尺寸: 'Size',
  寻源单号: 'Quotation Request No.',
  样品单: 'Sample Order',
  大货单: 'Mass Production',
  预计可发货数: 'Maximum Shipping Quantity',
  查看订单详情: 'Check Order Details',
  购买数量不可为空: '※Required field. Purchase quantity',
  '购买数量不足。': 'Insufficient number of purchases.',
  购买数量不可低于起订量: 'Incomplete purchase quantity.\n Purchase quantity does not meet minimum lot size.',
  子商品总数不能少于2件: 'A minimum of two single items is required for one set of products',
  批量编辑商品附加项: 'Batch Edit Product Options',
  需要填写收货地址: 'Please enter shipping address',
  添加收货地址: 'Add Shipping Address',
  payoneer充值记录: 'Payoneer Charge History',
  我知道了: 'Close',
  '存入金额（USD）': 'Transfer Amount (USD)',
  待初审: 'Waiting for initial review',
  待终审: 'Waiting for final review',
  已通过: 'Review Completed',
  上传成功: 'Uploaded',
  参考单价: 'Unit Price',
  冻结数量: 'Number of purchases',
  扣费日: 'Calculation Date',
  上次扣费日: 'Inventory storage period (beginning of period)',
  上架日: 'Date',
  免费保管天数: 'Free storage days',
  计费天数: 'Billable Days',
  请确认: 'Please confirm',
  '当前账号下无店铺，': 'There is no store under the current account,',
  请创建店铺后再执行操作: 'Please create a store before performing the operation',
  普通发货: 'Other than Amazon FBA delivery',
  FBA发货: 'Amazon FBA Delivery',
  收货仓: 'Destination of delivery',
  '如果您当前存在部分订单未完成的话，您账户可用余额中我们将会自动为您留下当下账户冻结金额*1的金额，来确保账户有足够的金额来支付国际运费后顺利发货。': 'If some of your current orders are not completed, we will automatically leave you the amount of the current account frozen amount * 1 in the available balance of your account to ensure that the account has sufficient amount to pay for international freight and then ship the goods smoothly.',
  '所以您目前可转账的金额为：账户可用余额减去冻结金额': 'So the amount you can currently transfer is: the available balance of the account minus the frozen amount.',
  本公司接受银行: 'Our beneficiary bank：Mizuho Bank',
  汇款人姓名: 'Name of payee',
  汇款时间: 'Date and time of transfer',
  汇款凭证: 'Payment Screenshot/File',
  点击上传: 'Click to upload',
  良品入库: 'Incoming ( Good )',
  不良品: 'Defective item',
  付费重拍: 'Paid exchange',
  本次重拍费用X円: 'Paid, this time the exchange fee is X $',
  '接受次品/缺货自动付费重拍（接受自动重拍，有助于我们更快的为您完成订单采购）': 'D2C members are recommended to "Exchange"',
  更换尺码: 'Size change',
  更换款式: 'Design change',
  '请输入链接(必填)': 'Enter URL (required field)',
  请输入链接: 'Please enter a link',
  同款链接: 'URL for the same item',
  点击可查看: 'Click to check',
  类似款链接: 'Similar product URL',
  等待原链接: 'Waiting for original URL',
  下单原链接: 'Buy original URL',
  '下单原链接（多出数量保留库存）': 'Purchase original URL (remaining inventory is stored in stock)',
  申请成功: 'Please allow 2 business days for the after-sales compensation application to be processed.',
  申请成功2: 'Successful application',
  '提交售后补偿申请，处理完成需要2个工作日左右，请稍等。': 'It will take about 2 working days to submit the after-sales compensation application. Please wait a moment.',
  请确认尺码: 'Confirmation of size',
  请确认颜色: 'Color Confirmation',
  '请确认设计（款式）': 'Confirmation of design',
  '全网断货，建议取消': '【Please confirm】\n All sites are out of stock. We recommend you to cancel your order.',
  '原商品缺货，找到了类似商品，请确认': '【Please confirm】\n The original URL is out of stock, we found a similar product in stock.\n Please confirm whether you wish to purchase.',
  '预售商品。预计下单后X天后能发货，要等吗？': '【Please confirm】\n The original URL is a pre-order item, and can be shipped from X days after the order is placed!\n Please confirm whether you want to buy it or not.',
  '找到新的现货链接，是否购买？': 'Find new spot link, buy?',
  '此商品的最小起订量是X件。请确认是否购买。': '【Please confirm】\n The minimum lot size for this item is X.\n Please confirm whether you want to purchase or not.',
  '找到符合下单量的新链接，是否可以购买。': '【Please confirm】\n We have found a URL where you can purchase the desired number of lots.\n Please confirm whether you want to purchase or not.',
  '原商品质量不佳，推荐在新链接采购。': '【Please confirm】\n I received a defective item even after several exchanges, so I recommend ordering at the new URL.',
  到错货: 'I received different items than I ordered.',
  少件: 'I received more items than I ordered.',
  多件: 'I received fewer items than I ordered.',
  快递扫不出: 'QR code cannot be read.',
  '配件差异（口袋，腰带，纽扣，拉链，拉绳等）': 'Wrong accessories',
  '设计差异（压线，领口，袖口，花纹，衣服设计等）': 'Wrong design',
  '材质/面料差异': 'Difference in fabric',
  '不良原因:有色差\n根据检查标准，判断为不良品。\n发生不良品时请指定处理方式。': 'Bad reason: color difference\nAccording to the inspection standard, it is judged as defective product.\nPlease specify the handling method when defective products occur.',
  'THE CKB档口': 'THE CKB Market Store',
  '我们的 OEM 仅适用于商务舱和头等舱成员。如果您想使用OEM，请从[会员信息]更改会员等级。如果您有任何问题，请联系我们的在线客服。': 'The OEM service is available to members above the Economy Program. If you want to enjoy OEM service, please upgrade your membership level.',
  充值会员: 'Go to Membership Rank Change',
  购买数量不可低于X件: 'Minimum lot quantity is X!',
  '平台库存（处理中）': 'THE CKB Inventory (in process)',
  '平台库存（已锁定）': 'THE CKB Inventory (Scheduled to be used)',
  '平台库存（可用库存）': 'THE CKB Inventory (Goods)',
  '平台库存（待处理次品数）': 'THE CKB Inventory (Non-Returnable Defective Items)',
  转账金额不能为0: 'Please enter an amount greater than or equal to 0 CNY for the transfer amount!',
  '同步中...': 'Loading...',
  '同步完成-执行刷新': 'Completed',
  我的工作台: 'My Page',
  订单管理: 'Orders',
  API同步订单: 'Order Management (API Ordering)',
  库存管理: 'Inventory Management',
  寻源列表: 'Quotation Request Management',
  OEM复购: 'Re-Quote Request List',
  'API/子账号配置': 'API Linkage / Store Creation',
  子账号配置: 'sub-account configuration',
  会员相关: 'My Account',
  会员办理: 'Join the Membership',
  国际配送管理: 'Shipping',
  FBA补货计划: 'FBA Delivery List',
  国际发货管理: 'International Delivery List',
  国际发货售后: 'After Sales Compensation Application',
  主账号资金明细: 'Master account List',
  店铺资金明细: 'List of Store Accounts',
  OEM寻源: 'Request for Quotation',
  全部店铺数据: 'Store Info',
  '这是您与THE CKB相处的第X天': 'Enrollment days: X days',
  升级会员: 'Join the Membership',
  钱包余额: 'Available Balance',
  未关联的商品: 'Unlinked Products',
  API同步异常订单: 'Abnormal Orders (API Orders)',
  商品在库: 'Product Inventory',
  在库辅料: 'Accessory Inventory',
  下单金额: 'Order Amount',
  API下单量: 'Number of orders (API orders)',
  订单数量: 'Order quantity',
  采购金额: 'Order Amount',
  采购量: 'Number of orders.',
  发货量: 'Number of items shipped.',
  待发库存数: 'Inspected (ready for delivery)',
  待确认补货计划: 'Delivery plan awaiting confirmation',
  待确认补货计划1: 'Delivery plan awaiting confirmation',
  未绑定商品: 'Unlinked products',
  请先关联商品: 'Unlinked',
  对折: 'Fold in half',
  不使用商品番号: 'No item number will be used',
  不使用客户商品sku: 'No customer SKU will be used',
  关联商品库填写: 'Enter the details of the linkage',
  请填写会社名: 'Please enter the company name',
  请填写会社地址: 'Please enter the company address',
  '图片格式支持jpg，png。': 'The only formats that can be uploaded are "jpg" and "png".',
  'LOGO图片比例为1:1，在水洗标打印时转变为黑白色': 'The image scale of the logo is 1:1, printed in black and white.',
  缝制样式: 'Sewing style',
  请选择商品番号填写方式: 'Please select the input method for the product number',
  '更新中...': 'Updating...',
  更新中: 'Updating...',
  '更新完成-执行刷新': 'Update Completed',
  Amazon在庫数更新: 'Amazon Stock Number Update',
  购买时间: 'Purchase Date',
  收藏时间: 'Date',
  更新时间: 'Update Date',
  请选择需要复购的商品: 'Please select the goods to be re-purchased',
  请选择需要优先发货的商品: 'Select items you would like to ship in installments',
  请选择需要取消的商品: 'Select items you wish to cancel',
  请选择需要售后的商品: 'Select items for which you would like to request a refund after receipt',
  请选择需要导出的订单: 'Select orders you wish to download',
  '自動発注をOFFにしました。': 'Automatic ordering is turned off.',
  '自動発注をONにしました。': 'Automatic ordering is turned on.',
  お届け先住所の形式が正しくありません: 'The format of the shipping address is incorrect',
  再度確認してから提出してください: 'Please confirm again before submitting',
  店铺url和访问令牌不能为空: 'Please enter your store URL and access code',
  未关联sku数量: 'Unlinked SKUs',
  星期一: 'Monday',
  星期二: 'Tuesday',
  星期三: 'Wednesday',
  星期四: 'Thursday',
  星期五: 'Friday',
  星期六: 'Saturday',
  星期日: 'Sunday',
  平台库存: 'THE CKB Stock',
  AMAZON库存: 'Amazon Stock',
  不可售: 'Not available for sale',
  入库: 'In-stock',
  '商品“已上架”之前的状态下的总数量': 'Number of orders that have not yet arrived at the warehouse',
  已使用准备发给您的商品: 'Number of relevant items currently scheduled for delivery',
  可使用的正品数量: 'Number of good items currently in the warehouse',
  '仓库发现商品次品且无法退款，进入您的次品库存': 'Number of non-returnable defective items currently in our warehouse',
  弊社受取銀行: 'Our receiving bank',
  横浜駅前支店: 'Yokohama-Ekimae Branch',
  店番292: 'Branch No. 292',
  口座番号: 'Account No.',
  '普通預金 4014779': '77722200512051843',
  口座名: 'Account Name',
  '株式会社 SNIFF JAPAN': 'HONGKONG EASYGO TRADING CO.,LIMITED',
  料金表: 'A list of fees',
  国際配送依頼番号: 'International Shipping Request No.',
  收据: 'Payment receipt',
  一键绑定: 'SKU auto-linkage',
  导出: 'Download',
  请确认售后信息: 'After Sales Compensation Application',
  解冻数量: 'Quantity',
  通过FBA补货计划发货: 'Amazon FBA Delivery',
  海外仓sku不能为空: 'Please enter your Japan Warehouse SKU',
  缺货: 'Out of Stock',
  传输商品信息到店铺: 'Batch registration to store',
  '创建成功，并已为您自动创建关联': 'Creation completed, linkage has been created automatically.',
  查看关联商品库: 'Confirm linkage management',
  领收书下载: 'Download Receipt',
  领收书: 'Receipt',
  流水: 'statement',
  是否确定加购样品: 'Would you like to order samples?',
  查看报价信息: 'Quotation details',
  加购成功: 'Add to Cart Complete',
  汇款金额必须大于0: 'The amount of the remittance must be greater than or equal to zero.',
  确认取消: 'Confirmation',
  '请绑定 Amazon sku': 'Amazon SKU is not yet specified. Please link to Amazon SKU.',
  换绑: 'Change Linkage',
  '绑定Amazon sku': 'Binding Amazon sku',
  '申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。': '【Please check】 If I delete my account, all information in THE CKB system will be deleted and cannot be restored. Do you want to delete your account?',
  是否确认取消授权: 'Do you want to remove API linkage',
  申请月数: 'Number of months applied',
  转账成功: 'Transfer Completed',
  银行转账: 'Bank Transfer',
  '您的余额不足，请充值后再次支付': 'If your account balance is insufficient, please recharge your account and then reexecute the transaction.',
  '5s后跳转充值页面': 'After 5 seconds, you will be redirected to the "Charge Funds" page.',
  '5s后跳转附加项配置': 'Move to the option setting page after 5 seconds.',
  下单失败: 'Order Failure',
  下单失败3: 'Order Failure',
  请确认本次重拍费用: 'Check the exchange fee',
  当前单价: 'Unit Price',
  商品关联列表: 'Linkage management list',
  修改关联: 'Change linkage',
  编辑附加项: 'Edit Options',
  '为您的商品编辑的附加项，会再API下单时直接使用。如需修改请点击此处。': 'If the product options been set already in store- option set, the order products options service for API orders will be same set automatically. Click edit to reedit ',
  请选择发货附加项: 'Options for Selective Shipping',
  请上传图片: 'Upload Logo Image',
  一键删除: 'Delete in Bulk',
  店铺商品信息: 'Product Informations',
  '如果是个人，请输入无': 'Please enter none if you are an individual',
  订单结算费用详情: 'Cost Details',
  物流详情: 'Delivery Status Details',
  订单搜索: 'Search Orders',
  发货详情: 'International Shipping Information',
  输入你的登陆密码: 'Enter your login password',
  是否确认复购: 'Would you like to add items to your cart?',
  复购成功: 'Add to cart complete',
  不同意: 'Disagree',
  '请填写商品的尺寸分类。': 'Please fill in the size classification of the goods.',
  '如果有多个尺寸，请按行输入尺寸。': 'If there is more than one size, enter the size by line.',
  '例 M、L、XL、30cm*40cm*20cm等': 'Example M, L, XL, 30cm * 40cm * 20cm, etc.',
  '请输入正确的Amazon sku': 'Please enter the correct Amazon sku',
  打印标签模板: 'Product Label',
  预览: 'Preview',
  设为默认地址: 'Set as default address',
  'Amazon sku绑定成功': 'Amazon Sku linkage successfully completed',
  '未处理，请点击【提出】按钮': 'Outstanding <br/> ※ Click submit for official response',
  OEM报价: 'OEM',
  '处理中，需要1～2分钟': 'Process in progress, taking 1-2 minutes',
  我的OEM商品: 'OEM Products',
  转到运输公司设置: 'Shipping Settings',
  '点击上方按钮编辑你常用的<span>快捷功能</span>': 'Screen display menu can be specified with check box',
  '拉动板块可<span>调整功能排序</span>哦！': 'You can change the screen order by selecting each menu and changing the configuration',
  '编辑后的功能入口在上方显示，你需要的功能直接点击前往即可': 'The edited function entrance is displayed at the top, and the function you need can be clicked directly.',
  '<span>透明购</span>: 为首页，并为您推荐1688、淘宝、天猫的商品查找专区。<br/><span>市场购</span>: THE CKB扩展的市场采购货品更全，价格更低。<br/><span>我的频道</span>: 你在本平台的喜欢的商品都在这里。 <br/>任何情况下，点击<span>logo</span>回到本页面': '<span>purchase on EC sites </span>：Search and purchase on major Chinede EC sites(1688、Taobao、Tmall)<br/><span>Market purchasing</span>：Search and purchase products from wholesale markets affiliated with THE CKB.<br/><span>MY Channel</ <br/><span>MY Channel</span>: Displays recommended suppliers and favorite products<br/>* Clicking the frog icon will take you to the EC site purchase.',
  '选择你感兴趣的<span>平台</span>和<span>类目</span>，再输入关键词，搜索更精准': 'Specify an e-commerce site and category, and enter product search keywords to search for related products in the system.',
  '点击“X”在THE CKB平台搜索': '【X】click to search for products in the direct delivery system based on the specified conditions.',
  '点击“X”跳转你选择的平台搜索。': '【X】click to search for products in THE CKB system based on the specified conditions.',
  'THE CKB为你提供了多个选购平台。根据你的<span>采购类型迅速选品</span>。': 'The following are some useful sites for product selection',
  '点击上方切换你喜欢的品类，我们将根据该品类进行推荐。': 'Select a category to display<br/>Displays recommended products in the selected category',
  '如果您有多个店铺可点击这里切换店铺，为不同的店铺采购。THE CKB也会为不同的店铺推荐不同的商品。': 'Switch between multiple stores and purchase products from each shop<br/>Recommended products are presented for each store by THE CKB.',
  '你的专属担当根据你的采购习惯，为您甄选的店铺会展示在这里。': 'Display the recommended stores from your dedicated manager.',
  '此处由系统根据你的采购习惯，为你甄选的店铺会展示在这里。': 'Display recommended stores based on your purchase history.',
  '下方为商品的推荐，会根据你的购买习惯更新商品哦！！！': 'Display recommended products based on your purchase history from the system.',
  '你还没有店铺，快去创建一个你的店铺，用来采购你的商品。': 'No store has been created yet<br/>You need to create a store to place an order.',
  跳过: 'Exit Guide',
  主钱包: 'Master account',
  子钱包: 'Select Sub-account',
  国际发货创建成功: 'International Shipping Request Creation Complete',
  处理中的次品和异常: 'Defective or abnormal item (being handled)',
  不可退货次品: 'Defective item (non-returnable)',
  去查看采购订单: 'To Order Details',
  资金明细: 'Funds Details',
  资金明细2: 'Funds Details',
  修改商品附加项: 'Edit',
  订单: 'Order',
  申请取消成功: 'Cancellation Requested',
  选择同款: 'Place an order with the same product URL',
  '是否确认取消国际发货？': 'Do you wish to execute the cancellation?',
  '海外仓（fnsku）/asin': 'Japan warehouse (fnsku)/asin',
  'Amazon sku/AMAZON商品名称': 'Amazon sku/Amazon product name',
  '搜索Amazon sku/FNSKU/ASIN/SKU': 'Please enter Amazon sku/fnsku',
  下单中: 'Order is being processed, please wait a moment',
  无效的URL: 'Please enter a valid URL',
  请选择打印模板: 'Please select a product label',
  商品更新: 'Update product',
  最新价格为X元: 'Price has been updated. The latest order price is X CNY. Update completed.',
  请选择要翻译的语种: 'Select language:',
  '请输入THE CKB订单编号': 'Enter THE CKB order number',
  发货标题: 'Delivery Title',
  请设置商品附加项: 'Please set options for product inspection',
  通过点击关联符合您要求的sku: 'Click to link target products',
  商品附加项要保存吗: 'Do you wish to save your inspection options?',
  签收成功: 'Receive Package Completed',
  已签收: 'Receiving Completed',
  API状态: 'API Linkage',
  请上传箱唛: 'Upload required box labels',
  箱唛文件: 'Box Label',
  上传箱唛: 'Upload Box Label',
  修改箱唛: 'Change Shipping Label',
  无法取消附加项: 'It cannot be canceled.',
  商品情报: 'Product Information',
  箱番号: 'Box number',
  请上传装箱清单: 'Please upload your delivery note',
  乐天: 'Rakuten',
  乐天sku: 'Rakuten SKU',
  上传文件只能是X格式: 'Uploaded file is invalid.　Please upload an "X" format file.',
  装箱明细: 'Delivery details',
  档口手续费: 'Market Purchase Commission',
  出库手续费: 'Shipping Fee',
  店铺仓库所在地: "Location of the store's warehouse",
  杭州仓: 'Hangzhou Route',
  广州仓: 'Guangzhou Route',
  不需要检品: 'No options required',
  附加项验证: 'Please select a commodity option',
  一键配置店铺配置商品附加项: 'Use configured merchandise options',
  一键配置店铺配置发货附加项: 'Use configured shipping options',
  客户SKU: 'Customer SKU',
  平台SKU: 'THE CKB SKU',
  复制成功: 'Copy Complete',
  'Amazon 库存': 'Amaozon Stock',
  'Amazon 商品名称': 'Amazon Product Name',
  不可用: 'Not for sale',
  关联商品信息: 'Supplier',
  仅良品数大于0的可创建国际发货单: 'If the number of good items is less than 1, international shipping request cannot be created.',
  最终采购价: 'Final Purchase Price',
  '无法按拼团价进行采购，需按原价进行采购': 'Purchase conditions have not been reached within the joint purchase buying period, you must purchase the item at the regular purchase price',
  '我们会尽可能按拼团价为您购买，如无法按照拼团价购买，将会按照原价进行购买': 'If you have not reached the specified conditions for the joint purchase price, you will purchase the product at the regular product price',
  '剩余XX天hh:mm:ss自动扣款': 'XX days until automatic withdrawal hh:mm:ss',
  我的账单: 'Payment Request Form',
  待支付总额: 'Amount Not Paid',
  账单名称: 'Transaction Details',
  待支付: 'Pending Payment',
  扣款说明: 'Details',
  应付总额: 'Total Amount Paid',
  钱包金额: 'Wallet amount',
  主账户账单: 'Master account Payment Request Form',
  子账户账号: 'Store Payment Request Form',
  编辑组合商品: 'Create Set Pair Item',
  请选择订单: 'Order not selected. Please select an order.',
  选择的订单国家不一致: 'The selected order country is different.',
  统一编辑发货附加项: 'Bulk Setup Shipping Options',
  '成功扣款的情况下，就会发货。': 'If the deduction is successful, the goods will be delivered.',
  '因余额不足无法扣款的情况下，会停止发货作业，并发送另行付款的通知。': 'If the payment cannot be deducted due to insufficient balance, the delivery operation will be stopped and a notice of separate payment will be sent.',
  '一旦确认到款，就会发货。': 'Once the payment is confirmed, it will be shipped.',
  '为了不影响发货，在发货前，请确保账户中有足够的余额。': 'In order not to affect the delivery, please ensure that there is sufficient balance in the account before delivery.',
  '点击【确定】按钮，系统将自动从余额扣除当前账单<br />应付总额XX元，确定支付吗': 'Click the [OK] button, and the system will automatically deduct the current bill <br /> the total amount payable is XX CNY from the balance. are you sure to pay',
  请输入拒绝原因: 'Enter the reason for refusal',
  请选择清关地址: 'Not selected. Please set up an IMPORTER address.',
  请选择收货地址: 'Not set. Please set your receiving address.',
  按原价采购: 'Purchase at the regular purchase price',
  拼团价: 'Joint Purchase Price',
  拼多多: 'Pinduoduo',
  '商品采购的最终价格，部分渠道如拼多多存在拼团失败需要按原价购买的情况': 'If you do not reach the specified conditions for the final purchase unit price Pinduoduo, you may purchase at the regular unit price instead of the joint purchase price',
  最终采购价详情: 'Details',
  取消类型: 'Cancellation Type',
  客户取消: "Cancel for Customer's Reason",
  系统取消: 'Cancel for convenience of THE CKB',
  提交并下载: 'DOWNLOAD',
  请求对象姓名: 'Customer Name',
  请求金额: 'Transfer Amount',
  点击下载: 'Click to Download',
  请求书下载: 'Deposit Transfer Application Form',
  请确认优先发货信息: 'Shipping Information Details',
  '余额扣费汇率全部以：XX円 = 1元，进行换算，请确认后再进行支付': 'The exchange rate will be calculated as "XX $ = 1 CNY"',
  编辑裁剪图片: 'Image Size Change',
  名称: 'Box number',
  实际重量: 'Actual weight',
  体积重: 'Volume weight',
  长: 'Height',
  宽: 'Width',
  高: 'Height',
  箱子: 'Cardboard box',
  编辑剪切区域和移动图片: 'Resize. Move Image.',
  适合正方形logo: 'Logs suitable for square designs',
  适合长方形logo: 'Logs suitable for rectangular design',
  '目前该运输方式暂时无法显示物流状态，烦请自主到物流公司网址进行查询': 'We are unable to indicate the status of the relevant logistics company, so please check the tracking URL below.\n Tracking URL:',
  '跟踪URL:': 'Tracking URL:',
  请以PDF格式上传各商品标签: 'Please upload each product label in PDF format',
  '详细步骤请参考这里。': 'Detailed steps please refer to here.',
  '上传的数据和追加的商品SKU不同，请确认后再上传。': 'The uploaded data is different from the additional SKU. Please confirm before uploading.',
  商品SKU上传设置: 'Product SKU upload settings',
  所有商品一个文件上传: 'Upload all SKUs at once',
  一个商品一个文件上传: 'Upload one file per SKU',
  请上传SKU文件: 'Upload file',
  '资料是需要事先准备的东西，没有库存的话无法为您处理。在没有库存的情况下，请先提交OEM估价委托。': 'Information is something that needs to be prepared in advance and cannot be processed for you without stock. In case of no stock, please submit OEM valuation commission first.',
  '指定搜索的网站→输入日语关键词→跳转至指定网站搜索商品': 'Specify the search website → Enter Japanese keywords → Jump to the specified website to search for goods',
  '更简单，更透明': 'Easier More Transparent',
  KAERU插件: 'KAERU Plug-in',
  插件下载: 'Add to Extensions',
  '更便捷地搜索&下单中国商品': 'Easier Search & Order Chinese Goods',
  立即安装: 'Install Now!',
  站内搜索: 'Internal Search',
  外部搜索: 'External Search',
  '在X系统中追加购买商品的购物车，正在选择中的系统是否符合顾客的意向，请再次确认': "Add the shopping cart to the X system. Please confirm whether the system being selected meets the customer's intention.",
  d2cb2b系统介绍: 'd2cb2b system introduction',
  'D2C系统:支持从单点直接传输到最终用户的业务': 'D2C system: support business from a single point of direct transmission to the end user',
  'B2B系统:支持保留库存并将其交付到国内EC相关仓库和内部仓库': 'B2B system: Support to retain inventory and deliver it to domestic EC related warehouse and internal warehouse',
  '通过单击Top菜单右侧的B2B/D2C图标可以切换系统': 'You can switch systems by clicking the B2B/D2C icon to the right of the Top menu',
  'D2C系统是小批量交付前提。1配送单位的商品价格在X元 (约Y日元) 以上时，请使用B2B系统。': 'The D2C system is a prerequisite for small batch delivery. 1 When the price of goods in the distribution unit is X CNY (about Y $) or more, please use the B2B system.',
  会员条约: 'Membership Agreement',
  使用条约: 'Use Of Treaties',
  会社情報: 'About Us',
  隐私权政策: 'Privacy Policy',
  解除: 'Resolve',
  商品类目: 'Category',
  操作取消: 'Cancel Operation',
  仅限输入英文字符: 'Please enter only alphabetic characters.',
  仅限输入英文和数字字符: 'Please enter alphanumeric characters only',
  无效的邮编: 'Please enter a valid zip code',
  国际物流配置id不能为空: 'There are fields that have not been entered. Please enter both carrier and weight before calculation.',
  '输入的支店名格式不正确，请设置1-20位字符': 'Branch name input error. Please enter branch name within 1~20 characters.',
  销售额取值范围: 'Order Period',
  返现类型: 'Reduction Method',
  返现: 'Reduction amount',
  返现2: 'Reduction amount',
  返点: 'Reduction rate',
  销售额区间: 'Total Order Amount Band',
  '销售额X%': 'X% of total order amount',
  为期: 'Calculation Period',
  X个月: 'X months',
  返现发放时间: 'Time of Cash Grant',
  每月X日自动返: 'Automatically granted on X day of every month',
  每季度自动返: 'Automatically granted every quarter',
  每半年自动返: 'Semi-annually (automatically)',
  充值记录: 'Charge History',
  处理结果: 'Response Status',
  取消发货任务记录: 'Shipping Cancellation History',
  取消采购记录: 'Purchase Cancellation History',
  订单是否结算: 'Liquidation Status',
  未结算: 'Unliquidated',
  待完善: 'To be completed',
  结算中: 'Liquidating',
  已结算: 'Liquidation Completed',
  结算失败: 'Failed to clear',
  发货取消结果: 'Delivery Cancellation Status',
  查看异常联络处理记录: 'Go to Processing History',
  结算时应退款金额: 'Refund Amount',
  '商品代金，订单结算后解冻至账户余额': 'After the order has been cleared, the (tentative) product price and product option fees for the cancelled items will be refunded to your system balance.',
  取消原因: 'Reason for Cancellation',
  '客户申请 (已取消发货)': 'Customer Request (Shipment Cancelled)',
  '客户申请 (已取消发货，成为库存)': 'Customer application (canceled shipment, inventory)',
  颜色尺寸未知: 'Color size unknown',
  异常订单处理记录: 'Exception Order Processing Record',
  客户申请: 'Customer Application',
  预约销售: 'Sales by appointment',
  有最小订单批次: 'With minimum order batch',
  '次品(即使达自动重拍次数上限，可发货的良品库存也不足)': 'Substandard products (even if the maximum number of automatic retakes is reached, the inventory of good products that can be shipped is insufficient)',
  '不良品 (在不良品对应设定中指定“退货退款”)': 'Deficiencies (specify "return refund" in the corresponding setting of defective products)',
  '缺货(即使达自动重拍次数上限，可发货的良品库存也不足)': 'Out of stock (even if the maximum number of automatic retakes is reached, the inventory of good products that can be shipped is insufficient)',
  全网断货: 'Out of stock at specified URL<br/>Cancellation recommended.',
  ' 缺货重拍完了': 'Out of stock remake finished',
  查看处理详情: 'Go to confirmation of response details',
  主账号: 'Primary Account No.',
  子账号: 'Sub-account',
  '如果您想使用资料以外的OEM服务(服装、杂货等)，请先将会员升级为商务舱。': 'If you want to use OEM services other than materials (clothing, groceries, etc.), please upgrade your membership to Business Class first.',
  '除了资料之外，OEM产品的开发流程比资料更长更复杂。': 'In addition to data, the development process for OEM products is longer and more complex than data.',
  '升级到商务舱以上，拥有丰富OEM经验的专业人员可为您提供更细致、更高效的服务，如果您对此感兴趣，请与我们联系。': 'Upgrade to business class or above, professionals with rich OEM experience can provide you with more detailed and efficient services. If you are interested in this, please contact us.',
  模板效果预览: 'View Template',
  检品标准: 'Inspection Standard List',
  取消尺码变更: 'Cancel',
  '填写尺码 如：Ｆ，XS，S，M，2XL等': 'Enter the size after the change. Example：Ｆ，XS，S，M，2X',
  月销售额区间: 'Monthly Sales Range',
  活动有效期: 'Activity Validity Period',
  次品退货退款并付费重拍: 'Exchange Response',
  '以后的商品为次品时，请都默认处理为次品退货退款并付费重拍。': "Defective product handling settings:<br/>If a defective product occurs after that, we will deal with it using the method of \"returning the defective product and refunding it, or reordering it with fee.''",
  '因原商品质量不佳，我们为您重拍时自动寻找了以下新链接，但新链接价格不符合您的预期，请您确认': 'Specified shop URL. High defective product rate<br/>There is no possibility of improving the defective product even if it is replaced (due to lot production)<br/>Similar products can be purchased at alternative shops<br/>→Because the purchase price limit has been exceeded , please check the availability<br/>Alternative shop URL: <a href="H" target="_blank">H</a><br/>Unit price: X CNY',
  '因原商品质量不佳，我们为您自动寻找了以下新链接，请您确认是否需要再新链接下重拍': 'Specified shop URL. High defective product rate<br/>There is no possibility of improving the defective product even if it is replaced (due to lot production)<br/>Similar products can be purchased at alternative shops<br/>Alternative shop URL: <a href= "H" target="_blank">H</a><br/>Unit price: X CNY',
  '以后的商品为次品时，请都默认处理为原商品退货退款并取消商品采购。': 'Defective Product Response Setup:<br/>All future cases of defective products will be handled under the "return defective product for refund or cancellation of purchase" method.',
  确认尺码: 'Not available in specified sizes<br/>Please double check your purchase size.',
  确认颜色: 'Not available in specified colors<br/>Please double check your purchase color.',
  确认款式: 'Not available in specified designs<br/>Please double check your purchase design.',
  '原商品缺货-推荐同款-价格不符合客户预期': 'Out of stock at specified URL. Alternative store available for purchase<br/>→Please check the availability of the alternative store URL because the purchase unit price limit has been exceeded<br/>Alternative store URL：<a href="H" target="_blank">H</a><br/>Unit price: X CNY',
  '原商品缺货-推荐类似款': 'Out of stock at specified URL. Alternative store available for purchase<br/>Alternative store URL：<a href="H" target="_blank">H</a><br/>Unit price: X CNY',
  '预售商品-推荐同款商品': "The item in question is a pre-order and is scheduled to ship in X days<br/>Alternative stores available for immediate shipment<br/>Alternative store URL: <ahref='H' target='_blank'>H</a>",
  '预售商品-无同款商品推荐': 'The item in question is a pre-order and is scheduled to ship in X days.',
  '不满足最小起量-推荐同款商品': "Minimum order lot has not been met<br/>Minimum lot: X Number of orders: Y <br/>※There are alternative stores where you can purchase the specified order quantity<br/>Alternative Shop URL:<ahref='H' target='_blank'>H</a>",
  '不满足最小起量-无同款商品推荐': 'Minimum order lot has not been met<br/>Minimum lot: X Number of orders: Y',
  '更换同款链接-价格不符合客户预期': 'Specified store URL. High defective rate<br/>There is no possibility of improving the defective product even if it is replaced<br/>Alternative store recommended for purchase<br/>Alternative Shop URL：<a href="H" target="_blank">H</a>',
  颜色差异: 'Color difference in products<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  logo差异: 'Logo is different<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delivery delay',
  '材质、面料差异': 'Different fabric<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delivery delay',
  配件差异: 'Different accessories<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delivery delay',
  商品上有中文: 'Chinese language<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problematic products, large possibility of delay in delivery',
  尺码差异: 'Wrong size<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delivery delay',
  设计差异: 'Different design<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delivery delay',
  '不良原因:其他\n根据检查标准，判断为不良品。\n出现不良品时请指定对应措施。': 'Bad reasons: other\nAccording to the inspection standard, it is judged as defective product.\nPlease specify the corresponding measures when defective products appear.',
  '不良原因:有污渍水渍\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reason: there are stains and water stains\nAccording to the inspection standard, it is judged as defective product.\nPlease specify corresponding measures when defective products occur.',
  '不良原因:损坏\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reason: damage\nAccording to the inspection standard, it is judged as defective product.\nPlease specify corresponding measures when defective products occur.',
  '不良原因:有线头、脱线\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reasons: wired head, off-line\nAccording to the inspection standard, it is judged as defective product.\nPlease specify corresponding measures when defective products occur.',
  '不良原因:接缝不良\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reason: bad seams\nAccording to the inspection standard, it is judged as defective product.\nPlease specify corresponding measures when defective products occur.',
  '不良原因:有导线\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reason: there is a wire\nAccording to the inspection standard, it is judged as defective product.\nPlease specify corresponding measures when defective products occur.',
  '不良原因:有针孔\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reason: pinhole\nAccording to the inspection standard, it is judged as defective product.\nPlease specify corresponding measures when defective products occur.',
  '不良原因:发霉\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reasons: moldy\nAccording to the inspection standard, it is judged as defective product.\nPlease specify corresponding measures when defective products occur.',
  '不良原因:有锈\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reason: rust\nAccording to the inspection standard, it is judged as defective product.\nPlease specify corresponding measures when defective products occur.',
  '不良原因:中文表示\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reasons: Chinese said\nAccording to the inspection standard, it is judged as defective product.\nPlease specify corresponding measures when defective products occur.',
  '不良原因:纽扣损坏\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reason: button damage\nAccording to the inspection standard, it is judged as defective product.\nPlease specify corresponding measures when defective products occur.',
  '不良原因:拉链有破损\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reason: zipper is damaged\nAccording to the inspection standard, it is judged as defective product.\nPlease specify the corresponding measures in case of defective products.',
  '不良原因:附件缺陷\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reason: attachment defect\nAccording to the inspection standard, it is judged as defective product.\nPlease specify corresponding measures when defective products occur.',
  '不良原因:有气味\n根据检查标准，判断为不良品。\n发生不良品时请指定对应措施。': 'Bad reason: smell\nAccording to the inspection standard, it is judged as defective product.\nPlease specify corresponding measures when defective products occur.',
  '原URL缺货，新的URL内商品是X元，请确认': "Out of stock at specified URL.　Alternative store purchase available<br/>→Please check the availability of the item because the purchase unit price limit has been exceeded<br/>Alternative Shop URL:<ahref='H' target='_blank'> H</a><br/> Unit price: X CNY",
  请在我指定的新链接购买: 'Purchase request at the following store<br/>URL :',
  取消商品采购: 'Cancel purchase',
  '取消商品采购+商品发送': 'Cancel purchase and shipping to end-user',
  请在我指定的新链接下采购: 'Purchase request at the following shop<br/>URL:',
  '请在THE CKB为我推荐的此链接下采购': 'Purchase at alternative store URL',
  '可以等待，请继续在原链接采购': 'Purchase at designated store URL<br/>→Allowable shipping wait time',
  '我接受起订量，请继续在原链接采购': 'I accept the minimum order quantity, please continue to purchase at the original link.',
  '我接受起订量，请继续在原链接采购（多采部分商品无异常上架后将作为库存在THE CKB仓库代为保管，并可匹配其他直发订单发出）': 'Change the order quantity to the minimum lot number and purchase at the original shop<br/>(The remaining inventory will be temporarily stored at THE CKB warehouse and will be used for the new order)<br/>→Allow minimum lot quantity',
  '问题不大，我能接受，请当成良品入库': 'The above product problem is acceptable and entered as a good product.',
  '此问题我不能接受，请依然当成不良品处理': 'Returned and refunded as defective product due to unacceptable color difference, and purchase was cancelled.',
  '我有可能有货的采购链接，请在这个链接再尝试购买': 'Wish to buy at the following shop<br/>URL:',
  '我等不及，请在我指定的新链接下采购': 'Wish to buy at the following shop<br/>→Waiting time for shipping is unacceptable<br/>URL:',
  '我等不及，请在THE CKB为我推荐的此链接下采购': 'Purchase at alternative store URL<br/>→Waiting time for shipping is unacceptable',
  '我不接受起订量，请在我指定的新链接下采购': 'Wish to buy at the following shop<br/>→Minimum lot size not acceptable<br/>URL:',
  '我不接受起订量，请在THE CKB为我推荐的此链接下采购': 'Purchase at alternative store URL<br/>→Minimum lot size not acceptable',
  'THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购': 'Wish to buy at the following shop<br/>→Alternate store URL price unacceptable<br/>URL:',
  '此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买': 'The above product problem is unacceptable and will be returned for a refund as defective. Wish to purchase from the following store.',
  我还是要继续在原链接采购: 'Purchase at specified store URL<br/>→Allow defective rate',
  取消商品重拍: 'Cancel Repurchase',
  '取消商品重拍+商品发送': 'Cancel re-purchase and end-user shipment',
  次品退货退款并取消商品采购: 'Return defective product for refund and cancel purchase',
  '次品退货退款并取消商品采购+商品发送': 'Return defective product for refund, cancel purchase and end-user shipment',
  确定后将按照新的货代进行发货: 'Press the "Confirm" button to ship with the changed carrier. <br/>Is that OK with you?',
  '确定后将取消您的国际发货单，您需重新创建': 'If you execute "Cancel", the relevant international shipping request will be canceled and you will need to create the international shipping request again. <br/>Do you wish to execute the cancellation?',
  关闭后将不再向您店铺同步物流单号及订单状态: 'Turning off the automatic tracking number reflection will stop the automatic reflection of the international tracking number and shipment status on our website<br/>Do you want to cancel the automatic reflection of the tracking number?',
  关闭提醒: 'Please confirm.',
  批量搜索: 'Batch Search',
  '每行输入一个，按Enter键换行': 'Enter one per line and press Enter to wrap the line',
  可以直接粘贴Excel数据: 'Can paste Excel data directly',
  '※最多可同时搜索100个': '※ can search up to 100 simultaneously',
  双击批量搜索: 'Double-click to Batch Search',
  选择类似款: 'Alternative Store Purchase',
  '此问题我不能接受，请依然当成不良品处理，并取消商品采购': 'Cancellation of purchase and return for refund of defective product due to unacceptable product problems described above.',
  '此问题我不能接受，请依然当成不良品处理，并取消商品采购+商品发送': 'Cancellation of purchase and shipment to end-user due to unacceptable product problems as defective and return for refund.',
  后台导入: 'Migrated Data',
  确认重拍: 'Replacement',
  '使用高强度耐用的瓦楞纸箱进行国际运输，质量好，库存充足': 'Use high-strength and durable corrugated boxes for international transportation, with good quality and sufficient inventory',
  '$THE CKB发货袋说明$': 'Use high-strength, durable shipping bags for international shipments, high quality and well-stocked.',
  $厂家原箱说明$: 'May be damaged, may not be suitable for international shipping strength, risk of affecting shipping speed.',
  纸箱类附加项必须选择一种: 'You must select one of the cardboard boxes of your choice from the list below.',
  发货袋附加项必须选择一种: 'You must select one of the following shipping bags of your choice.',
  如想变更为商务舱以上: 'If you want to change to business class or above',
  和日本工作人员在Line上商量: 'I want to change to more than business.\nTalk with our Japanese staff on Line.',
  取消发货: 'Cancel shipment',
  '同意一个包裹无法装下商品时，THE CKB将为您拆成多个包裹进行发货': 'If the weight of one package exceeds the small-lot import regulations, <br />we will split your order and ship it separately.',
  '由于该订单商品无法在一个包裹中装下，我们为您拆成了多个包裹进行发货': 'Due to the weight of one package exceeding the small-lot import regulations, we have divided your order and shipped it separately',
  拆: 'Automatic partial delivery',
  优: 'Partial delivery',
  下单提醒: 'Please note',
  下次不再提醒: 'Do not show next time',
  人气购物网站: 'Popular shopping sites',
  '发现海量中国商品，助您更简单，更透明地下单购物！': 'Find more hot sell products and make your China stocking easier!',
  使用tips: 'How to use',
  '1.指定采购来源': '1. Specify the search destination supplier.',
  '2.选择商品类目或输入关键字': 'Enter Japanese keywords and select a category.',
  '3.即可前往指定采购来源站点搜索相关商品': "3. Search for products on the specified supplier's website.",
  '抱歉，订单正在打包中，不允许修改地址': 'Shipping address cannot be changed because the order is already packed.',
  联系我们: 'Contact Us',
  失效: 'Expired',
  '很抱歉！您的店铺（X）因token失效需重新绑定，如需帮助请联系客服': 'API linkage expired (X) Please cancel the linkage and re-link.',
  所选日期区间长度不可超过X天: 'You can only select dates within X days including the start date.',
  能够在中国找到丰富的供应商: 'Abundant China purchasing routes can be developed!',
  '按照日本质量标准进行检验（隶属于日本公司）': 'Inspection available with Japanese quality standards (affiliated with a Japanese company).',
  '最低国际运费保证，可运往23个国家/地区': 'Lowest international shipping rates in the industry, shipping to 23 countries and regions',
  可靠的支持和即时的客户服务: 'Immediate customer service and support',
  会员中心: 'Member Center',
  我的会员: 'My Plan',
  最低: 'Lowest price',
  会员规则变更通知: 'Notice of Revision of Membership Plans',
  '尊敬的用户，THE CKB团队经过谨慎考虑，为了更好的为用户提供服务，决定在经历了一段时间的免费运营后，于2023/1/11开始只对付费会员提供服务。': 'Thank you very much for using THE CKB.<br/>To improve the quality of our system and to provide a service that satisfies our customers, <br/> THE CKB has decided to change the "0 yen membership plan" to a fee-based plan as follows.<br/>We apologize for the sudden change and appreciate your understanding.<br/><br/>Date of Change: <span style=\'color: #eb4545\'>2023/1/11</span><br/>Details of the change: <span style=\'color: #eb4545\'>Economy Plan 0 yen → 1980 yen/month</span><br/>※Automatic update to the paid Economy Plan (Term of Validityvalid：<span style="color:#eb4545">until 2023/01/31</span>）',
  '您也不用担心，您是陪伴我们成长的首批用户，我们已为您自动升级到新会员，并且免费送您会员到1月31日（原价1980日元/月)！赶快去试用体验吧！': 'The following is a list of the major changes that will accompany the change to fee-based plans, as well as items for which we ask for your cooperation.<br/>＜Changes to the service＞<br/>★Economy Plan: 5% purchase commission (5%) -> Free of charge★<br/>★Free membership fee during January 2023 & Free membership fee for another 30 days with Line friend registration★<br/><br/>＜Changes in the system functions＞※More will be added in the future.<br/>★Launch of cell phone application service ★ March 2023<br/>Addition of new system partners (Yahoo! Shop, Mercari, Stores, etc.) ★ 2023<br/>Addition of new Chinese buying routes ★ 2023',
  '到期后会员将失效，将无法享受下单服务，欢迎随时充值新会员。': '＜Matters for which we need your cooperation＞<br/>After the free period of the new Economy Plan, Please select the plan after the change by yourself<br/>※ If you do not select the new plan, you will not be able to use the system. Please be aware of this.',
  新会员权益介绍: '>Click here for details ',
  开通新会员: 'Change to New Membership Plans',
  查看新会员: 'New Member Plans List',
  '开通会员，立享下单代买服务。请联系主账号开通。': 'New member registration is available for China purchasing! ※Please register from your Master account.',
  '开通会员，立享下单代买服务': 'New members can purchase from China!',
  '开通会员，即可享受下单代买服务。': 'New members can purchase from China!',
  '请联系主账号开通。': '※Please register from your Master account.',
  '即可享受下单代买服务。': 'You can enjoy the order purchase service.',
  '有效期：': 'Membership expiration date:',
  已失去会員: 'Membership inactive',
  未登録: 'Not Registered',
  未登录: 'Logged Out Status',
  '会员等级变更！': 'Notification of Membership Plan Change Completion',
  您当前的会员等级已变更为V: 'Your plan has been changed to V.',
  立即享用会员: 'Go to System TOP',
  '您的会员已到期！': 'Notice of Membership Expiration',
  '您当前的会员已到期，为了不影响正常下单和使用，请及时开通哦！（不影响历史订单集账户余额充值）': 'The membership plan you have selected has expired. We recommend that you recharge your membership fee as soon as possible.',
  查看会员: 'Membership Plan List',
  'THE CKB会员，为您的买卖生活提供一切所需。': 'Makes China Purchasing Easier!',
  入会优享超多服务: 'Registration for membership allows you to take advantage of a variety of services that make importing from China easier!',
  开通会员: 'Join Now',
  有效期至: 'Expiration Date of Membership',
  自动续费已开启: 'Automatic payment of membership fee: ON',
  自动续费已关闭: 'Automatic payment of membership fee: OFF',
  成为: 'Change to',
  去续费: 'Extend membership',
  当前自动续费不可开启: 'Unable to set up automatic payment of membership fee',
  '您在持有预充会员【XX】期间，暂不可开启自动续费。在该预充会员正式开启后，我们会自动为您开启会员的自动续费，敬请谅解。': '【XX】Automatic membership fee deduction cannot be set up because a plan change has already been reserved<br/>Automatic membership fee deduction will be automatically turned on when the relevant plan is activated.',
  知道了: 'Close',
  '请及时关闭PayPal账户内不需要的自动续费，如未关闭，我们会将这笔钱充值到您的余额，可能需要您承担部分手续费。': '※If you already set up automatic Paypal payment and wish to renew your membership plan, please cancel the previous automatic Paypal payment.<br/>If you do not cancel the automatic Paypal payment, the fee will be charged automatically.<br/>Please note that you will be responsible for the refund handling fee for the incorrect cost charge.',
  关闭PayPal自动续费教程: 'Go to Automatic Payment Cancellation Manual',
  关闭paypal自动续费教程: 'Manual for canceling automatic payment',
  续费提示: 'Notice of Membership Extension',
  '续费后，会在XX开始自动延长YY时间': 'Upon completion of payment, the membership expiration date of YY for the selected plan will be extended from XX.',
  '检测到您当前有T1至T2的预充会员，续费成功后，会取消原来预充的会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>。': 'Since the customer has already reserved the [V] plan (validity period: T1-T2) change, please do not renew the plan.<br/>In the event of plan renewal, the reserved [V] plan will become invalid<span style="color:#EB4545;"> and the pre-paid fee will not be refundable.</span>。',
  升舱提示: 'Notice Regarding Membership Plan Upgrade',
  '您当前为V1，想开通V2，您想选择何时生效？开通成功后，选择将不可更改':
    // 'Current plan is V1; to change to V2, activate V2 now <br/> activate V2 after the expiration of ORV1.',
    'Current plan is V1; to change to V2, you need to activate V2 now or you can activate V2 after the expiration of V1.',
  '检测到您当前有T1至T2的预充会员，降仓成功后，会取消预充会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>。': 'Since the customer has already reserved the [V1] plan (validity period: T1-T2) change, please do not renew the plan.<br/>In the event of plan renewal, the reserved [V1] plan will become invalid<span style="color:#EB4545;"> and the pre-paid fee will not be refundable.</span>。',
  降舱提示: 'Notice Regarding Membership Plan Down',
  '续费后，会在T开始自动延长V时间': 'Upon completion of payment, the membership V end date of the selected plan will be extended from T',
  '您当前为V1，想开通V2，为保障您当前的会员权益，会等原会员套餐到期（TT）后开始实行降仓会员，是否要进行降仓？':
    // 'The current plan is V1; to change to V2, activate V2 after the expiration date of V1.',
    'Your current membership level is V1. If you want to activate V2, in order to protect your current membership rights, the membership level will be reduced after the original membership package expires (TT). Are you sure you want to proceed with the reduction?',
  '检测到您当前有2段会员，升舱成功后，会取消当前会员和预充会员，钱款不予退还。': 'It is detected that you currently have 2 members. After the upgrade is successful, the current members and pre-charged members will be canceled and the money will not be refunded.',
  '检测到您当前有2段会员，升舱成功后，会取消当前会员和预充会员，<span style="color:#EB4545;">钱款不予退还</span>。': 'If you change your membership plan, your [V1] and [V2] memberships will become invalid.<span style="color:#EB4545;">Please note that membership fees are non-refundable.',
  '检测到您当前有T1至T2的预充会员，升舱成功后，会取消预充会员，预充会员的钱款不予退还': 'It is detected that you currently have pre-charged members from T1 to T2. After the upgrade is successful, the pre-charged members will be canceled and the money of the pre-charged members will not be refunded.',
  '检测到您当前有T1至T2的预充会员，升舱成功后，会取消预充会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>': 'Since the customer has already reserved the [V] plan (validity period: T1-T2) change, please do not renew the plan.<br/>In the event of plan renewal, the reserved [V] plan will become invalid<span style="color:#EB4545;"> and the pre-paid fee will not be refundable.</span>。',
  立即生效: 'Activate Now',
  '{time}开始生效': 'Activate from {time}',
  定时升舱: 'Reservation for Plan Upgrade',
  利用期间: 'Number of months applied',
  '%割引': '% Discount',
  '%off': '%off',
  '折合X円/月': 'After discount price X $/month',
  已成功开通预充会员: 'Payment of membership fee completed',
  已成功开通会员: 'Payment of membership fee completed',
  '已为您开启预充会员V，有效期为Y': 'V membership fee payment has been completed. Valid period: Y',
  '已为您开启V，有效期为Y': 'V membership fee payment has been completed. Expiration date: Y',
  '为了不影响您的后续使用，请保持PayPal内开启自动续费。': "We recommend you to set up automatic payment by PayPal, if you haven't done so yet!",
  '已优惠:X': 'X $ OFF',
  已优惠: 'X$OFF',
  确认协议并立即支付: 'Agree to the terms and go to payment',
  会员服务协议: 'Membership Terms and Conditions',
  自动续费服务规则: 'Auto Payment Terms',
  高级会员专享服务: 'Contact us on Skype',
  '如需开通商务舱或头等舱会员，请先用line扫描右侧二维码联系我们，获取专属咨询服务。': '※For users of Standard Class membership and above. Scan the QR code below for consultation.',
  恭喜成功开通: 'Thank you for using the',
  '为了更好地帮您履行下单履约，您需要提前填写以下信息。': 'In order to ensure smooth correspondence regarding your order, please take care of the following store settings in advance.',
  添加店铺: 'Add a store',
  采购设置: 'Purchase setting',
  国际配送设置: 'International shipping settings',
  暂不设置: 'Do not set up now ',
  保存设置: 'Save',
  请填写完成国际配送设置: 'Please set up your international shipping preferences',
  请填写完成采购设置: 'Please set up your purchasing preferences',
  请填写完成店铺信息: 'Enter your store information',
  去开通: 'Submit',
  是否要关闭自动续费: 'Please confirm',
  '关闭自动续费后，您的V将于T到期。关闭后会影响您后续的正常使用，请谨慎关闭。是否现在关闭？': 'Canceling automatic payment of membership fees will terminate your current Plan V membership.',
  '为了能正常关闭自动续费，请务必前往paypal关闭自动续费。': '※If you have set up automatic payment of membership fee by Paypal, please cancel the setting of automatic payment by Paypal when you change your membership plan.<br/>If you do not cancel the setting, the fee will be automatically charged.<br/>Please note that you will be responsible for the refund fee for the incorrect cost charge.',
  '已为您开启V自动续费，记得保持余额充足。': 'If you have set up automatic withdrawal from your account: <br/>Please make sure that you have sufficient balance in your account, because if automatic payment fails due to insufficient balance, you will not be able to place an order.',
  '为了能正常打开自动续费，请务必前往PayPal开启自动续费。': 'If you choose PayPal automatic payment: <br/> Please set up automatic payment on the official paypal website.',
  支付金额: 'Total Amount',
  '支付金额(円)': 'Total Amount($)',
  '尊敬的用户，您需办理会员后，方可下单，请联系主账号办理': 'To use the ordering function, you must first register as a member.<br/><b>Please register as a member from your Master account.</b>',
  办理会员: 'Go to Member Registration',
  '尊敬的用户，您于T变更为非会员用户，我们已发站内信告知您：开启自动同步下单功能及按钮已关闭（变为非会员后，不影响历史订单及账户余额提现）': 'Due to the suspension of membership from T, the automatic order placement function of the API has been temporarily suspended (please be assured that orders and balance withdrawals already handled will not be affected).<br/>Please check the message in the system for details.',
  '尊敬的用户，您需办理会员成功后，方可同订单数据': 'To use the order entry function, you must first register as a member.',
  '尊敬的用户，您需办理会员成功后，方可开启自动同步下单，请联系主账号办理': 'To use the automatic order placement function, you must first register as a member. <br/><b>Please register from your Master account.</b>',
  '尊敬的用户，您需办理会员成功后，方可开启自动同步下单': 'To use the automatic order entry function, you must first register as a member.',
  '尊敬的用户，您于T变更为非会员用户，已授权的API被禁用，需办理会员成功后，方可同步订单数据，请联系主账号办理': 'API functionality for linked status is no longer available due to membership suspension by T. If you wish to continue using the service, you must first register as a member.<br/><b>Please register from your Master account.</b>',
  '尊敬的用户，您需办理会员后，方可授权绑定子店铺，请联系主账号办理': 'Dear users, you need to apply for membership before you can authorize the binding of sub-stores. Please contact the main account',
  '尊敬的用户，您需办理会员成功后，方可授权绑定子店铺': 'To use the API linking function, you must first register as a member.',
  授权店铺API绑定变更: 'Notice of API Linkage Status Change',
  '尊敬的用户，您于T变更为非会员用户，已授权店铺绑定的API变更为禁用状态（不影响历史订单及账户余额提现）': 'As your membership has been suspended by T, you will no longer be able to use API functions that are already linked (please be assured that orders and balance withdrawals that have already been handled will not be affected).',
  '已授权（禁用）': 'Linked (Unavailable)',
  '円/月': '$/month',
  '/月': '/month',
  '{currency}/月': '{currency}/month',
  绑定信用卡支付: 'Add Credit Card',
  你还没有绑定信用卡: 'There is no available card at this time',
  有効期限: 'Expiration Date',
  请选择信用卡: 'Please select a credit card',
  '是否删除信用卡？': 'Do you wish to delete this credit card information?',
  信用卡卡号: 'Credit Card No.',
  信用卡安全码: 'Security Code',
  仅限数字: 'Please enter only numbers',
  '仅限输入3-4位数字安全码': 'Only 3-4 digits allowed',
  '仅限数字，例：05/2022': 'Only numbers allowed：e.g. 05/2022',
  请检查卡信息是否有误: 'Please make sure your credit card information is correct',
  '支付失败，请重新操作！': 'Payment failed, please try again.',
  paypal信用卡: 'Credit Card',
  充值失败: 'Charge failed',
  请联系主账号更改: 'Please operate from Master account',
  已为您开启自动续费: 'Automatic payment of membership fees turned on',
  已失去会员: 'Membership inactive',
  未入会: 'No Member',
  设为默认支付方式: 'Set as default payment method',
  支付失败: 'Payment Failure Notification',
  '余额不足，请先充值余额后重试。': 'Insufficient account balance, please charge funds for monthly membership fee',
  每次询问我处理次品方式: 'Confirm with me when defective products appear',
  '尊敬的用户，您需办理会员后，方可下单': 'To use the order function, you must first register as a member.',
  会費: 'Membership fee',
  PayPal加载中: 'PayPal loading in progress',
  '余额不足，请先绑定店铺后充值，再重试': 'Insufficient account balance, please add a store and charge the funds and try again',
  '信用卡-由PayPal提供，支持Visa、MasterCard、AMEX、JCB等类型': 'You can use any credit card brand registered in your PayPal account, such as VISA, MasterCard, AMEX, JCB, etc.',
  次品处理: 'Non-Returnable Defective Product Response',
  处理时间: 'Correspondence Date and Time',
  '处理中(转正品)': 'Being handled (Received as good)',
  已转正品: 'Already received as good',
  所属订单编号: 'THE CKB Order No.',
  次品图片: 'Image',
  次品原因: 'Cause',
  次品数: 'Quantity',
  次品共: 'Non-returnable defective item:',
  '次品转正品后，产生的商品附加项费用，可在子钱包（费用流水）页面，使用订单编号查询费用记录，': 'You can also search by THE CKB order number.',
  '去查询>': 'Go to statement confirmation',
  批量作废: 'Discard in batch',
  批量转正品: 'Receive as good in batch',
  '您确定转正该批次的次品吗？': 'Would you like to warehouse the selected items as good items?',
  '次品转正后，平台将按正品处理相关业务流程，且不可再次打次，请慎重操作！': 'If the selected items are entered as good items, they will be handled as good items and cannot be judged as defective again. Do you want to receive the selected items as good items?',
  '您确定作废该批次的次品吗？': '【Please confirm 】',
  '次品作废后将不可转正品，不可退还，': 'If you request for disposal, it is considered that the ownership of the item is relinquished by the customer.',
  'THE CKB平台有权自行处理，且无任何经济纠纷，': 'In that case, the customer cannot request delivery of the item as a good again.',
  '请慎重操作！': 'Do you wish to dispose of the selected items?',
  '已申请转正品！<br />我们将尽快处理，转正品成功后将有站内信通知到您': 'As soon as we confirm the application to enter the item as a good, we will take immediate action. <br />We will notify you via a message in the system as soon as the operation is completed.',
  已作废成功: 'Request for disposal completed',
  作废: 'Discard',
  转正品: 'Receive as good',
  含次品转正品: 'Non-returnable defective items are already in the warehouse as good items.',
  '次品经您转为正品后，可视为正品下单，存在消费者不可接受的风险，请谨慎操作！平台不承担相关责任。': 'After receiving the defective items as good items, we will deliver them to end users as other good items. Please note that there is a possibility that the end-user may not accept it.',
  '查看转正记录>': 'Go to the correspondence history of Non-Returnable Defective Items',
  会员开通记录: 'Membership Fee Payment History',
  活动赠送: 'Free Trial',
  自动续费: 'Automatic Membership Payment',
  自动续费2: 'Automatic Membership Payment',
  开通失败: 'Payment Failed',
  开通成功: 'Already Paid',
  待生效: 'Waiting ineffective',
  会员套餐: 'Membership Rank',
  '支付价格（日元）': 'Price paid ($)',
  会员有效期: 'Membership Term of Validity',
  导出记录: 'Download',
  会员订单编号: 'Order No.',
  类型2: 'Type',
  '如果您现在更改会员计划，您当前的会员资格将失效。请注意，会员费不可退还。': 'If you change your membership plan now, your current membership will expire. Please note that membership fees are non-refundable.',
  '请重新选择商品附加项，您之前选择的附加项可能失效或价格发生变化': 'Product Option Not SelectedPlease select the product option again as the price of the product option selected at the time of order may have changed or become unavailable.',
  历史选择商品附加项: 'Product Option selected at the time of order',
  附加项总价: 'Total Amount (approximate)',
  开通会员2: 'Open member',
  状态2: 'Status',
  '请重新选择商品附加项，': 'Commodity Option Not Selected',
  您之前选择的附加项可能失效或价格发生变化: 'Please select the Product Option again, as the price of the Product Option you selected at the time of order may change or become unavailable.',
  请选择附加项后再提交: 'Merchandise Option Not Selected Please select the content and try again.',
  色差: 'Color difference',
  '污渍/斑点/水印': 'Stains, spots, water marks',
  破损: 'Damage',
  线头: 'Lint and fraying treatment',
  接缝不良: 'Stitches',
  抽丝: 'run',
  针眼: 'Needle holes',
  霉菌: 'Mold',
  生锈: 'Rust',
  商品有中文: 'Chinese Markings',
  纽扣破损: 'Damaged buttons',
  拉链破损: 'Damaged zipper',
  附属品缺陷: 'Accessories Defects',
  有气味: 'Smell',
  其他不良: 'Other',
  处理状态: 'Status',
  请输入订单编号: 'Enter THE CKB order number',
  银行卡便捷支付: 'Bank transfer (speed of reflection increased)',
  '线下汇款至我们指定的银行账户，点此查看': 'Transfer to our designated account',
  收款账户信息: 'View Designated Account Information',
  绑定您的支付行信息: 'Enter the source account information. <br/><span style="font-size:12px">※Please be careful not to enter incorrect information.</span>',
  提交支付信息: 'Enter the amount already transferred and submit.',
  绑定银行卡信息: 'Register the account from which the money transfer is to be made.',
  '系统确认中的状态是指银行到账通知时间存在差异，如超过3天状态未变更，请先联系当地银行确认打款是否成功，再联系客服处理': 'Deposit time varies depending on the financial institution. However, if you have not received your payment for more than 3 business days, please check with your bank first to see if the payment was successful, and then contact our online customer service.',
  银行名称2: 'Bank of our beneficiary',
  银行账号2: 'Bank Account No.',
  支店名2: 'Name of the branch from which the payment was made',
  支店号: 'Branch number from which payment was made',
  账户持有人: 'Account name from which payment was made',
  设为默认支付方式2: 'Set as default payment method',
  系统确认中: 'Payment is being confirmed',
  '系统确认中~预计1-3个工作日到账，后续可在充值记录查看资金入账情况！': 'System confirmation is in progress ~ it is expected to arrive within 1-3 working days. you can check the fund entry status in the recharge record later!',
  '复制收款银行信息，去线下银行转账至我们的收款银行': 'Amount specified to our designated account',
  '线下银行转账成功后，您可以在这里绑定您自己的银行卡信息': "After the transfer is completed, enter the customer's bank account information from which the transfer was made",
  '输入金额，点击“确定”按钮，提交支付信息': 'Enter the amount transferred and click the "Confirm" button',
  '请先确认线下汇款成功后再提交，否则审核会被拒绝': 'For bank transfers, the transfer procedure must be completed by the customer himself/herself to the bank account designated by us. <br/>Please confirm that the transfer has been completed before submitting your charge request.',
  '请输入1-20位银行名称': 'Please enter the name of the bank in 20 characters or less',
  请输入7位数字银行账号: 'Please enter 7-digit account number',
  '请输入1-20位支店名': 'Please enter your branch name in 20 characters or less',
  请输入3位支店号: 'Please enter a 3-digit branch number',
  '请输入1-20位账户持有人': 'Please enter the name of the person in whose name the account is held in 20 characters or less',
  不可代购: 'Purchase unavailable',
  '输入的密码格式不正确，请设置6-32个字符，字母和数字的组合，字母区分大小写': 'Incorrect password. Password must be 6~32 mixed alphanumeric characters (please note that alphabetic characters are case sensitive).',
  '是否修改密码？': 'Change password?',
  '系统检测到您当前的密码过于简单，存在安全风险，建议您修改密码。': 'Password change is required.Password is insecure, we recommend changing to a more complex password to prevent unauthorized access.',
  '注册或登录后，将为您推荐更多个性化内容。': 'Register new OR login to see content that fits your preferences',
  '注册或登录后，可查看更多相似商品': 'New Registration OR Login to view more similar products',
  删除成功: 'Successfully deleted',
  完成以下配置才可使用表格导入创建订单功能: 'If you are using Excel Batch Ordering, the following order-related settings must be addressed in advance.',
  默认商品附加项配置: 'Default Option Settings',
  默认发货附加项配置: 'Shipping Option Settings',
  默认国际物流配置: 'Shipping Company Settings',
  前往配置: 'Go to Settings',
  注意事项: 'matters needing attention',
  '1.表格数据最多为1000行，超过请分多个表格导入': '1. You can upload up to 1,000 lines at a time. If the number of rows exceeds this limit, please split the file into multiple Excel files.',
  '2.仅支持.xlsx、.xls文件，且小于20M': '2. Uploaded files must be in .xls or .xlsx format, with a maximum size of 20 MB per file.',
  '3.导入成功后，请前往「待付款」，进行付款后完成下单': '3. After uploading is complete, please make payment on the "Payment Waiting" screen of "Order Management" -> "All Orders".',
  订单创建中: 'Uploading in progress',
  下单失败提示: 'Upload is completed',
  本次导入成功X个订单: 'Number of uploads: X',
  失败X个订单: 'Number of failed uploads: X',
  失败订单请重新导入: 'Please download the failed upload orders below, modify them, and upload them again.',
  失败订单下载: 'Download Failed Upload Orders',
  我已知晓: 'I already know',
  下载: 'download',
  'THE CKB SKU': 'Straight ahead SKU',
  // 表格下单字段改不得
  order_客户订单号: 'Customer Order NO',
  order_直行便SKU: 'THE CKB SKU',
  order_数量: 'quantity',
  order_收件人姓名: 'recipient',
  order_联系电话: 'Phone number',
  order_都道府县: 'Province',
  order_市: 'city',
  order_详细地址: 'Address',
  order_邮编: 'recipient zip code',
  order_国家: 'nation',
  good_直行便SKU: 'THE CKB SKU',
  good_数量: 'Quantity',
  good_客户SKU: 'Your product SKU',
  '表格数据最多为1000行，请分多个表格导入': 'You may upload up to 1,000 rows once. If the number of items exceeds this limit, please do so in multiple Excel files.',
  '表格数据最多为200行，请分多个表格导入': 'You can upload up to 200 rows once. If the number of items exceeds this limit, please split the file into multiple Excel files.',
  客户订单号不能为空: 'Enter Customer Order No.',
  客户订单号最长为100个字符: 'Maximum length of customer order number is 100 characters.',
  商品SKU不能为空: 'Please enter THE CKB SKU',
  '请输入6~100个字符的商品SKU': 'THE CKB SKU must be between 6 and 100 characters',
  '第X行，同一个客户订单号SKU有且仅能有一行': 'X line, the same customer order number and THE CKB SKU already exists.',
  请输入7位数字的邮编: 'ZIP code must be 7 digits',
  表格导入创建订单: 'Excel Batch Order',
  表格导入中: 'Uploading',
  表格导入创建商品: 'Uploading Excel batch',
  批量付款: 'Batch Payment',
  客户订单号: 'Customer Order No.',
  '商品总额(¥)': 'Total merchandise (¥)',
  '附加项总额(¥)': 'Total additional items (¥)',
  '总计(¥)': 'Total (¥)',
  '单价(¥)': 'Unit price (¥)',
  '附加项金额(¥)': 'Additional Item Amount (¥)',
  '小计(¥)': 'Subtotal (¥)',
  确认订单信息: 'Confirm Order Details',
  商品创建中: 'Uploading',
  请勿上传空文件: 'Empty file cannot be uploaded. Please enter the contents and try again',
  请勾选订单: 'Please select your order',
  表格下单: 'Excel Batch Order',
  数量不能为空: 'Please enter quantity',
  请输入大于等于1的整数: 'Please enter a whole number greater than or equal to 1',
  收件人姓名不能为空2: 'Please enter a recipient name',
  '请输入1-50个字符的商品SKU': 'Recipient name must be between 1 and 50 characters',
  联系方式不能为空: 'Please enter a phone number',
  '请输入8-11字符的联系方式': 'Please enter a phone number between 8 and 11 digits',
  都道府县不能为空2: 'Please enter State/Province',
  '请输入1-50字符的都道府县': 'Please enter a state/province within 1~50 characters',
  '请输入1-50字符的市': 'City must be within 1~50 characters',
  都道府县与市不匹配: 'State and city do not match',
  详细地址不能为空2: 'Please enter a detailed address',
  邮编不能为空2: 'Please enter zip code',
  '请输入1-50个字符的收件人姓名': 'Recipient name must be between 1-50 characters',
  '相同订单下，收件人信息与第X行不一致': 'The order number is the same and the recipient information does not match the information on line X.',
  '订单创建成功，完成付款后下单成功': 'Upload completed, please go to "Order Management" -> "All Orders" -> "Waiting for Payment" screen to make your payment.',
  第X行: 'Line X',
  数据不完整: 'Input data is incomplete. Please check the contents and try again.',
  数量需为大于0的整数: 'Quantity must be an integer greater than or equal to 1',
  第X行SKU重复: 'Line X The same THE CKB SKU already exists.',
  上传失败请重试: 'Upload failed Please try again',
  客户订单号最长为32个字符: 'Customer order number has a maximum length of 32 characters',
  没有该都道府县: 'The corresponding prefecture does not exist',
  请上传文件: 'Please select a file',
  '文件大于20M,请重新上传': 'Uploaded files must be in .xls or .xlsx format, with a maximum size of 20 MB per file.',
  表格导入商品: 'Excel batch upload',
  '1.表格数据最多为200行，超过请分多个表格导入': '1. You may upload up to 200 lines at a time. If the number of rows exceeds this limit, please split the upload into multiple Excel files.',
  '请输入1-200字符的详细地址': 'Detailed address must be within 1~200 characters',
  删除成功2: 'Successfully deleted',
  '会员才可查看我的收藏、足迹、购买过内的商品哦': 'To view your favorite list, browsing history, and purchased products/stores, you must be a registered member.',
  会员登录: 'Upgrade my membership',
  '货物发出去之后不要在亚马逊后台再打开这个补货计划，避免调用api失败': 'To ensure smooth processing of your delivery plan, <br/>please do not re-open the delivery plan in Amazon Seller Central before the items have been shipped.',
  '订单读取中，预计需要1-3分钟，请稍后刷新页面查看读取结果': 'Order is being taken <br/>After 1-3 minutes, please refresh the page again to check the result.',
  处理详情: 'Response Details',
  文件大小不超过10M: 'The maximum file size that can be uploaded is 10 MB.',
  'PayPal加载中，请稍等': 'Please wait a moment while the PayPal payment page is loading.',
  由PayPal提供服务: 'Service provided by PayPal.',
  '请求超时，请稍后重试': 'The connection is currently unavailable, please try again in a few minutes.',
  '预计到账：X元': 'Estimated deposit amount: X CNY',
  '预计到账CNY：X元': 'Estimated deposit amount CNY: X CNY',
  '支付中，请稍等': 'Payment is being processed, please wait a moment.',
  '您填写的信息受到加密保护，请安心填写': 'The information you have entered is encrypted and protected, so please feel free to enter it!',
  再试一次: 'Reload',
  会员功能限定去升级: 'This operation requires Business Class or higher membership registration.',
  保留自动续费: 'Keep auto payment setting (ON)',
  关闭自动续费: 'Cancel automatic payment (OFF)',
  继续保留自动续费: 'Cancel (Auto Payment Setting ON)',
  提交并关闭自动续费: 'Submit Response (Auto Payment Setting OFF)',
  升级成商务舱及以上就可享用更多寻源服务: 'This operation requires Business Class or higher membership registration.',
  电话: 'Phone Number',
  充值撤回: 'Cancel Charge',
  请选择银行卡: 'Please select the bank account to which you would like to make a payment',
  费用合计: 'Total Cost',
  已失效: 'Out of URL',
  已失效_: 'Expired Authorizations',
  已失效1: 'Out of URL',
  已下架: 'Out of Stock',
  商品不存在: 'There are products that have already been removed.',
  '存在已失效商品，请调整商品': '【Please note】Please note that some items are out of stock and cannot be purchased',
  '存在已下架商品，请调整商品': '【Please note】that some items are out of stock and cannot be purchased.',
  '存在库存过低商品，请调整发货量或及时补充库存': '【Please note】Some items are out of stock and cannot be purchased.',
  '多个商品有异常，请重新调整商品': '【Please note】An abnormality has occurred with several products, please try again after we have taken care of the problem.',
  '商品已下架，请调整商品或发货量': 'Out of stock item(s), <br/>please adjust shipping quantity or replenish stock from your in-stock order.',
  '商品已失效，请调整商品或发货量': 'Some items are out of URL, <br/>please adjust the number of shipments or replenish inventory from stock holding orders.',
  库存不足: 'THE CKB Insufficient Stock',
  '当前订单包含需采购的商品，如遇到商品无法采购等情况导致取消时，将通过异常联络通知您，您可在xx中更改默认项': 'The current order contains the goods to be purchased. If the goods cannot be purchased and other circumstances lead to cancellation, you will be notified through abnormal contact. You can change the default items in xx',
  '组合不可，1次订购单品商品最多可组合30中SKU': 'Combination is not allowed, one order item can be combined with up to 30 SKU',
  商品链接: 'Product Link',
  '希望以订单为单位，确认是否可以取消': 'I hope to confirm whether it can be canceled by order.',
  '同意THE CKB直接取消该商品发货，剩余商品正常发货，无需询问': 'Automatically cancel the order. If there are multiple items in the order, only the items in normal condition will be shipped.',
  '组合商品：希望以订单为单位，确认是否可以取消': 'Combined goods: I hope to confirm whether it can be canceled by order.',
  '组合商品以外：同意THE CKB直接取消该商品发货，剩余商品正常发货，无需询问': 'Other than the combination of goods: agree to go straight to cancel the shipment of the goods directly, the remaining goods are shipped normally, no need to ask.',
  '无法发送商品时，设置是否可以取消自动发送 (直发订单)': 'When the goods cannot be sent, set whether to cancel automatic sending (straight order)',
  '※有「全网断货」OR「超出自动重拍次数上限」的商品的场合等': '※ there are "the whole network out of stock" OR "exceeds the maximum number of automatic remake" of the goods and so on',
  异常订单设置: 'Exception Order Settings',
  '当前订单包含需采购的商品，如遇到商品无法采购等情况导致取消时，将通过异常联络通知您，您可在中更改默认项': 'Issues that we handle will be posted in the Abnormal Order menu. Default settings for abnormal orders can be made in the following menu',
  '店铺配置->发货设置': '<br />[Store Management] -> [Abnormal Order Settings]',
  '该商品取消采购和发货，订单下其余商品（若有）正常发货': 'Cancel shipment of the error item, and if there are other items in the same order, ship the other items only.',
  '该商品取消采购和发货，订单下其余商品（若有）也取消发货，转为库存': 'Cancel shipment of the error item, and if there are other products in the same order, keep the other products in stock.',
  '该商品取消采购和发货，订单下其余商品（若有）自定义发货或转为库存': 'If the relevant error item is canceled for shipment and other items are included in the same order, instructions are given for each item to be handled individually.',
  '该商品不取消采购和发货，在我指定的新链接继续购买': 'If there are other products in the same order, you will be instructed to handle each product individually.',
  '「已取消」或「已发货」或「待发货」或「触发异常联络未处理」的商品无法再次选择': '(For products that have been "cancelled," "awaiting shipment," "shipped," or "awaiting abnormal order decision," the response instructions cannot be changed.',
  继续发货: 'Request for normal shipping',
  取消发货转为库存: 'Cancel shipment, change to stock in storage',
  选择结果: 'Contents of response instructions',
  最终组合结果: 'Breakdown of sets',
  选择: 'No change',
  次品重拍达到上限: 'Maximum number of automatic re-stocking has been reached',
  '已达到自动重拍次数上限，取消建议': 'Maximum number of automatic retakes reached, cancel suggestion',
  '由于您选择次品退货退款，未触发次品重拍': 'As soon as a defective item is found, we will automatically return the item to the store for a refund.',
  商品组合信息: 'Commodity combination information',
  请选择规格后再追加: 'Required Item Product Properties',
  商品已存在: 'Cannot be added. Same product already added.',
  请创建关联关系后再选择: 'Please try again after SKU linkage',
  组合或oem商品不允许编辑尺码变更: 'size change is not allowed to be edited for combination or oem items',
  请编辑附加项后保存: 'Required field<br/>Please select the product option for the child product.',
  '主商品无库存时下直发单，附加项将不执行': '*For D2C-End-User Direct Orders, the Set Setup Options setting will be disabled.',
  请补充手机号信息: 'Enter your cell phone number',
  '为了更好的为您服务，我们建议您补充手机号信息': 'In order to provide you with better service, we need your cell phone number to replenish your cell phone account.',
  不写区号: 'No area code',
  补充手机号: 'Replenishment will be done.',
  '活动赠送(推广联盟)': 'Benefits for Referral Ambassadors',
  经济舱: 'Economy Plan',
  标准舱: 'Standard Plan',
  商务舱: 'Business Plan',
  头等舱: 'Diamond Plan',
  温馨提示: 'Please confirm',
  去升级: 'Change to Standard Membership',
  暂不升级: 'Purchase now',
  '当前提交的订单商品数量达X件，升级标准舱预计本单可节省Y元手续费(入库手续费&出库手续费)，是否升级后再下单？': 'Currently, the number of orders submitted is x. upgrading the standard cabin is expected to save y CNY handling fee (warehousing handling fee & outbound handling fee). do you want to place an order after upgrading?',
  '出库手续费(预估)': 'Outbound Shipping Fee',
  '入库手续费(预估)': 'Inbound Fee',
  '可节省手续费合计(预估)': 'Total Fee Savings (Estimated)',
  件1: 'Piece 1',
  是否拦截: 'Shipment on Hold',
  拦截状态: 'Shipment on Hold',
  关闭拦截: 'Release hold',
  开启拦截: 'Shipment on Hold',
  出荷保留不可: 'Shipment hold not available',
  '首次加入会员，尊享首月': 'New member first month discount',
  立即入会: 'Join Now',
  首次加入会员: 'New Membership',
  尊享首月: "first month's fee",
  首次入会: 'New members only!',
  试用: 'Special Discount Offer!',
  '新客优惠活动还剩：': 'New Member Campaign Application Period: Remaining',
  首月: 'First month',
  名额仅剩: 'Only a few left',
  '次月续费X円/月': 'X $ per month from the following month',
  '※对于新用户专享活动，如果在会员到期前关闭自动续费，则不会产生使用费。只要没有办理关闭自动续费，就会从下个月开始以正常价格续费。': '※New user limited price will be applied only for the first month. The regular rate will be automatically deducted from the following month. The automatic withdrawal setting can be changed from the Member Information page.',
  '新客{A}円': '{A} $',
  新客1円: '0.1 $',
  新客X折: 'X% Discount',
  '新客{x}折': '{x}% discount',
  新人试用活动: 'Payment of membership fee (discounted price)',
  推广联盟: 'Referral Ambassador',
  '恭喜您已成为THE CKB专业推广者': 'You are now a Professional Referral Ambassador!',
  '恭喜您已成为THE CKB普通推广者': 'You are now a General Referral Ambassador!',
  我的专属推广码: 'Your Referral Code',
  '复制邀请码或者链接，即可进行推广': 'Copy your referral code or referral URL and share it with your acquaintances and friends!',
  复制: 'Copy',
  开启推广之旅: 'Confirm',
  '欢迎来到THE CKB！': 'Welcome to THE CKB!',
  '成功邀请了您，恭喜您获得': 'Referral Registration Benefits ',
  '天会员免费试用！': ' days! Experience the simplicity of Chinese purchasing!',
  我也要推广: 'Become a Referral Ambassador',
  '邀请码(选填)': 'Enter Invitation Code',
  邀请码错误: 'There is an error in the corresponding invitation code.',
  '邀请码无效，请重新输入': 'There is an error in the invitation code.',
  请输入日文: 'Please enter the code in Japanese',
  请输入英文: 'Please enter the code in English',
  无相关搜索结果: 'No matches found',
  支持日文搜索: 'Search in Japanese',
  支持英文搜索: 'Search in English',
  '支持日文/英文搜索': 'Search in English or Japanese',
  都道府县日文: 'Prefecture',
  市区町村日文: 'City/Town/Village (in Japanese)',
  都道府县英文: 'Prefecture (in English)',
  市区町村英文: 'City/Town/Village (in English)',
  请输入日文详细住所: 'Please enter a detailed address in Japanese',
  请输入英文详细住所: 'Please enter detailed address in English',
  '发货费用总额(元)': 'Total International Shipping Amount (RMB)',
  发货费用总额: 'Total International Shipping Amount',
  已失效2: 'Not available for selection',
  商品附加项组合: 'Product Option Set',
  发货附加项组合: 'Shipping Option Set',
  编辑商品附加项: 'Product Option Set Management',
  编辑类目附加项: 'Category Option Set Management',
  创建附加项组合: 'New Option Set',
  操作成功: 'Option set was already set up',
  附加项组合: 'Option Sets',
  '抽检数量根据比例向上取整；选择抽检如发生次品，则无法发起售后': 'Please note: <br/>・The number of samples for sampling inspection is rounded up according to the ratio and a whole number is taken. <br/>In case of sampling inspection, even if defective products are found, after-sales service is not available. <br/>If you choose the sampling inspection service, even if defective items are detected in the sample, all items that have not been inspected cannot be retested and will be entered as good items.',
  请填写抽检比例: 'Please enter the percentage of samples.',
  '使用了抽检服务，无法发起次品售后': 'If sampling inspections are performed, after-sales service is not available for defective products.',
  添加: 'Add',
  组合名称: 'Option Set Name',
  肩宽: 'Shoulder width',
  横宽: 'Body width',
  衣长: 'Length of clothes',
  袖长: 'Sleeve Length',
  袖宽: 'Sleeve width',
  袖口宽: 'Cuff width',
  连肩袖长度: 'Sleeve length',
  领围: 'Collar circumference',
  腰围: 'waist',
  臀围: 'Hips',
  前档长: 'Inseam',
  后档长: 'The rise',
  裤脚宽: 'Hem Width',
  大腿根围: 'Armpit Width',
  半身裙: 'Skirt',
  裙长: 'Total Length',
  连衣裙: 'Dress',
  后衣长: 'Back of the body',
  '头围（内侧）': 'Head circumference (inside)',
  高度: 'Height',
  肩带: 'Shoulder straps',
  下胸围: 'Underbust',
  长度: 'Total Length',
  最大宽度: 'Maximum Width',
  跟高: 'Heel Height',
  鞋底宽: 'Bottom width',
  '鞋底的长度（有鞋跟的商品除外）': 'Total length of sole (excluding items with heels)',
  鞋前宽: 'Instep Circumference',
  '脚踝围（外侧）': 'Ankle circumference (outside dimension)',
  '筒围（内侧）': 'Toe Circumference(Inside dimension)',
  鞋底高度: 'Sole Height',
  宽度: 'Width',
  我的商品测量结果: 'Product Specification confirm',
  我的商品测量结果menu: 'Product Specification confirm',
  附加项数量: 'Numbers of options',
  范围: 'Inspection method',
  抽检比例: 'Sample Ratio',
  全检: 'Total inspection',
  抽检: 'Sampling inspection',
  分包: 'Shipping in installments on the store side',
  快递公司请求重量: 'Shipping company billing weight',
  退差价: 'Refund',
  物流公司不能为空: '※Required Fields',
  展开全部数据: 'View More',
  图像: 'Image',
  商品SKU: 'Product SKU',
  单品数量: 'Quantity of single item',
  单品落单数: 'Remaining stock quantity of single item',
  '库存发生变更，请重新提交订单': 'Stock quantity has changed. Please resubmit your order.',
  '商品已失效，库存不满足需求量，无法下单': 'Product URL page not applicable.',
  成品区库存重组需收取组合费用: '【Please note】 <br/>When you use single item inventory for a set, a set assembly fee will be charged.',
  使用库存会收返工费: 'Re-working fee will be charged when a set is assembled using a single item in stock.',
  成品区可用的库存数量: 'Re-work fee will be charged for set assembly using single item inventory.',
  组合返工费用: 'Re-working set-up fee',
  质检区落单的库存数量: 'Remaining stock of set items',
  'THE CKB专属会员': 'THE CKB PRO Member',
  'THE CKB专属会员权益': 'Benefits of THE CKB PRO Membership',
  立即开通专属会员: 'Register as THE CKB PRO Member',
  立即续费专属会员: 'Continue THE CKB PRO Membership',
  复制专属会员推广链接: 'Copy your referral URL',
  功能特权: 'Additional Benefits',
  您的专属权益: 'PRO Membership',
  非会员: 'Regular Member',
  专属会员专享服务: 'Continue THE CKB PRO Membership',
  专属会员: 'Continue THE CKB PRO Membership',
  '您还可选择THE CKB普通会员': 'Choose to register as THE CKB Regular Member',
  '如有任何疑问，请用LINE扫描右侧二维码联系我们，获取专属咨询服务。': 'If you have any questions, please contact us by reading the QR code on the right or contact us on line. You can get exclusive consulting service.',
  '您无法购买该会员，请前往会员中心购买普通会员': 'I am unable to purchase a Pro membership. Please go to the Member Center to purchase a regular membership.',
  提醒: 'Please note',
  保留中: 'Pending',
  通常出荷: 'Normal Shipping',
  'PRO会员尊享：常规权益+PRO追加权益，查看': 'Exclusive for PRO members: All First Plan services + additional PRO benefits. For a list of plan services',
  常规权益: 'Click here',
  会员计划: 'Member',
  'LINE 查询': 'Contact us on LINE',
  新限量: 'Limited to new',
  '您输入的值的长度对于目标字段来说可能太短或太长。 请再次输入正确的内容': 'The length of the entered value may be too short or too long for the subject field. Please enter the appropriate content again.',
  您输入的值格式错误: 'The format of the entered value is incorrect.',
  错误请联系客服: 'Error. Please contact Customer Service.',
  '*汇率以“”计算': '※The exchange rate will be calculated with " ".',
  我确认并同意以上内容: 'I confirm and agree to the above',
  Shopif操作动手册: 'Shopify Integration Manual',
  您已选择关闭自动付款: 'You have chosen to turn off automatic payment.',
  '★请再次确认★': '★Please reconfirm★',
  '[推荐设置！ 超过90%的用户设定]': '【Recommended setting!】 More than 90% of users have set it.',
  '我们建议您自动支付支付每月的会员费。': 'We recommend that you set up <automatic payment> for your monthly membership fee.',
  '*如果自动付款设置为“关闭”，则需要采取以下措施。': '※If you choose [OFF] for automatic payment, you will need to do the following',
  '① 每月需要缴纳会费工作': '(1) You need to pay the monthly membership fee by yourself.',
  '（2）如果会员有效期满而未采取第（1）项中的措施，则将无法使用所有会员服务。': '(2) If you do not take the action described in (1) above and your membership expires, you will not be able to use all services for members.',
  '→需再次办理入会手续': '→Membership procedure is required again.',
  '不可续费功能，超过有效期后无法使用': 'Functions not available after expiration of membership period',
  '· 直接从中国EC网站购买购物车': '・Direct shopping cart purchase from Chinese e-commerce website',
  日语和图片产品搜索: ' ・Product search in Japanese & with images',
  产品订单: 'Merchandise ordering',
  '· 直接采购中国产品，最高品质检验': '・Direct purchase of Chinese goods & highest quality inspection',
  '·行业最快的物流服务': '・Fastest logistics service in the industry',
  '最快、最便宜的国际运输': '・Fastest & Lowest Price International Shipping',
  '· 与其他网站（BASE、shopify、亚马逊等）的链接': '・Connectivity with other websites (BASE, shopify, Amazon, etc.)',
  '· 自动下单、批量产品注册、FBA发货等': '・Automatic ordering, bulk product registration, FBA delivery, etc.',
  '如果取消自动付款，过期后将不会自动续充会员': 'If you cancel automatic payment, after your membership is suspended,',
  '您的订单将自动停止处理，这可能会导致交货延迟。': 'Order processing will be automatically suspended, which will also lead to delivery delays.',
  '您确定要关闭会员费自动续费功能吗？': 'Would you like to "turn off" automatic payment of membership fees?',
  问卷调查: 'Survey',
  '感谢您使用它。 请帮助我们今后改进我们的服务。': 'Thank you for using our service. Please fill out the survey to help us improve our service in the future.',
  必需的: 'Required',
  请填写投诉内容: 'Please describe your dissatisfaction',
  '取消自动缴纳会费的原因（可多选）': 'Reason(s) for canceling automatic payment of membership fee(s)',
  我想按照自己的节奏使用会员服务: 'I want to use membership services at my own pace.',
  我想更改会员费支付方式: 'I would like to change my membership payment method.',
  '我对会员费自动缴费服务功能不满意（焦虑）': 'I am dissatisfied (concerned) with the automatic membership fee payment service function.',
  我想取消乘坐直飞航班: 'I want to stop using THE CKB.',
  其他的: 'Other',
  '请告诉我们您选择“我想取消直飞航班”的原因（可多选）': '-"I want to stop using THE CKB." Please tell us the reason for your choice in ( multiple answers accepted).',
  不常使用: 'Infrequent use',
  昂贵的: 'Fees are too high',
  系统可操作性差: 'Poor operability of the system',
  对运送速度不满意: 'Unsatisfied with shipping speed',
  对产品质量不满意: 'Unsatisfied with product quality',
  我对支持和询问的答复不满意: 'Unsatisfied with support, inquiries, etc.',
  我没有得到我想要的服务: 'Services were not well suited to my needs.',
  '如果您想使用任何其他服务，请告知我们。': 'Please let us know if there are other services you would like to use.',
  '如果您还有其他意见或要求，请随时填写。': 'Please feel free to add any other comments or requests you may have.',
  '请选择需要的项目。': 'Please select required items.',
  结束日期: 'End Date',
  结束日期1: 'End Date',
  新人开通专属会员享: 'New customers only. First month',
  '円/首月': '$',
  名额仅剩X名: 'Only X people remaining',
  特惠体验中: 'Special Discount Experience Now!',
  '请购买会员后观看直播。': 'Membership is required for live streaming. Please register or renew your membership.',
  距离开播还剩: 'Until the live stream starts.',
  '商品缺货，无法下单，请重新勾选商品下单。': 'Product out of stock<br/>Please remove the corresponding product and reorder',
  预约成功: 'Appointment successful',
  系统使用手册: 'System Manual',
  视频: 'Video Manual',
  $最后一行谢谢$: '$Last line Thank you $',
  未读: 'Unread',
  请求失败: 'Request failed',
  对应情报: 'Response Information',
  '确认要追加商品吗？': 'Would you like to add an item to your cart?',
  隐私条款: 'Privacy Policy',
  次转正提醒: 'Please Note',
  OEM条款: 'OEM Support Terms of Use',
  '请输入THE CKB发货单号': 'Enter Direct Shipment Request No.',
  纸板外箱: 'Cardboard Outer Box',
  自有品牌运输袋: 'Own Brand Shipping Bag',
  様: '',
  商品オプション設定: 'Product Option Setup',
  料金詳細: 'Details of Charges',
  規格: 'Standard',
  名: 'Name',
  サイズ: 'Size',
  '已上架(已清算)': 'Shelf (liquidated)',
  '({time}に保留を自動解除)': '(Automatically release pending at {time})',
  KAERU工具: 'KAERU Tools',
  発送: 'Shipping',
  API連携: 'API Linkage',
  箱唛: 'Box Label',
  '- 库存系统': '- B2B Seller System',
  '- 无库存系统': '- D2C Seller System',
  暂无数据: 'Data is temporarily unavailable',
  '由于没有可用的运输方式，需要您取消发货': 'No available shipping routes, please cancel shipment',
  此订单已取消发货: 'Your shipment has been canceled.',
  无可用运输方式: 'There are no available shipping routes.',
  $国际运单号$: 'International Shipping No.',
  线下: 'Factory Direct',
  国际料金表提示: 'Please note the following points regarding international shipping charges: <br/>・International shipping charges will be deducted based on actual measurements taken at our warehouse. <br/>・Please note that there is a possibility of error between our measurement and that of the logistics company. <br/>・After shipment, additional charges may be incurred, such as remote area charges, delivery address change fees, and oversize/overweight charges. <br/>・Please check the invoice from the logistics company and if there is a difference, we may charge you the difference in the following month. <br/>・If there is insufficient balance to debit international shipping charges, shipment will be suspended and a separate payment notice will be sent. <br/>・After payment is confirmed, the product will be shipped. <br/>・To avoid any impact, please ensure that you have a sufficient balance in your system account prior to the shipment of goods.',
  通关名义: 'Name of customs clearance',
  个人: 'Individual',
  企业: 'Company',
  邮箱不能为空: '※Required Fields',
  会社编号不能为空: '※Required field',
  公司名不能为空: '※Required field',
  '在既成品的基础上，我有一些改良的需求': 'On the basis of the finished product, I have some improvement needs.',
  '既无参考图片也无式样书的情况，无法发起寻源，请联系对应担当提供制作式样书服务': 'Please contact our representative.\nOur representative will provide you with the details as you will need to provide us with the specifications necessary for our OEM production.',
  '请问你对本次服装OEM的初步需求是怎样的？': 'What is your initial demand for this clothing OEM?',
  '只需要生产出和图片或链接看起来一样的产品，对面料没有任何要求，且不需要有任何设计上的改动。': 'I would like to produce a product that matches only the design of the product image or product URL.\n　The highest priority is placed on speed of response, and no product fabric is specified.',
  '风险告知：A的情况，此选项不寄实物样品给客户，只通过样衣图片在线上进行确认。此选项优点为出样快，缺点为THE CKB只保证成衣外观和客户提供的图片接近一致无法保证和原链接衣服材质保持一致。请知悉！': 'Compared to other plans, this plan places the highest priority on speed.\n The emphasis is on matching the product design, and samples are confirmed with images rather than the actual product.\n Please note that we can only guarantee that the product matches the design, not the fabric or texture.\n *If you have size and fabric specifications, please select Plan B or C.',
  '我有样衣，希望THE CKB帮我生产出和样衣一模一样的衣服。': 'There is a product sample, and we want to produce the same product as the sample in terms of fabric, size, etc.',
  '我有样衣，但我对设计/面料/尺寸等，有希望改动的地方。': 'There is a product sample, and you want to produce a product with a different design, fabric, size, etc.',
  '我只有参考图片或链接，且我有需要改动的地方或我对面料有拘泥。': 'There is no product sample, but only a product image or product URL. There is a request to change the design, fabric, size, etc.',
  '此种情况您需要尽可能提供一件样衣到THE CKB作为参考，或者您需要提供详细的式样书，如果您没有式样书，可以联系THE CKB使用式样书制作服务': 'Please submit samples or specifications for reference. If you do not have a specification sheet, you can request us to prepare one for you.',
  '我没有样衣或参考图片/链接，但我有式样书，希望THE CKB根据式样书帮我进行生产。': 'There is only a product specification sheet (no sample, reference image, or product URL). We would like to produce products according to the specifications.',
  '既无参考图片也无式样书的情况，无法发起寻源，请联系对应担当提供制作式样书服务；式样书必须包含产品的色卡、尺寸、特殊工艺、面料信息等': "Please contact our company's representative.\nOur representative will provide you with the details as you will need to provide us with a specification document for OEM production at our company.",
  请至少填写一条完整的产品信息: 'We cannot request a quotation due to insufficient information.',
  产品信息说明: 'Product Information Description',
  '不知道，但是我可以邮寄面料样布，希望THE CKB帮我找到和样布一样的面料': 'Fabric samples are available for shipping.',
  '请问你是否知道面料具体信息？': 'Explanation of fabric information',
  '知道，我可以提供面料信息和具体的色卡信息': 'Enter fabric information and color',
  '不知道，希望THE CKB帮我找到和样衣或参考图片一样的面料': 'Refer to the sample',
  '不知道，希望THE CKB可以根据我的需求，给我推荐合适的面料': 'Suggestion of THE CKB',
  请提供具体的色卡信息: 'Please enter desired fabric information (material and color)',
  '请大致描述一下希望布料的外观或功能上的需求，如': 'Please generally describe the appearance or functional requirements of the desired fabric, such',
  '请大致描述一下希望改动哪些方面,如': 'Please describe roughly what you want to change, such',
  '请问你能够提供尺码的具体尺寸吗？': 'Could you provide a detailed size guide for the product?',
  '我有尺码对应的尺寸数值。': 'Enter size information',
  '根据服装生产标准，尺寸相差': 'According to clothing production standards, the size difference',
  '我没有数值，请参考链接尺寸。': 'Refer to the dimensions on the product page',
  '我没有数值，请THE CKB提供。': 'Suggestion of THE CKB',
  '请先下载对应模板，填写完成后上传': 'Please download the template file and enter your details before importing',
  创建寻源单说明: 'Create Source Tone Description',
  '以上为参考报价，具体报价需要以最终报价为准': 'The above is a reference quotation, and the specific quotation shall be subject to the final quotation.',
  '系统检查到，您未安装采购扩展程序，现在安装采购更方便直接在1688，天猫，淘宝官网THE直达商品可以添加到采购系统购物车中。现在马上安装': 'With our tool, you can buy products directly from major Chinese websites such as 1688, T-MALL, Taobao through THE CKB System!\nIt is very convenient for you to purchase products!\n Add [KAERU Tool] now!',
  请输入Amazon: 'Please enter Amazon',
  请搜索需要绑定的Amazon: 'Search for the Amazon that needs to bind',
  '商品名称/Amazon': 'Product Name/Amazon',
  点击完结: 'Click End',
  存在待组商品: 'Goods to be grouped exist',
  購入数量が最低ロット数を満たしていません: 'Purchase quantity does not meet minimum batch quantity',
  '存在不足起订量的商品，请修改数量': 'Purchase quantity incomplete.\n Purchase quantity does not meet minimum lot size.',
  '当前账号下无店铺，请创建店铺后再执行操作': '【Please check】\n Store not registered.\n Please try again after creating a store.',
  '如果您当前存在部分订单未完成的话，您账户可用余额中我们将会自动为您留下当下账户冻结金额*1的金额，来确保账户有足够的金额来支付国际运费后顺利发货。所以您目前可转账的金额为：账户可用余额-冻结金额': 'In order to ensure that there is enough money to pay for international shipping when there is an order being handled, we have temporarily set the amount of (Deposit in this account*1) from the available amount as unavailable.\n Currently, the amount available for transfer is the available amount minus the deposit.',
  申込月数: 'Number of months applied',
  銀行振込: 'Bank transfer',
  '请填写商品的尺寸分类。如果有多个大小，请添加行并输入大小。例M、L、XL、30cm*40cm*20cm等': 'Please indicate the size category of the product.\nIf there are multiple sizes, please add a line and enter the size.\n Example: M,L,XL,30cm*40cm*20cm, etc. ',
  例: 'Example',
  '<span>透明购</span>': '<span> Clear Purchase </span>',
  搜索Amazon: 'Search Amazon',
  剩余XX天hh: 'XX days remaining hh',
  '点击【确定】按钮，系统将自动从余额扣除当前账单<br': 'Click the [OK] button, the system will automatically deduct the current bill from the balance <br',
  余额扣费汇率全部以: 'The balance deduction exchange rate is all based on',
  请输入中文: 'Chinese',
  '注册成功后国家/地区无法更改，请谨慎选择': 'Once successfully registered, the country cannot be changed. Please select your country carefully. ',
  新增银行转账方式大幅提高入账速度: 'New bank transfer method greatly improves recording speed',
  未选择检查选项: 'No check options selected',
  '没有检查工作就可以寄出产品吗？': 'Can I send the product without inspection work?',
  请检查一下: 'Please confirm',
  在有色的情况下: 'In the case of colored',
  洗涤后颜色可能会轻微褪色: 'Colored fabrics',
  '请避免与其他衣物混用。': 'so please avoid mixing with other laundry.',
  再次: 'Also',
  由于汗水或潮湿条件下的摩擦: 'color fading may occur due to perspiration or friction when the product is damp.',
  可能会发生变色: 'Discoloration may occur',
  洗后有一定缩水: 'May shrink slightly after washing',
  米白色: 'beige white',
  '对于浅色产品，请使用不含荧光增白剂的洗涤剂。': 'For light-colored products, please use a detergent that does not contain fluorescent bleach.',
  相同的: 'Same',
  在产品中: 'of (number) products.',
  测量点: 'Measure (number)',
  '如果您想对所有产品进行测量，请联系客服。': 'Please contact Customer Service for full product measurements.',
  淘宝: 'Taobao',
  官网搜索: 'Search the official website',
  提供多种支持中国采购的强大功能: 'Numerous functions are available to strongly support China purchases.',
  '如果您是THE CKB会员': 'If you are a member of THE CKB',
  提供更丰富的中国代购服务: 'you can have access to more extensive Chinese procurement services',
  而且: 'Furthermore',
  满满的会员专享福利: 'Full of members-only benefits',
  'THE CKB汇率': 'Straight-line exchange rate',
  API链接指南: 'API Link Guide',
  '什么是付款申请表？': 'What is the Payment Request Form?',
  发生系统账户自动提款以外的费用时: 'Any charges other than those incurred by automatic debit from the system account.',
  '这是一份要求用户额外付费的文件。': 'This is a document that charges additional fees to the user.',
  '当用户批准付款请求时，该费用将从系统余额中扣除。': 'The fee will be deducted from the system balance when the user approves the payment request.',
  自签发之日起: 'from Date of Issue',
  如果无法在几天内确认付款: 'If payment is not confirmed within (nubmer) days,',
  我们会自动扣除费用: 'the fee will be automatically debited from your account.',
  使用工具: 'By using our tool,',
  '产品可以直接从官网加入购物车，比如': 'products can be added directly to THE CKB cart from official websites such as (name of the website)',
  店铺已经准备好: 'Since the store you entered',
  因为它与商店链接: 'has already been already linked to a store,',
  无法变更为其他店铺并再次链接: 'it is not possible to change another store and link it again.',
  '由于系统维护，系统服务将无法使用。': 'System services will be unavailable due to system maintenance.',
  自动下单: 'automatic order placement.',
  做好了: 'Well done',
  什么是工具: 'What is our tool?',
  安装方法: 'How to Install',
  在以下位置搜索工具: 'Search for tools on',
  固定工具: 'Fixing tool',
  点击下单: 'Pin the tool',
  点击进行产品搜索: ' Click-to-order',
  带翻译功能: 'Translation function included',
  点击: 'Click',
  同类产品研究: 'Research similar products for',
  具有图像搜索功能: 'Includes an image search function',
  'THE CKB系统': 'THE CKB system',
  站点: 'Site',
  该工具是: 'Our tool is',
  'THE CKB开发的产品研究和订购的便捷工具': "THE CKB's proprietary and useful tools for researching and ordering products.",
  '如果您在THE CKB系统中使用此工具，': 'By using this tool on our system,',
  中国的: 'Chinese',
  用日语搜索产品: 'search for products in Japanese on',
  您可以一键下单: 'Orders can be placed with a click!',
  具有同类产品研究功能: 'it has a similar product research function',
  '也可以比较价格，降低成本。': 'cost reduction is also possible by comparing unit prices.',
  打开网上商店: 'Open the Web store',
  工具: 'tool',
  输入: 'type in',
  添加扩展名: 'add extensions',
  按顺序点击: 'Click them in this order',
  安装: 'and install.',
  安装后: 'After you have done installing our tool,',
  在地址栏的右边: 'on the right side of the address bar',
  销标记: 'the pin mark',
  建议您点击置顶: 'We suggest you to click (B94) to fix it.',
  '·中国': '・China',
  在网站上研究的产品: 'Products researched on the website',
  单击即可进行系统内订购: 'can be ordered in the system with a click.',
  打开官网: 'Open the official website,',
  选择所需产品: 'select your desired product.',
  在产品详细信息页面上: 'on the product detail page',
  '添加到THE CKB购物车': 'add it to THE CKB cart',
  点击按钮: 'click the button',
  '可以添加到THE CKB系统内的购物车': 'you can add them to your cart in the THE CKB system.',
  返回系统购物车页面: 'Return to the system cart screen,',
  '我们将继续进行订购​​流程': 'the order process will be proceed.',
  点击首页右上方的图标: 'Click the icon in the upper right corner of the top page screen',
  输入关键字后: 'enter keywords',
  单击搜索按钮: 'click on the Search button',
  显示搜索结果: 'it will display search results.',
  点击产品研究: 'Click Product Research',
  '・直接输入日语即可用中文': '・By entering English directly, you can research ',
  您可以在网站上研究产品和商店名称: 'products and store names on Chinese websites.',
  输入产品关键词后: 'Once you enter the product keywords',
  在我们的系统中注册后: 'After registering in our system',
  可用的工具: 'tools will be available to help you',
  '・THE CKB系统 ・日本': '・THE CKB System ・Japan',
  '网站・中国': 'Website　・China',
  与网站上的产品相似的产品: 'Similar products to those displayed on the site',
  产品: 'Products',
  可以使用图像搜索功能进行研究: 'can be researched on (name of the website)・Image search function included.',
  '一键搜索THE CKB相似商品': 'Similar products of those displayed in THE CKB system',
  研究可能: 'can be serched with one-click.',
  '登录THE CKB系统': 'Login to THE CKB',
  在产品图片的左上角: 'top left of product image',
  铲子: 'the shovel',
  单击图标: 'icon',
  前往官方网站: 'brings you to the official website',
  显示相似产品搜索结果: 'to view similar product search results.',
  一键点击搜索与网站上产品相似的产品: 'Similar products of those displayed can be',
  研究: 'researched with one-click.',
  在目标产品图像的左上角: 'Top left corner of the subject product image',
  可以研究: 'serched with one-click.',
  从产品搜索结果列表: 'From the list of product search results',
  找不到您要查找的页面: 'PAGE NOT FOUND',
  输入值的长度为: 'The length of the entered value',
  目标字段可能太短或太长: 'may be too short or too long for the target field.',
  请重新输入正确的内容: 'Please enter the appropriate details again.',
  您输入的内容格式错误: 'The format of the entered value is incorrect.',
  瑞穗银行: 'Mizuho Bank',
  '节假日·调休的汇款会在第二个工作日处理。': 'For transfers on holidays and substitute holidays',
  将在下一个工作日处理: 'will be processed on the next business day.',
  接收人姓名: 'Recipient Name',
  '请提供包含转账金额信息的图片。': 'Please provide an image that includes information on the amount of money to be transferred.',
  注册转账来源账户: 'Register the account of the sender',
  输入片假名: 'Enter Katakana',
  必须与实际转账名称相同: 'Must be the same as the name on the actual transfer.',
  请注意输入错误: 'Please be careful of input errors.',
  当你取消: 'If you cancel,',
  '所有输入的信息将被删除。': 'all entered information will be deleted.',
  山吹支店: 'Branch',
  花旗银行: 'City Bank',
  北美: 'North America',
  目前没有可用的卡片: 'There are no cards available at this time.',
  汇款金额必须大于等于零: 'The amount of the remittance must be greater than 0.',
  当您输入的预定转帐日期与付款日期不符时: 'If there is a discrepancy between the estimated transfer date you entered and the date of payment arrival,',
  '收到款项后，需要办理会计复核手续。': 'you will need to go through the accounting re-examination process after receiving the payment',
  '请注意，付款可能需要一些时间才能到账到系统帐户中。': 'Please note that it may take some time for the deposit to be reflected in the system account.',
  没有数据: 'NO DATA FOUND',
  '找不到银行名称，请手动输入': 'Bank name could not be found. Enter manually.',
  输入转账银行名称: 'Enter the name of the bank from which the money was transferred.',
  报价请求: 'Request a Quote',
  采购现成商品: 'Purchase of ready-made products.',
  市场产品采购: 'Purchase of market products.',
  样品订单: 'Sample Order',
  产品组合: 'Product Combination',
  洗衣标签创建: 'Create laundry tags',
  仅表: 'Surface only',
  纽扣孔开口: 'Make buttonholes',
  缝上布标: 'Sew fabric tags',
  缝上洗衣标签: 'Sew laundry tags',
  摘除原始标签: 'Remove original tag',
  洗衣标签: 'Laundry tag',
  布标: 'Fabric tag',
  吊牌: 'Hang tag',
  附加项更换: 'Additional item replacement',
  放入感谢卡: 'Additional item replacement',
  检查时将其放入每个产品中: ' Insert in each item during inspection',
  彩带包装: 'Ribbon packaging',
  衣架: 'Put the hang tag',
  刮刮卡盒: 'Scraping card box',
  优惠券: 'Insert Coupon cards',
  保证卡: 'Guarantee Card',
  使用说明书: 'Instructions for use',
  替代品: 'Switch',
  自己的品牌: 'Own brand',
  专用储物袋更换: 'Replace with special storage bag',
  其他配件: 'Put other accessories in',
  气泡膜包装: 'Bubble Wrap packaging',
  拉伸膜包装: '【Live stream】Special price',
  缓冲包装: 'Cushioning packaging',
  线程锁: 'Hang tag string with a lock',
  去除布标: 'Remove the fabric tag',
  去除洗涤标签: 'Remove the landry tag',
  摘除吊牌: 'Remove the hang tag',
  调整尺寸: 'Resize',
  缝上尺码标签: 'Sew on size tag',
  尺寸标签: 'Size Label',
  松动检查: 'Loosening inspection',
  包装时放入每个包装: 'Put each package when packing',
  丝带包装: 'Ribbon packaging',
  纸板箱: 'Carton',
  纸板包装工作: 'Cardboard packaging work',
  标签: 'Label',
  托盘包装: 'Pallet packaging',
  刮刮卡: 'scratch card',
  箱子标签: 'Box Label',
  洗衣标: 'Laundry label',
  附加项安装更换: 'ADDITIONAL INSTALLATION REPLACEMENT',
  去除吊牌: 'Remove the tag',
  调整大小: 'Resize',
  转账申请表: 'Transfer Application Form',
  充值资金: 'Recharge funds',
  资金转账到各店铺: 'Funds transferred to each store',
  仅限会员支付: 'Member Payment Only',
  订单将在该店铺下单: 'Orders will be placed in this store',
  订购前: 'Before ordering',
  '首先，您需要通过转账的方式将资金转入店铺。': 'First, you need to transfer funds to the store by transfer.',
  加载失败: 'Failed to load',
  继续: 'Continue',
  请重新加载页面: 'Please reload the page',
  加载中: 'Loading',
  请稍等: 'Please wait a moment',
  马来语: 'Malay',
  泰语: 'Thai',
  检查更多: 'Check More',
  演员博客: "Actor's Blog",
  '扣款成功的话，会发货': 'If the deduction is successful, the goods will be delivered.',
  '由于余额不足的原因无法提款的情况下，我们会停止发货作业并发送另外支付的通知。': 'If the withdrawal cannot be made due to insufficient balance, we will stop the delivery operation and send a notice of additional payment.',
  一旦确认付款: 'Once payment is confirmed',
  我们将运送产品: 'We will ship the product',
  以免影响发货: 'So as not to affect the delivery',
  '请在发货前在系统账户中准备足够的余额。': 'Please prepare sufficient balance in the system account before shipment.',
  如果提现成功: 'If the withdrawal is successful',
  模板: 'Template',
  商品管理代码: 'Commodity Management Code',
  因为无法标明相关物流公司的状态: 'Because it is not possible to indicate the status of the relevant logistics company.',
  '对不起，麻烦您了': 'Sorry to trouble you',
  在下面的参考文件中追踪: 'Traced in the reference document below',
  请检查: 'Please check',
  参考文件: 'REFERENCE DOCUMENTS',
  还没有: 'Not yet',
  未开始对应: 'No correspondence started',
  确认管理页上的内容后: 'After confirming the content on the management page',
  请提交您的需求: 'Please submit your requirements',
  '如果您想订购多种款式，': 'If you want to order multiple styles,',
  请务必输入每个产品的详细信息: 'Be sure to enter details for each product',
  如果我不: "If I don't",
  您可能无法订购多种规格: 'You may not be able to order multiple specifications',
  感谢您的理解: 'Thank you for your understanding',
  模板文件: 'Template File',
  包括相关网站说明: 'Include related website description',
  同意并继续: 'Agree and continue',
  是的: 'Yes',
  不: 'No.',
  等待购买: 'Waiting to buy',
  有存货: 'In stock',
  等待入库: 'Waiting for storage',
  根据我们的检验标准判断为有缺陷: 'Defective according to our inspection criteria',
  如果您在订购时选择检验选项: 'If you select the inspection option when ordering',
  仅限新会员: 'New members only',
  您可以在以下网址体验中国进口代理服务: 'You can experience China import agency service at the following website',
  关于以上内容: 'About the above content',
  '确认/同意': 'Confirm/Agree',
  以下产品是: 'The following products are',
  '请注意，我们无法处理': 'Please note that we cannot handle',
  '如有疑问，请在购买前': 'If in doubt, please before purchasing',
  请每次检查: 'Please check each time.',
  侵犯专利权: 'Infringement of patent right',
  鸦片: 'Opium',
  罂粟籽: 'Poppy Seed',
  手枪: 'Pistol',
  这些弹药和手枪零件: 'These ammunition and pistol parts',
  发货取消: 'Shipment Cancelled',
  '发货已取消/有货': 'Shipment canceled/in stock',
  '未知颜色/尺寸': 'Unknown color/size',
  有最小订货批号: 'Minimum order lot number available',
  即使自动回购次数已达到上限: 'Even if the number of automatic repurchases has reached the upper limit',
  可出货的可用库存不足: 'Insufficient available stock to ship',
  不良商品处理设置: 'Bad Commodity Handling Settings',
  指定的: 'Specified',
  所有网站都缺货: 'All websites are out of stock',
  缺货补货完成: 'Out of stock replenishment complete',
  购买已取消: 'Purchase canceled',
  有最小订货量: 'have minimum order quantity',
  '您已达到最大自动回购次数。': 'You have reached the maximum number of automatic repurchases.',
  后自动解除: 'Automatic release after',
  在指定时间自动解除: 'Automatically dismiss at a specified time',
  可以手动提前解除: 'Can be manually released in advance',
  '已处于发货状态的商品不能转为库存。': 'Goods that are already in shipment status cannot be converted to inventory.',
  订单的所有产品状态: 'Status of all products for the order',
  已经取消: 'Cancelled',
  当改为: 'When changed',
  已清算订单: 'Liquidated Order',
  请确认商品的作业记录: 'Please confirm the operation record of the commodity',
  已设置为自动下单: 'Set to place orders automatically',
  自动排序: 'Automatic sorting',
  登录我的Paypal后: 'After logging into my Paypal',
  单击屏幕右上角的齿轮图标: 'Click the gear icon in the upper right corner of the screen',
  在屏幕顶部: 'At the top of the screen',
  管理自动付款: 'Manage automatic payments',
  在这个屏幕上: 'On this screen',
  您可以添加或取消定期付款: 'You can add or cancel recurring payments',
  如果你想取消: 'If you want to cancel',
  从左边的菜单: 'From the menu on the left',
  单击要取消的定期付款: 'Click on the recurring payment you want to cancel',
  在右边的屏幕上: 'On the right screen',
  被选中: 'be selected',
  请再次确认: 'Please reconfirm',
  '超过 10% 的用户设置': 'More than 10% of user settings',
  会员月费: 'Monthly membership fee',
  我们推荐: 'We recommend',
  如果是: 'If it is',
  需要进行以下操作: 'The following operations are required',
  每个月必须自己支付会员费: 'You must pay your own membership fee each month.',
  不采取行动: 'no action',
  会员到期后: 'After expiration of membership',
  所有会员服务不可用: 'All member services unavailable',
  再次需要办理入会手续: 'Once again, you need to go through the membership formalities.',
  '不可续费功能，过了有效期就不能使用了': 'The non-renewal function cannot be used after the validity period.',
  直接从网站购物车购买: 'Buy directly from the website shopping cart',
  按图片搜索产品: 'Search Products by Picture',
  直接购买中国产品: 'Buy Chinese products directly',
  业界最快的物流服务: "The industry's fastest logistics service",
  国际航运最低价: 'Lowest international shipping price',
  其他站点合作: 'Other Sites Collaboration',
  这样的: 'Such',
  送货等: 'Delivery, etc.',
  如果取消自动付款: 'If automatic payment is canceled',
  您的订单将自动停止处理: 'Your order will automatically stop processing',
  导致交货延误: 'Lead to delivery delays',
  会员费自动支付: 'Automatic payment of membership fees',
  可以吗: 'Can you',
  感谢您使用它: 'Thank you for using it',
  为了未来的服务改进: 'For future service improvements',
  请配合问卷调查: 'Please cooperate with the questionnaire survey',
  取消自动支付会员费的原因: 'Reasons for canceling automatic payment of membership fees',
  我对会员费自动续费服务功能不满意: 'I am not satisfied with the membership fee auto-renewal service feature',
  '我想取消使用THE CKB会员': 'I would like to cancel the use of Direct Express membership.',
  请告诉我你选择的理由: 'Please tell me the reason why you chose',
  不经常使用: 'not used often',
  我对支持和查询的响应不满意: 'I am not satisfied with the response of support and query',
  我没有得到我正在寻找的服务: "I didn't get the service I was looking",
  '如果您想使用任何其他服务，请告诉我们。': 'If you want to use any other service, please let us know.',
  '如果您有任何意见或要求，请随时填写。': 'If you have any comments or requests, please feel free to fill in.',
  请选择所需项目: 'Please select the required items',
  几个月: 'A few months',
  从余额中支付: 'Pay from balance',
  付款方式: 'Payment Method',
  '会员费可在到期前自动从账户中扣除。': 'Membership fees can be automatically deducted from your account before they expire.',
  取消自动续费设置: 'Cancel automatic renewal setting',
  可以从会员页面更改: 'Can be changed from membership page',
  信用卡: 'Credit Card',
  '※汇率按照“xx日元=xx元”计算': 'The ※ exchange rate is calculated according to "xx $ = xx CNY"',
  服务: 'service',
  line客服: 'Customer service line',
  计划更改为: 'Plan changed to',
  国際料金表: 'International Fee Schedule',
  国内运费2: 'Domestic freight',
  $商品基础信息$: 'Product Information',
  'THE CKB': 'THE CKB',
  chrome插件: 'KAERU Tools',
  插件简介: 'China Product Research Ordering Made Easier!',
  该用户名已被注册: 'This username is already in use.\n Please enter a different username.',
  '验证码正在发送到您的邮箱，请注意查收': 'The verification code has been sent to your registered e-mail address. Please check and enter the verification code.',
  合計: 'Total',
  整单确认: 'By shipping request form',
  按SKU确认: 'Per SKU',
  涉及药事法: 'Narcotics, pharmaceuticals, quasi-drugs, medical devices',
  涉及食品法: 'Food related',
  带电池: 'Goods with batteries attached',
  木制品: 'Wooden products',
  侵权产品: "Goods that infringe on patent rights, utility model rights, design rights, trademark rights, copyrights, neighboring rights, or breeder's rights",
  '粉末，液体，以及易燃易爆物品': 'Powders, liquids, flammable substances',
  '武器配件，管制刀具等': 'Guns, rifles, machine guns, cannons, ammunition and parts of guns',
  动植物产品: 'Animal and plant related',
  不满足发货重量要求: 'Shipping weight requirements are not met',
  价格过高: 'Freight rate of your designated carrier is too high',
  '订单仍在进行中，当前产生的费用并不是最终实际费用': 'The cost has not yet been determined because the order has not yet been cleared. Please note.',
  市场商品采购费: 'Market Merchandise Purchase',
  既成品采购费: 'Off-the-Shelf Purchasing',
  次品重买: 'Defective Item Repurchase',
  商品组合: 'Merchandise Combination',
  入库费: 'Warehousing',
  '{member}に変更予定': 'Scheduled Change to {member}',
  保管料: 'storage fee',
  吊り札掛け: 'Hang a tag',
  段ボール外箱: 'corrugated box',
  自社ブランド発送袋: 'Own company brand shipping bag',
  $接受次品重拍文案$: 'If you specify "Product Exchange", you can exchange each product up to X times free of charge.\nExisting item purchase fee will be charged each time after X times (maximum number of exchanges is 3 times).\nIf the number of automatic exchanges reaches the maximum (3), the response method can be set using the "Abnormal Order Settings".Market purchases and exchanges are not included in the number of retakes.',
  $次品退货退款文案D2C$: 'If you select 【Returns and Refunds】, defective products will be automatically returned to the store and the merchandise price will be automatically refunded, and your order will be automatically canceled.',
  '当您采购的商品价格出现变化时，或不能采购时我们将为您寻找其他相同的商品，所以请告诉我您能接受的价格变动幅度。': 'Please enter the maximum purchase unit price. If a product cannot be purchased at the specified store, another store will be searched based on the set unit price limit.',
  '接受次品重拍，有助于我们更好的为您完成C端订单': 'Select a recommendation of THE CKB',
  '入金反映：約1営業日': '',
  '※週末、祝日・振替休日の振込は、翌営業日扱いとなります。': '',
  // Remittances for ※ weekends, holidays and transfer holidays will be processed on the next working day.
  '振込日、振込依頼人、お受取人名、振込金額の情報が含まれる画像をお願いします。': 'Please provide the file containing the below transfer info: payment date, payment amount, payee name.',
  '※資金チャージ、各店舗への資金振替、会員費支払いのみ対応可能': '※ funds recharge, funds transfer to each store, can also pay membership fees',
  '発注は店舗で行いますので、': 'Before placing order,',
  'ご注文前に、まず振替による店舗へ資金を移動する必要があります': 'you need to transfer the funds to your store first which need to place order.',
  $商品组合信息$: 'Product Information',
  '※同じsku商品の中で1点を採寸します': '※ the size of a product in the same sku product.',
  skuの全商品採寸を希望する場合はカスタマーサービまでご連絡してください: 'If you want all sku product sizes, please contact customer service',
  'ご注意ください：': 'Please note:',
  '新商品確認サービスでは、サンプルの撮影と採寸を行います。': 'In the new goods confirmation service, the shooting and size of the sample are carried out.',
  '同じSKUで複数の商品をご購入の場合でも、確認対象は一つの商品に限定されます。': 'Even in the case where a plurality of products are purchased in the same SKU, the confirmation object is limited to one product.',
  '商品与运输方式不匹配，THE CKB为您推荐了更合适的运输方式，需要您进行确认': 'The currently selected shipping company is unable to ship (some products are infringing or do not meet the shipping conditions), we recommend change the shipping company.',
  主: 'Master account',
  子: 'Sub-account',
  'で中国輸入代行サービス体験可能！': 'Can experience China import agent service!',
  不可展示多于X个选项: 'You cannot show more than X options',
  次品退货退款: 'Returns and refunds',
  '订单中所有商品的状态为“已检品”或“已取消”时，清算订单': 'Change the status of all items in your order to "Inspected" & "Canceled" to clear your order',
  '正在发送请求，请稍侯': 'Please wait while the request is being sent',
  余额支付: 'Pay from balance',
  请阅读: 'Please read',
  '1688、タオバオ、TMALL公式サイト検索': '1688, Taobao, TMALL official website search',
  请选择需要的项目: 'Please select the desired project',
  发货设置: 'Abnormal Order Settings',
  '当直发单中存在「全网断货」或「次品重拍到上限」的商品时，是否允许THE CKB直接取消发货任务': 'When the items are abnormal (the whole network is out of stock, the number of rebuy reaches the limit, etc.), set whether to automatically cancel the order.',
  '遇到该场景时，需要每次都通过异常联络联系': 'Confirm with me whether to cancel the order',
  '遇到该场景时，若商品为普通商品则无需询问，剩余商品正常发货；': '<strong>Set items: </strong>Confirm with me if you need to cancel',
  '若为组合商品的子商品，则需要每次都通过异常联络联系': '<strong>Non-set items: </strong>Automatically cancel the order. If there are multiple items in the order, only the items in normal condition will be shipped.',
  '采购商品时，没有指定类目附加项时，使用全部附加项，两者不重复': 'When ordering from the cart, if there is no default option set for each category, the default option that has already been applied to all products will be used.',
  '当您订单下有该类目商品时，我们将默认为您添加以下附加服务': 'When ordering from the cart, if the default options for each category have already been set, the options for the products ordered in that category can be set automatically.',
  '規格：M': 'Specification: M',
  '表地：綿100％': 'surface: 100% cotton',
  '表地：': 'surface:',
  '綿100％': '100% cotton',
  注意事項: 'Precautions',
  '1.色物の場合は、洗濯時に多少色落ちすることがありますので、他の洗濯物との混入はお避け下さい。また、汗や湿った状態での摩擦により、色落ちが生じる恐れがあります。': '1.If it is a colored fabric, it may fade when washed, so please avoid mixing it with other clothes. Friction in a humid environment may cause fading. ',
  '2.洗濯後多少の縮みがあります。': '2.Clothes may shrink a little after washing.',
  '3.生成り、淡色製品には蛍光増白剤が入っていない洗剤をご使用下さい。': '3.Please use detergent without optical brighteners to wash dark or light-colored products.',
  明細: 'Details',
  入金領収書ダウンロード: 'Collection Receipt Download',
  出库费: 'Shipping operations',
  未設定: 'Not set',
  '支払依頼書とは、<br/>システム口座自動引落以外の料金が発生した場合、利用者に対して追加で料金を請求する書類です。<br/>利用者が支払いの請求を承認した時点でシステム残高から料金をお引き落としいたします。<br/>※注意点：発行日から7日以内にお支払いがご確認できない場合、自動で料金をお引き落としさせて頂きます。': 'Debit authorization is a document that collects additional fees from the user when fees other than the automatic deduction of system account occur. <br/> When the user approves the payment request, the fee will deducted from the system balance. <br/>※ note: if the payment cannot be confirmed within 7 days from the date of issue, will deduct the fee automatically.',
  韩文名: 'Korean name',
  英文名: 'English notation',
  请输入手机号: 'Please enter phone',
  请输入邮编: 'Please enter zip code',
  追跡番号自動反映: 'Tracking No. Auto Sync',
  '每一个商品需要上传一个对应的标签文件，格式为PDF，参考如下': 'Upload each product label in PDF format',
  配送: 'Distribution',
  国际发货合计额: 'Total International Shipping Amount',
  '部分图片读取失败，请按需手动下载，正在开启自动下载': 'Some images could not be loaded.\n Please download manually if necessary.\n Automatic download is enabled.',
  店铺: 'shop',
  中国買付を強力にサポートする機能を多数利用可能: 'Can use a lot of strong support for China procurement function',
  'THE CKB会員なら': 'If the member is a THE CKB',
  'もっと充実した中国仕入れサービスを利用可能！さらに、お得な会員限定特典満載！': 'Can use more substantial Chinese procurement services! More cost-effective membership limited discount full load!',
  箱规: 'Box gauge',
  已支付: 'Payment has been made',
  使用客户商品sku: 'Use customer SKU',
  $次品退货退款文案$: 'Once we received the defective item(s) from the supplier.<br/>If you do not specify "return and refund", we will confirm how to deal with the defective items with you.We recommend that you specify the handling method in advance, as the product will delay in a waiting state until you instruct us to handle it, which may lead to a delay in delivery.',
  '$THE CKB通用纸箱说明$': 'Use of high-strength and sturdy cardboard boxes for international shipping, high quality and well-stocked.',
  国际发货详情2: 'International Shipment Details',
  '金额（元）': 'Amount (RMB)',
  重量差补扣: 'Additional amount billed due to weight difference',
  国际运费补扣总和: 'Total amount of additional international shipping charge',
  退款: 'International Shipping Refund',
  '※运输公司称重比我司称重的情况下，需要补扣差额。': '※If the shipping company invoice weight is heavier than THE CKB invoice weight, we will add a deduction for the difference in international shipping costs.',
  '該当物流会社のステータスは表記できないため、お手数ですが、下記参考ファイルに追跡URLをご確認くださいませ': 'Because the status of the logistics company cannot be marked, please confirm the tracking URL of the following reference documents.',
  '参考ファイル：': 'Reference file:',
  国際送料: 'International freight',
  本次实付商品代金: 'Down Payment (Down Payment)',
  待支付商品代金尾款: 'Product Price (Balance)',
  'クリックすると、商品の作業履歴をご確認いただけます！': 'Click to confirm the work history of the goods!',
  快递公司: 'Shipping Company',
  按照建议运输方式发货: 'Change to recommended shipping company',
  保持原运输方式发货: 'Shipped by designated shipping company',
  '如果此单使用多种运输方式，提交后将会拆分成多个国际发货单子单': 'Please note! If more than one shipping company is used, the international shipping request will be split into multiple shipments.',
  批量处理: 'Change all selections at once',
  此国际发货单已取消发货: 'Cancellation of the relevant shipping invoice is completed.',
  '成功，此国际发货单将按照建议运输方式发货': 'Select a recommendation of THE CKB',
  '成功，此国际发货单将保持原运输方式发货': 'No change of shipping company (designated shipping company)',
  ダウンロード: 'Download',
  X期金额: 'Xth Period Commodity Price',
  本期冻结总价: 'Product price (down payment)',
  '每行一个（支持excel复制黏贴）': 'Enter one item per line, press Enter to break line\nExcel data can be pasted directly\n※You can search up to 500 items',
  'お客様申請(発送キャンセル済)': "Customer's request (Shipping has been canceled)",
  'お客様申請(発送キャンセル済・在庫保有)': "Customer's request (canceled shipment, in stock)",
  'カラー・サイズ不明': 'Color/size unknown',
  異常注文処理履歴: 'Abnormal Order Processing History',
  在庫切れ: 'Out of Stock',
  予約販売: 'Pre-order',
  最小注文ロット数あり: 'There are minimum order lot numbers',
  '不良品(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)': 'Defective product (Even if the maximum number of automatic restocking has been reached, there is not enough good inventory available for shipment)',
  '不良品(不良品対応設定で「返品返金」ご指定)': 'Defective product (specify "Returns & Refunds" in the "Defective Product" setting)',
  '在庫切れ(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)': 'Out of stock (even if the maximum number of automatic re-stocking has been reached, there is not enough stock of good items available for shipment)',
  全サイト在庫切れ: 'Out of stock on all websites',
  在庫切れ再発注完了: 'Out of Stock. Re-order completed.',
  不良品返品完了: 'Return of defective products completed',
  '在庫切れ(自動再仕入れ回数上限に達した)': 'Out of stock (automatic restocking limit reached)',
  '不良品(自動再仕入れ回数上限に達した)': 'defective product (automatic restock limit reached)',
  出荷保留解除方式: 'Delivery Reservation Release Method',
  手動解除: 'Manually disarm',
  '指定時間に自動解除（手動で早期解除可能）': 'Automatic release at the specified time (can be manually released in advance)',
  解除時間: 'Release time',
  '※実振込の名義と同一である必要あり。入力間違いにご注意下さい': 'The ※ must be in the same name as the actual remittance. Please note the input error',
  お知らせ: 'Notifications',
  'キャンセルすると、入力した内容が全て削除されます<br/>続行してもよろしいでしょうか': 'If canceled, all the entered contents will be deleted <br/> can you continue?',
  '銀行振込(従来)': 'Bank Transfer (Previous)',
  偏远地区费: 'Long Distance Shipping Fee',
  超长费: 'Oversize Charge',
  改派费: 'Change of delivery address fee',
  扣件费: 'Shipping Stop Fee',
  退件费: 'Return shipping fee',
  销毁费: 'Disposal fee',
  仓储费: 'Logistics warehousing fees',
  关税: 'Customs duties',
  特殊处理费: 'Special handling fees',
  我司请求重量: 'THE CKB invoice weight',
  补扣: 'Additional Charges',
  订单应冻结金额: 'Amount to be received.',
  利用规约: 'Terms of Use',
  '銀行名が見つからない 手動で入力': 'Unable to find bank name entered manually',
  データなし: 'No data',
  分期付款: 'Go to Payment',
  に到着予定: 'Scheduled Arrival',
  '配達が遅れています。': 'The delivery was late.',
  '現在催促中でしばらくお待ち下さい。': 'Please wait a moment while it is being urged.',
  何かご問題があればカスタマーサービスまでお問い合わせ下さい: 'If you have any questions, please consult customer service.',
  '支持韩文/英文搜索': 'Support English search',
  到着予定時間: 'Estimated Time of Arrival',
  中国国内運送追跡番号: 'China Domestic Shipping Tracking No.',
  輸送中: 'In transport',
  配達済み: 'Delivered',
  '商品は受け取り済みで、入庫手配中です。1営業日以内に入庫完了予定です。暫くお待ちください。': 'The goods have been received and are being put into storage. They are expected to be put into storage within 1 working day. Please wait a moment.',
  荷物: 'Baggage',
  クリックすると配送状況を確認: 'Click to confirm delivery status',
  '現時点では追跡情報を取得できません。暫くしてからもう一度お試し下さい': 'Logistics information cannot be obtained at present, please try again later.',
  '引き落としに成功した場合は、商品を発送いたします。': 'If the debit is successful, we will ship the item(s).',
  '残高不足の原因で引落できなかった場合は、出荷作業を停止して別途支払のご案内をお送りいたします。': 'If the debit was not successful due to insufficient balance, we will stop the shipping process and send a separate payment notice.',
  'ご入金確認ができ次第、商品を発送いたします。': 'We will ship the merchandise as soon as we receive confirmation of payment.',
  '発送の影響を与えるないように、商品発送前にはシステム口座に十分な残高を用意しておいて下さい。': 'Please make sure that you have a sufficient balance in your system account before shipping the merchandise so as not to affect the shipment.',
  商品条码上传方式: 'Product SKU Upload Settings',
  点击查看更多: 'For detailed instructions, please click here.',
  '此单包含X种运输方式，生成了Y个国际发货单': 'This document contains X modes of transportation and generates Y international shipment documents.',
  サービス: 'Service',
  请选择解除方式: 'Please select the termination method',
  '抱歉，当前直播内容暂不支持观看': 'Sorry, the current live streaming does not support watching',
  请选择时间: 'Please select a time',
  下面的检索结果都是1688官方的精选商品: 'The following search results are all 1688 official selected products.',
  '搜索1688官方精选供应商以外的店铺时，请使用URL直接搜索或KAERU工具进行对应': 'When searching for stores other than 1688 official selected suppliers, please use URL direct search or KAERU tool for correspondence.',
  '「1688官方精选，指根据以下内容内部选定的商店」': '"1688 Official Selection means a store selected internally based on 」',
  '·良品率高·价格竞争力高于其他店·1688畅销商品': '-High rate of good products, higher price competitiveness than other stores, 1688 best-selling goods.',
  '『精选供应商的保证条件』': '"Conditions of Guarantee of Selected Suppliers 』',
  '·购买后48小时内店铺发货・7天无理由退货・比其他店铺更快速退款': 'The store delivers goods within 48 hours after purchase, returns goods within 7 days without reason, and refunds faster than other stores.',
  '1688原价': 'original price',
  '当前会员等级享无水印图片{X}次/月，剩余{Y}次': 'The current member level can enjoy {X} times/month without watermark pictures, with {Y} times remaining',
  '※无水印图片次数说明': '※ No Watermark Picture Times Description',
  无限使用: 'Unlimited use',
  '{X}次/月': '{X} times/month',
  升级会员享无限次: 'Unlimited upgrade membership',
  '抱歉，您的无水印次数已达上限，升级会员享受无限次。': 'Sorry, your watermark-free times have reached the upper limit, upgrade members enjoy unlimited times.',
  '您当前的会员等级，可享无限次“无水印”图片下载。': 'Your current membership level, you can enjoy unlimited "no watermark" image download.',
  无水印: 'No watermark',
  有水印: 'with watermark',
  同款商品: 'Same item',
  暂无相关搜索结果: 'No relevant search results',
  去站外搜更多: 'Search outside the station for more',
  重新上传图片搜索: 'Re-upload image search',
  '监测到您当前尚未安装KAERU插件，【站外搜】功能需要配合KAERU插件才可正常使用哦。': 'It is monitored that you have not installed KAERU plug-in at present, and the [off-site search] function needs to cooperate with KAERU plug-in before it can be used normally.',
  '什么是KAERU插件？': 'What is a KAERU plug-in?',
  去安装: 'To install',
  暂不安装: "Don't install",
  '1688严选': '1688 Sourcing',
  去1688严选搜: 'Go to 1688 to strictly select and search',
  查看1688官方精选供应商商品: 'View 1688 Official Selected Supplier Items',
  'THE CKB官方精选商品': 'Go straight to the official selection of goods',
  收起: 'Fold',
  详细: 'View more',
  展开: 'Expand',
  '1. 1688什么是官方精选供应商': '1. 1688 what is the official selection of suppliers',
  '是1688官方选定的价格更具竞争力的人气供应商。': 'is the 1688 official selected price more competitive popular suppliers.',
  精选供应商的特点: 'Featured Supplier Features',
  良品率高: 'high yield',
  价格比其他店铺有优势: 'The price is better than other shops',
  拥有人气畅销商品: 'Have popular best-selling goods',
  '1688严格挑选的供应商保证以下条件': '1688 strictly selected suppliers guarantee the following conditions',
  '48小时内店铺发货': 'Store delivery within 48 hours',
  '7天无条件退货': '7 days unconditional return',
  加快退款速度: 'Speed up your refund',
  '2. 什么是受欢迎的商品': '2. What is a popular commodity',
  '1688根据公式保留的内部数据，我们分析客户的购买历史，偏好，趋势等，并预测客户可能感兴趣的产品。': "1688 internal data retained according to the formula, we analyze the customer's purchase history, preferences, trends, etc., and predict the products that the customer may be interested in.",
  '3. 为什么我们可以给予低价?': '3. Why can we give low price?',
  '严格挑选的特别价格只对特定合作伙伴、企业共享。': 'Strict selection of special prices only for specific partners, enterprises to share.',
  'THE CKB通过与1688的业务合作，作为特定企业可以以特别价格购买商品，也可以提供给THE CKB的会员': 'Through business cooperation with the 1688, as a specific enterprise can buy goods at special prices, can also be provided to the members of the straight line.',
  '4. 优点是什么': '4. What are the advantages',
  '根据1所描述的精选供应商的内容和条件，可以缩短订单的交货期，提高良品率。': 'According to the content and conditions of the selected suppliers described in 1, the delivery time of the order can be shortened and the yield rate can be improved.',
  找同款: 'Find same model',
  'THE CKB会员特惠价': 'Direct member special rate',
  价格竞争力高于其他店: 'The price is more competitive than other stores.',
  '1688畅销商品': '1688 best sellers',
  必须: 'Must',
  '国家/地区': 'Country',
  用户协议: 'User Agreement',
  登录名: 'Username',
  返回上一步: 'Back to previous step',
  注册完成: 'Registration',
  邀请码: 'Invitation Code',
  '登录名/邮箱': 'Username',
  邮箱登录: 'Mailbox Login',
  '注册并绑定您的THE CKB账户': 'Register and bind your THE CKB account',
  '只需绑定一次，后续可用{platform}直接登录': 'You only need to bind it once, and you can use {platform} to login directly later.',
  确认绑定: 'Confirm Binding',
  '还没有CKB账户，现在去注册并绑定': 'There is no CKB account yet, now register and bind it.',
  去注册: 'Register',
  注册并绑定您的CKB账户: 'Register and bind your CKB account',
  只看精选会员折扣价: 'Just look at the discount price for select members',
  '抱歉，该商品暂不支持购买': 'Sorry, this product is not supported for purchase',
  '使用插件，您可以将1688等平台产品直接添加到THE CKB购物车中。': 'Using the plug-in, you can add platform products such as 1688 directly to THE CKB shopping cart.',
  首页: 'Home Page',
  '已经注册的邮件地址。请登录，进行{A}关联。': 'The registered email address. Please login for {A} association.',
  同意用户协议: 'Agree to User Agreement',
  '注册成功后登录名将无法更改。': 'Username cannot be changed after successful registration.',
  '6-32个字符': '6-32 characters',
  '字母和数字的组合(字母区分大小写)': 'A combination of letters and numbers (letters are case sensitive)',
  '已有CKB账户，去【登录并绑定】': 'If you already have a CKB account, go to [login and bind]]',
  '还没有CKB账户，现在去【注册并绑定】': 'There is no CKB account yet, now go to [register and bind]]',
  三方登录管理: 'Three-party login management',
  绑定您的CKB账户: 'Bind your CKB account',
  '是否解绑{A}账户': 'Unbind {A} account',
  绑定失败: 'Binding failed',
  '您的账户已被其他账号绑定，无法绑定当前账号。': 'Your account has been bound to another account and cannot be bound to the current account.',
  授权回调中: 'Authorization callback',
  授权成功: 'Authorization succeeded',
  绑定成功: 'Binding success',
  '我还没有CKB账户，现在': "I don't have a CKB account yet.",
  企业通关号码: 'Enterprise Customs Clearance No.',
  个人通关码: 'Personal Clearance Code',
  通关码: 'Pass code',
  '企业通关号码/个人通关码': 'Enterprise Customs Clearance Number/Personal Customs Clearance Code',
  通关码不能为空: 'Passcode cannot be empty',
  order_个人通关码: 'order_personal clearance code',
  个人通关码不能为空: 'Personal Pass Code cannot be empty',
  '相同订单下，通关码信息与第X行不一致': 'Under the same order, the customs clearance code information is inconsistent with line X.',
  同一个订单只能存在一个OEM商品下单: 'No duplicate products will be generated for the same order.',
  '根据韩国海关的要求选择附加项：': 'Select additional items according to the requirements of the Korean Customs:',
  '最终选择用企业通关来国际发货时-': 'When you finally choose to use corporate clearance for international shipments-',
  '如果是纺织品（例：衣服/被子等）': 'If it is textile (example: clothes/quilt, etc.)',
  '在下单时一定需要选择水洗标制作和水洗标缝制服务！': 'When placing an order, you must choose the water-washed standard production and water-washed standard sewing service!',
  '如果是杂货（例：发卡/文具等）': 'If it is groceries (example: hairpin/stationery, etc.)',
  '一定在发货时选择贴原产地标服务！': 'Be sure to choose the origin label service when shipping!',
  '如果不能确认请联系页面右方的客服中心服务！': 'If you cannot confirm, please contact the customer service center on the right side of the page!',
  不再提示: 'No more prompting',
  我知道了2: 'I know.',
  によるサービス提供: 'Providing services',
  注册信息隐私说明: 'Privacy Notice',
  为了告知介绍大使会员的用户名: 'In order to inform the user name of the member introducing the ambassador',
  '请不要在用户名中注册包含能够识别个人身份的信息，比如真实姓名等。': 'Please do not register a username that contains personally identifiable information, such as your real name.',
  '如果用户名中包含您的个人信息，请事先同意提供给推广者会员。': 'If the user name contains your personal information, please agree in advance to provide it to the promoter member.',
  使用新运输方式: 'Change to recommended shipping company',
  使用原运输方式: 'Shipped by designated shipping company',
  '文件大小不超过50m；支持格式doc;excel;pdf;': 'Format：doc, excel, pdf\n Capacity: 50M or less',
  '同步商品进行中，请等待1-3分钟': 'Product is being imported.Please wait 1-3 minutes.',
  '用户名或邮箱不正确，请重新输入1-10位用户名或邮箱': 'Username input error.\n Username must be within 1~18 single-byte alphanumeric characters.',
  '密码修改成功，请重新登录': 'You have successfully reset your password.\n Please login with the password you just reset.',
  '用户名不可用，请重新设置1-18位用户名不支持标点符号': 'Incorrect user name.\n Username must be within 1~18 characters.',
  输入Aucfan的注册邮箱提示: "Enter Aucfan's registration email prompt",
  目前您还没有创建店铺: 'Child account has been successfully created',
  円: '$',
  '当商品出现问题时，我们将为您免费重新换货X次。超过X次每次Y元，最多不超过Z次。当不勾选时，每次出现次品时，我们都会询问您的意见，在进行处理，会影响您的购买效率。': 'If you specify "Product Exchange", each product can be exchanged up to X times free of charge.\n If you exchange more than X times, you will be charged Y CNY/exchange fee (maximum exchange is Z times).\n If you specify "Returns and Refunds", you can automatically return defective items to the store and receive a refund of the product price.\n If you do not specify "return/refund", we will confirm how to deal with the defective item as soon as it is found.\n We recommend that you specify the response method in advance, as the product will remain in a waiting state until you instruct us to take action, which may delay delivery.',
  '请大致描述一下希望布料的外观或功能上的需求，如:弹性好，柔软等': 'Please describe the fabric, for example: soft fabric with excellent elasticity',
  '请大致描述一下希望改动哪些方面,如:材质、设计、颜色、尺寸等': 'Describe the changes you would like to make, for example: change of fabric, color, size, design, etc.',
  OEM样品单不能组合: 'Combination items cannot be re-combined.',
  '找到新的现货链接，是否可以购买？': '【Please confirm】\n URL found in stock.\n Please confirm whether you want to purchase or not.',
  $色差$: 'Reason for defect: Color difference<br/>Deemed defective according to inspection standards<br/>Please specify what to do in case of defect',
  $色差$2: 'Color difference<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  '文件SKU和商品列表SKU不一致，请检查后重新上传': 'Uploaded data is different from the product SKUs added, so please check the data before re-uploading.',
  跳转外链操作步骤: 'Specify the e-commerce site to search → Enter Japanese keywords → Products can be searched on the specified site',
  slogon: 'Easier More Transparent',
  系统说明: 'System Description',
  '系统说明ps(X元Y円)': 'System description ps (x CNY y $)',
  ホーム: 'Home',
  お客様申請: 'Customer Request',
  '如果您想定制其他复杂产品，比如服饰杂货等，请升级商务舱，我们会有专门的客户经理单独一对一和您对接。': 'If you wish to use OEM services for non-materials (apparel, general merchandise, etc.), please change to Business Class in your membership plan.\nThe development process of non-material OEM products is longer and more complicated than that of materials.\nFor Business Class, we can provide more detailed and efficient services with our dedicated staff with rich OEM experience.',
  $通电不良$: 'Reason for defect: Poor electrical<br/> Deemed defective according to inspection standards<br/>Please specify the action to be taken in case of defective products',
  $通电不良$2: 'Poor electrical<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  $其他不良$: 'Reason for defect: Other. <br/>The product was determined to be defective according to the inspection criteria. <br/>Please specify the action to be taken when a defective product is detected.',
  $其他不良$2: 'Other.<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  '$污渍/斑点/水印$': 'Reason for defect: Stains, stains, or water spots are present<br/>Deemed defective according to inspection standards<br/>Please specify what to do in the event of a defective product.',
  '$污渍/斑点/水印$2': 'Stains, stains, or water spots are present<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  $破损$: 'Reason for defect: Damaged<br/>Deemed defective according to inspection criteria<br/>Please specify what to do when defective items occur',
  $破损$2: 'Damaged<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  $线头$: 'Reason for defect: Lint and fraying<br/>Deemed defective according to inspection standards<br/>Please specify what to do when defective items occur',
  $线头$2: 'Lint and fraying<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  $接缝不良$: 'Reason for defect: Defective tangent<br/>Deemed defective according to inspection standards<br/>Please specify the action to be taken when the defective product occurs.',
  $接缝不良$2: 'Defective tangent<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  $抽丝$: "Reason for defect: It's got a run.<br/>Deemed defective according to the inspection criteria<br/>Please specify the action to be taken when the defective product occurs.",
  $抽丝$2: "It's got a run.<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery",
  $针眼$: 'Reason for defect: Needle hole<br/>Deemed defective according to inspection standards<br/>Please specify what to do in case of defective products',
  $针眼$2: 'Needle hole<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  $霉菌$: 'Reason for defect: There is mold<br/>Deemed defective according to the inspection criteria<br/>Please specify the action to be taken when the defective product occurs.',
  $霉菌$2: 'There is mold<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  $生锈$: 'Reason for defect: There is rust<br/>Deemed defective according to the inspection criteria<br/>Please specify the action to be taken in case of defective products.',
  $生锈$2: 'There is rust<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  $商品有中文$: 'Reason for defect: Description in Chinese<br/>Deemed defective according to inspection standards<br/>Please specify what to do in case of defective products.',
  $商品有中文$2: 'Description in Chinese<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  $纽扣破损$: 'Reason for defect: Bodan damaged<br/>Deemed defective according to inspection standards<br/>Please specify the action to be taken in case of defective products.',
  $纽扣破损$2: 'Bodan damaged<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  $拉链破损$: 'Reason for defect: Broken zipper<br/>Deemed defective according to the inspection criteria<br/>Please specify the action to be taken when the defective item occurs.',
  $拉链破损$2: 'Broken zipper<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  $附属品缺陷$: 'Reason for defect: Defective accessory<br/>Deemed defective according to inspection standards<br/>Please specify the action to be taken when the defective product occurs.',
  $附属品缺陷$2: 'Defective accessory<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  $有气味$: 'Reason for defect: Smell is present<br/>Deemed defective according to inspection criteria<br/>Please specify what to do when defective products occur',
  $有气味$2: 'Smell is present<br/>No possibility of improvement of defective products even if exchanged (due to lot production)<br/>* Large number of problem products, large possibility of delay in delivery',
  及: 'and',
  '4.当前仅支持日本地址导入': '4. Non-Japan addresses are not accepted for Excel bulk orders',
  '商品总额(￥)': 'Total value of goods (RMB)',
  商品总额: 'Total value of goods',
  '附加项总额(￥)': 'Total Product Option Amount (RMB)',
  附加项总额: 'Total Product Option Amount',
  '总计(￥)': 'Total Amount (RMB)',
  '单价(￥)': 'Unit price (RMB)',
  '附加项金额(￥)': 'Total amount of merchandise options (RMB)',
  附加项金额: 'Total amount of merchandise options',
  '小计(￥)': 'Subtotal (RMB)',
  '该商品近30天不良率超过X%，请谨慎选择。': 'The deficiency rate of the relevant item exceeds X%. We recommend that you purchase from a different store.',
  '该商品近30天回货速度慢，请谨慎选择。': 'The shipping speed of the relevant store is below average. It is recommended to purchase from a different store!',
  '※商品不良包含：次品、到错货、多件/少件情况。': 'The item is considered defective if any of the following apply: defective, different, or missing item.',
  '※回货时长超过15天。': '*It takes more than 15 days to ship.',
  '当前订单包含需采购的商品，如遇到商品无法采购等情况导致取消时，将通过异常联络通知您，您可在': 'The current order contains goods to be purchased. If the goods cannot be purchased and other circumstances lead to cancellation, you will be notified through abnormal contact. You can',
  中更改默认项: 'Change the default item in',
  '超过组合sku数量，一个组合商品至多由30种不同单品sku组成': 'No sets are allowed; a maximum of 30 SKUs of single items can be set in a single order.',
  $次品重拍达到上限$: 'Automatic re-stocking limit has been reached.',
  $全网断货$: 'Out of stock at all sites',
  '请输入国家/地区': 'Please enter a country/region',
  日文名: 'Japanese notation',
  SKU规格: 'Specifications',
  请先配置默认物流信息: 'Please try again after setting the shipping company.',
  商品发货详情: 'Commodity delivery details',
  商家虚假发货: 'False shipment on the store side',
  物流揽收超时: 'Logistics acceptance delay',
  物流周转超时: 'Logistics transfer delay',
  物流停滞: 'Logistics Stagnation',
  '运力不足，物流缓慢': 'Delivery delay due to insufficient transportation capacity',
  '天气因素，物流缓慢': 'Delivery delays due to bad weather',
  '节日因素，物流缓慢': 'Delivery delays due to public holidays',
  去找同款: 'Find Similar Products',
  余额不足: 'Insufficient balance',
  确定支付: 'Confirm',
  本期支付: 'Amount of this payment',
  '当前账户余额不足，请先充值。': '【Insufficient Balance】 Please check your Sub-account balance before recharging funds.',
  已支付金额: 'Paid Amount',
  待支付金额: 'Amount Not Paid',
  运输公司请求重量: 'Shipping company invoice weight',
  箱标: 'Box Label',
  次品退款: 'Refund for defective products',
  本期支付金额: 'Product Price (Down Payment)',
  '订单已生成，生成订单信息如下请随时关注订单动态': 'Order Complete. Please check the progress from Order Status.',
  同一个寻源单不能同时下大货和样品: 'Finished products and samples cannot be produced at the same time on the same document.',
  直播价: '【Live streem】Special price',
  直播中: 'Live streaming',
  去预约: 'Reservation for live stream',
  钱包余额不足: 'Please charge your missing account balance',
  直播回放: 'Live Playback',
  观看回放: 'Watch Playback',
  'Citibankの内部調整に伴い、2023年9月11日（月）19:30（日本時間）より、銀行振込（Citibank）振込サービスを停止させていただけます今後、システムへのチャージは、銀行振込（みずほ銀行）、Paypal、クレジットカードを通じてご利用いただけます。': "With the internal adjustment of Citibank, starting from 19:30 (Japanese time) on September 11, 2023 (Monday), the bank transfer (Citibank) remittance service will be discontinued. In the future, the system's recharge can be used through bank transfer (Mizuho Bank), PayPal, and credit card.",
  'お客様申請(仕入れキャンセル済)': 'Customer request (purchase cancelled)',
  中国国内運送状況: 'Domestic transportation status in China',
  登录失败: 'Logon failure',
  '该地区不支持访问，请求地址': 'Access is not supported in this region, request address',
  用户IP: 'User IP',
  点这里给我们发送错误报告: 'Click here to send us a bug report',
  订单商品总数量: 'Total Quantity',
  行目: 'Line',
  エラーメッセージ: 'error message',
  邮箱验证码登录: 'Email login',
  手机号验证码登录: 'Phone Number Login',
  店铺余额: 'Balance',
  手机验证码: 'Code',
  '手机号格式不正确，请重新输入': 'The phone number format is incorrect, please re-enter',
  使用邮箱找回密码: 'Use email to retrieve password',
  使用手机号找回密码: 'Use TEL to retrieve password',
  '验证码正在发送，请注意查收': 'The verification code is being sent, please check it carefully.',
  手机号验证码: 'Mobile phone number verification code',
  手机号登录: 'Mobile Phone Number Login',
  折扣价: 'Discount price',
  品牌集: 'Brand Portfolio',
  '请输入主营类目、品牌名称或风格': 'Please enter the main category, brand name or style',
  什么是品牌集: 'What is a brand portfolio',
  主营类目: 'Main Category',
  '可授权形式：全部，普通授权、独家授权': 'Authorized form: all, ordinary authorization, exclusive authorization.',
  '均价范围，全部，自定义': 'Average Price Range, All, Custom',
  申请中: 'Application',
  地址: 'Address',
  平均客单价: 'Average customer unit price',
  授权类型: 'Authorization Type',
  品牌风格: 'Brand style',
  产品理念: 'Product concept',
  品牌说明书: 'Brand Instruction',
  授权申请: 'Authorization Application',
  收起筛选: 'Collapse Filter',
  展开更多: 'Expand More',
  距离授权到期仅剩3天: 'Only 3 days until the license expires',
  品牌授权已过期: 'Brand license expired',
  '品牌店铺已关注，请前往商品管理-我的收藏中查看': 'Brand stores have paid attention to, please go to commodity management-my collection to check',
  品牌店铺已取消关注: 'Brand store has canceled attention',
  所有商品: 'All commodities',
  '7日上新': 'New on 7 days.',
  请输入商品名称: 'Please enter product name',
  '请前往进行品牌授权后，方可购买': 'Please go to the brand authorization, can purchase',
  新增授权任务: 'Added authorized tasks.',
  品牌图片: 'Brand Image',
  品牌信息: 'Brand Information',
  品牌名称: 'Brand Name',
  品牌链接: 'Brand Link',
  授权条件: 'Authorization Conditions',
  授权条件1: 'Authorization Conditions',
  可授权类型: 'Authorizable Type',
  申请授权类型: 'Request authorization type',
  '用途，请输入': 'Purpose, please enter',
  销售平台: 'Sales Platform',
  销售网站商品名: 'Sales Site Product Name',
  平台链接: 'Platform Link',
  预计月采购额: 'Estimated monthly purchase amount',
  预计年采购额: 'Estimated Annual Purchases',
  其他补充说明: 'Other supplementary notes',
  是否需要联名: 'Joint name required',
  联名需求描述: 'Joint Demand Description',
  保存并发布: 'Save and Publish',
  '授权已保存，可在工作台-品牌管理查看授权进度。': 'The authorization has been saved and the authorization progress can be viewed in the workbench-brand management.',
  前往查看: 'Go to view',
  '提交授权申请后，THE CKB工作人员会在XX个工作日内联系您。可在工作台-品牌管理查看授权进度。': 'After submitting the authorization application, the ckb staff will contact you within XX working days. You can view the authorization progress at Workbench-Brand Management.',
  下载授权书: 'Download Authorization',
  优质供应商: 'Quality Supplier',
  目录: 'Directory',
  供应商优势: 'Vendor Advantage',
  基础信息: 'Basic information',
  热卖产品: 'Hot Products',
  品牌授权书: 'Brand Authorization Letter',
  品牌授权: 'Brand Authorization',
  申请类型: 'Application Type',
  申请日期: 'Date',
  开始日期: 'Start Date',
  新增品牌授权: 'New Brand Authorization',
  待提交: 'To be submitted',
  审核中: 'Under review',
  品牌URL: 'Brand URL',
  申请信息: 'Application Information',
  审核信息: 'Review Status',
  授权有效期: 'Validity Period',
  普通授权: 'Ordinary Authorization',
  独家授权: 'Exclusive license',
  重新申请: 'Re-apply',
  审核详情: 'Audit Details',
  通过: 'pass through',
  '是否确认提交？': 'Confirm submission?',
  '是否确认取消？': 'Confirm cancellation?',
  品牌授权通知: 'Brand Authorization Notice',
  品牌授权申请通过: 'Brand authorization application passed',
  '您申请的XXXX品牌授权通过，可前往商城购买品牌商品或查看授权书。': 'You apply for XXXX brand authorization through, you can go to the mall to buy brand goods or view the authorization.',
  授权详情: 'Authorization Details',
  品牌详情: 'Brand Details',
  品牌授权申请失败: 'Brand authorization application failed',
  '您申请的XXXX品牌授权失败，原因为：': 'Your application for XXXX brand authorization failed due:',
  品牌授权即将过期提示: 'Brand license is about to expire',
  '您申请的XXXX品牌授权将在2023-12-31日过期，请前往处理。': 'The XXXX brand authorization you applied for will expire on 2023-12-31, please go to process.',
  品牌授权过期: 'Brand license expired',
  '您申请的XXXX品牌授权已过期，请前往处理。': 'The XXXX brand license you applied for has expired, please go to process.',
  '如下所示，您的品牌授权申请通过了': 'As shown below, your brand license application passed',
  授权期限: 'Duration of authorization',
  '如下所示，您的品牌授权申请失败了': 'As shown below, your brand license application failed',
  '如下所示，您的品牌授权即将在3天后过期，请前往处理。': 'As shown below, your brand license will expire in 3 days, please go to process.',
  '如下所示，您的品牌授权已过期，请前往处理。': 'As shown below, your brand license has expired, please go to process.',
  前往授权: 'Go to Authorization',
  '存在部分商品未授权，请查看详情并申请授权': 'Some products are not authorized, please check the details and apply for authorization.',
  我收藏的品牌: 'Favorite Brands',
  可授权形式: 'Authorized form',
  均价范围: 'Average Price Range',
  '距离授权到期仅剩{day}天': 'Only {day} days until the license expires',
  用途: 'Purpose',
  '预计月采购额（円）': 'Estimated monthly purchase amount($)',
  '预计年采购额（円）': 'Estimated Annual Purchases($)',
  '提交授权申请后，THE CKB工作人员会在{day}个工作日内联系您。可在工作台-品牌管理查看授权进度': 'After submitting the authorization application, the ckb staff will contact you within {day} working days. You can view the authorization progress at Workbench-Brand Management.',
  '授权已保存，可在工作台-品牌管理查看授权进度': 'The authorization has been saved and the authorization progress can be viewed in the workbench-brand management.',
  '前往查看>': 'Go to view >',
  '前往授权>': 'Go to Authorization >',
  密码修改成功: 'Password modified successfully',
  '该手机号已被注册，请重新输入': 'The phone number has been registered, please re-enter',
  '手机号验证码不正确，注册失败': 'Mobile phone number verification code is incorrect, registration failed',
  '手机号验证码不正确，登录失败': 'Mobile phone number verification code is incorrect, login failed',
  '验证码正在发送，请注意查收。': 'The verification code is being sent, please check it carefully.',
  '已发送验证码请求，请勿重复发送请求': 'The verification code request has been sent, please do not repeat the request.',
  进入品牌: 'Enter the brand',
  联名品牌: 'co-branding brand',
  联名: 'co-branding',
  不联名: 'Disjoint name',
  操作后状态: 'Status after operation',
  品牌已下架: 'Brand removed',
  前往品牌列表: 'Go to Brand List',
  '前往品牌列表>': 'Go to Brand List>',
  查看全部: 'View All',
  普通授权字段说明: 'Common Authorization Field Description',
  独家授权字段说明: 'Exclusive License Field Description',
  '品牌集的优势介绍 给用户带来什么': 'What does the introduction of the advantages of brand set bring to users',
  销售平台不能为空: 'Sales platform cannot be empty',
  联名品牌不能为空: 'Co-brand cannot be empty',
  '品牌集的优势 用户可以获得哪些权益，在品牌集购买商品有什么优惠等等': 'When buying and selling Chinese brands, a brand license is required.Now THE CKB has obtained independent sales rights for some Chinese brands, and you can see the collection of these brands here!You can apply for brand selling rights through THE CKB, and if you reach a certain purchase volume, you can apply for exclusive selling rights!The attractions of brand licenses are (1) market competitiveness (2) inventory stability (3) originality. After obtaining the exclusive right to sell the brand, you can freely set the price and stabilize the sales, thus increasing the competition in the market.',
  寻找: 'Looking',
  请填写邮箱: 'Please enter the mailbox',
  次品重买1: 'Defective Item Repurchase',
  资金明细3: 'Funds Details',
  商品附加项1: 'Product Options',
  商品附加项2: 'Product Options',
  手机重置密码: 'Phone number reset password',
  押金1: 'Deposit',
  全检1: 'Total inspection',
  件2: 'items',
  公司英文名: 'English notation',
  服装类目: 'Clothing category',
  杂货类目: 'Groceries category',
  圣诞节HOT商品: 'Christmas hot products',
  展开更多2: 'See more',
  没有搜索结果: 'No search results',
  默认1: 'Default',
  找相似1: 'Find Similar Products',
  英文名1: 'English notation',
  请选择附加项3: 'Please select product options',
  选择物流公司1: 'Shipping Company',
  价格1: 'Price(CNY)',
  注意3: 'Please note',
  起订量1: 'MOQ',
  使用邮箱注册: 'Email Registration',
  使用手机号注册: 'Phone registration',
  已取消1: 'Canceled Authorizations',
  收起筛选条件: 'Put away the filter conditions',
  展开筛选条件: 'Expand filter conditions',
  筛选条件1: 'Filter conditions',
  '密码的新建/变更': 'Password Creat/Change',
  批量修改物流: 'Batch Modify Logistics',
  采购均价: 'average price',
  '默认物流不可发该国家，请重新选择': "Default logistics can't ship to this country, please re-select",
  '第{day}期': '{day}th billing',
  '商品的供应商次品多，无法购买': "※The factory's product defect rate is high and cannot be purchased.",
  '※商品的供应商次品多，无法购买': "※The factory's product defect rate is high and cannot be purchased.",
  '商品侵权，无法购买': 'The product cannot be purchased due to possible infringement of intellectual property rights.',
  '※商品侵权，无法购买': 'The product cannot be purchased due to possible infringement of intellectual property rights.',
  '商品次品过多，无法购买': 'The product has a high defect rate and cannot be purchased.',
  '※商品次品过多，无法购买': 'The product has a high defect rate and cannot be purchased.',
  '商品缺货，无法购买': 'The product is discontinued and cannot be purchased.',
  '※商品缺货，无法购买': 'The product is discontinued and cannot be purchased.',
  '商品为易燃易爆产品，无法购买': 'The product is flammable and other dangerous goods and cannot be purchased.',
  '※商品为易燃易爆产品，无法购买': 'The product is flammable and other dangerous goods and cannot be purchased.',
  '商品为液体，无法购买': 'This product is a liquid and cannot be purchased.',
  '※商品为液体，无法购买': 'This product is a liquid and cannot be purchased.',
  '商品为仿牌，无法购买': 'Cannot be purchased because it is a counterfeit or pirated product.',
  '※商品为仿牌，无法购买': 'Cannot be purchased because it is a counterfeit or pirated product.',
  '商品为粉末，无法购买': 'Cannot be purchased because it is a powdered product.',
  '※商品为粉末，无法购买': 'Cannot be purchased because it is a powdered product.',
  '商品为未防腐处理木制品，无法购买': 'This product cannot be purchased because it is a wood product that has not been treated with methyl bromide.',
  '※商品为未防腐处理木制品，无法购买': 'This product cannot be purchased because it is a wood product that has not been treated with methyl bromide.',
  '商品为管制刀具，无法购买': 'This product is a sword and cannot be purchased.',
  '※商品为管制刀具，无法购买': 'This product is a sword and cannot be purchased.',
  '商品为动植物，无法购买': 'This product is suspected to be a quarantine hazardous plant or animal and cannot be purchased.',
  '※商品为动植物，无法购买': 'This product is suspected to be a quarantine hazardous plant or animal and cannot be purchased.',
  黑名单商品不支持下单: 'Blacklisted products are not supported for place order',
  '该供应商次品多，无法购买': 'Purchase from this factory is not possible due to the high defect rate of products.',
  '该供应商因次品过多，无法购买其产品': 'Purchase is not possible from this factory due to the high rate of product defects.',
  请取消PayPal自动续费: 'Please cancel PayPal auto-renewal',
  '已设定Paypal的自动支付，请解除以前的Paypal自动支付。如果未解除，将自动进行费用充值。请注意，对于错误费用的退款，您将需要支付退款费用。': 'Paypal autopay has been set up.<br/>Please release the previous autopay set up. If not released, the fee will be automatically recharged. Please note that for refunds of erroneous charges, you will be required to pay a refund fee.',
  一键设置追跡番号自動反映: 'Bulk Tracking NO. Auto Sync',
  设置当前页追迹番号反映: 'Set reflect the tracking number in current page',
  开启: 'turn on',
  一件购买: '1pc purchase',
  批发: 'Wholesale',
  '建议订购数：{num}': 'Suggested order quantity: <span style="color:#E83D51;">{num}</span>',
  可享批发优惠价: 'will enjoy <span style="color:#E83D51;">wholesale price</span>',
  API自动下单设定: 'API auto order setting',
  '当自动下单的商品不满足最小起订量，且有“一件购买”价时': 'When the auto order product doesn\'t meet MOQ, and there is a "1pc purchase available" price.',
  '不询问，自动下单成功（以“一件购买”价）': 'No need to ask, auto order successful (order at the "1pc purchase" price)',
  每次询问: 'Ask me every time',
  '有最小起订量限制，价格更优惠': 'With MOQ limit, wholesale price is more favorable',
  '无最小起订量限制，可一件购买': 'No MOQ limit, 1pc purchase available.',
  支持一件代发: 'Support 1pc purchase',
  '当前订单内商品不满足最小起订量，继续下单将以“一件代发”价格下单': 'The current order does not meet the moq, continue order will purchase with "1pc purchase" price',
  '设置为自动下单，不再询问': "Auto ordering Setting Don't ask again",
  为不超过次品退货期限次品默认退货: '<br/>【※Attention】：Return of all defective products',
  '＜农历新年前希望交付的OEM订单推荐下单时间＞': '＜THE CKB purchasing advice for OEM orders before Lunar New Year＞',
  服装·杂货: 'Clothing/Grocery',
  '1月5日（星期五）': 'Suggest orders before January 5',
  截止: 'Suggest orders before',
  材料: 'Materials/Accessories',
  '1月18日（星期四）': 'Suggest orders before January 18',
  '※即使超过接单截止时间，仍然可以下OEM订单，但发货可能会延迟到2月下旬以后。': '*OEM orders can be placed after the suggested date, but shipment will be delayed until late February.',
  '※根据工厂的情况，即使在接单截止时间前下的OEM订单，也有可能在春节之后才发货。': '*OEM orders before the suggestion date may also ship after the Lunar New Year Depend on factory holiday.',
  成品采购春节停止下单时间2: '＜Cutoff date for Finished Product Purchasing Spring Festival＞',
  '１月27日': 'before January 27th',
  'Taobao・1688等': 'E-commerce sites purchase',
  '2月4日': 'before February 4th',
  '※由于部分店铺已经开始休业，2月4日之前下单的商品也有节前发不出货的可能': '※ Due to some stores have start to rest, the goods ordered before February 4, there is also the possibility of pre-holiday shipments can not be sent',
  '※2月4日（日）~2月17日（土）的订单我们也受理，统一在2月17日之后采购': '※February 4 ~ February 17 orders accept too, but will unified procurement after February 17th!',
  '※为防止断货建议1月屯两个月库存': "In case of stock-outs, it is recommended to stock two months' worth of sales in January.",
  建议春节前尽快囤货2: 'Recommended to stock up as soon as possible before the Chinese New Year',
  春节前希望发货的发货委托制作的推荐期间2: '',
  船运节前出货发货依赖截单时间2: 'Deadline for sea shipment',
  空运节前出货发货依赖截单时间2: 'Deadline for air shipment',
  '2月1日（木）19时': 'February 1, 7pm',
  '2月6日（火）19时': 'February 6, 7pm',
  截单时间之后的发货依赖可能会在节后发货: 'Please arrange shipment in advance.',
  春节期间仓库爆单请提前安排发货: '',
  '＜旧正月 OEM发货和报价申请休假通知＞': '',
  休假期间: 'factories stop OEM production',
  '2月7日（星期三）至2月17日（星期六）': 'February 7~February 17',
  '※即使在休假期间，我们仍然接受OEM发货和报价申请。': 'We are still accepting OEM shipments and quote requests even during the holiday season.',
  '我们将在旧正月过后顺序处理，请尽早提交您希望订购的商品。': 'We will process them in order after the holidays, so please submit the items you wish to order as early as possible.',
  '我们建议您尽早提出申请。': 'We recommend that you submit your request as early as possible.',
  '＜旧正月期间成品采购停业通知＞': '＜Notice of Finished Goods Purchase for Holidays＞',
  休业期间: 'Period of closure',
  '2月4日（星期日）至2月17日（星期六）': 'February 4 to February 17',
  '※即使在休业期间，我们仍然接受订单。': '※We are still accepting orders even during the holiday period.',
  '我们将在旧正月过后按顺序进行处理，请尽早提交您希望订购的商品。': 'We will process them in order after the holiday, so please submit the items you wish to order as early as possible.',
  '＜旧正月仓库停业通知＞': '＜THE CKB warehouse holiday time＞',
  'D2C（仓库发货停止）2': 'D2C',
  '2月9日（星期五）至2月14日（星期三）': 'February 9th ~ February 14th',
  'B2B（仓库发货停止）2': 'B2B',
  '2月9日（星期五）至2月17日（星期六）': 'February 9th~February 17th',
  '※即使在休业期间，仍然可以创建发货请求，但我们将按照重新开放业务的顺序进行处理。': 'Even during the holidays, shipping requests can still be created, but we will process them in the order of business reopening.',
  专属折扣价: 'Exclusive Discount Price',
  默认顺序: 'Default sorting',
  复购率: 'High Repurchase Rate',
  价格从低到高: 'Unit price from low to high',
  价格从高到低: 'Unit price from high to low',
  次品默认退货退款: '※ Defective products will be automatically returned',
  '请决定发生次品时，您的重拍设置': 'Please confirm your repurchase settings in the event of a defective item',
  留在购物车: 'Return to Cart',
  '商品SKU作用旨在区分相同商品的不同规格、尺寸、颜色等。': 'SKU used to distinguish between different specifications, sizes, colors, etc. of the same product.',
  '您可以直接填写自家店铺现有的的商品SKU，也可以额外设置新的SKU。': 'You can fill in store existing SKU directly , or set up a new SKU.',

  '用于识别不同订单。': 'Used to identify different orders.',
  '您可以直接引用自家店铺的客户订单号，': 'You can directly quote the customer order number of your own store.',
  '也可以另外输入文字区分您的订单。': 'Or text to differentiate your orders.',
  '例）': '(Example) ',
  '＜店铺订单号＞ 503-0575395-6075865': '＜Store order number＞ 503-0575395-6075865',
  '＜订单标题＞ 2024年1月24日李先生的订单已读': "＜Order Title＞ Mr. Lee's order on January 24, 2024",
  '该价格仅供参考，请登录后获取实际价格信息': 'This price is for reference only. Please log in to obtain actual pricing information.',
  '在国际发货时，如果包含易碎或尖锐的物品，建议选择气泡膜或者缓冲垫。': 'It is recommended to choose bubble wrap or cushioning pads for your package if shipping fragile or sharp items.',
  '气泡膜体积较小，但是保护作用会比缓冲垫差一点。': 'Bubble wrap is smaller with less protective than cushioning.',
  '缓冲垫体积较大，但是保护作用较强。': 'Cushioning is larger, but with more protection. You can also choose to use both these two cushioning materials.',
  '您也可以选择同时使用两种缓冲材。不管是哪种方式都无法确保100%不破损。': 'Either way, there is no guarantee that 100% of the items will not be broken.',
  注册或登录以查看更多信息: 'Register or login to view more info',
  '加入CKB 会员计划以查看更多信息': 'Join the CKB Member for more info',
  库存保管费: 'Stock Keeping Fee',
  包裹滞留费: 'Parcel Holdup Fee',
  '免费滞留天数（自然日）': 'Free retention days（natural days）',
  结算周期: 'Settlement Period',
  发货单编号: 'Shipment No.',
  滞留日期: 'Hold Date',
  发货完成日期: 'Shipment Completion Date',
  免费滞留天数: 'Free days of stay',
  计费类型: 'Billing Type',
  '数量(体积)': 'Quantity (volume)',
  体积: 'volume',
  体积类型: 'Volume Type',
  '元/个/天': 'CNY/pc/day',
  个: 'pc',
  '元/m³/天': 'CNY/m³/day',
  明细下载: 'Detailed Download',
  关于超过免费保管期限的保养费: 'Maintenance fees for periods exceeding the free storage period',
  超小: 'XS',
  小: 'S',
  中: 'M',
  大: 'L',
  超大: 'XL',
  '注: 体积为3边合计，小于1cm则按1cm计算': 'Note: Volume is the total of 3 sides, less than 1cm is counted as 1cm.',
  关于超过免费滞留期的滞留费: 'About the detention fee beyond the free detention period',
  按包裹计费: 'Charge by parcel',
  按箱子计费: 'Charge by box',
  '注: 箱子体积小于1㎡则按1平方米计算': 'Note: If the box volume is less than 1 square meter, then calculate according to 1 square meter.',
  '您本月库存保管费和包裹滞留费账单已生成，合计XX元。请前往"资金管理"进行查看': 'Your inventory holding fee and parcel detention fee bill for this month has been generated, totaling XX CNY. Please go to "Funds Management" to check.',
  '您本月的库存保管费和包裹滞留费账单已生成（合计XX人民币），请前往“资金管理”进行查看': 'Your inventory holding fee and parcel detention fee bill for this month has been generated, totaling XX CNY. Please go to "Funds Management" to check.',
  及以上: 'and above',
  包裹: 'parcel',
  $箱子$2: 'box',
  库龄: 'Stock age',
  '3边合计': 'Total size of 3 sides',
  以上: ' or larger',
  '180日以上': 'More than 180 days',
  '365日以上': 'More than 365 days',
  '在庫の保管日数では、在庫あり商品の保管日数を示します': 'Stock retention days indicate the number of days items in stock are kept in stock',
  '在庫の保管日数に含まれる商品 = 良品 + 返品不可不良品': 'Goods included in the number of days in stock = Good + Non-returnable Defective',
  '※在庫保管日数は日単位で計算され、1日未満の場合は1日となります': 'Days in Stock is calculated in days, less than 1 day is counted as 1 day.',
  总计天数: 'Total days',
  需计费天数: 'Billed days',

  是否使用在途库存: 'Whether to use inventory in transit',
  使用1: 'Use',
  '(如果您选择了「使用」，如您有处理中的库存，将会使用处理中库存进行下单(无需支付商品费用，处理中库存成品上架后即可发货))': '(When you choose "Use", if you have in-process inventory, you will use the in-process inventory to place an order (no need to pay for goods, the finished product of the in-process inventory can be shipped once it is on the shelves))',
  不使用1: 'No use',
  '(如果您选择了「不使用」，则会为您采购成品库存不足的商品)': '(If you select "Do not use", it will purchase for you the finished product with insufficient stock)',
  使用在途库存: 'Use of inventory in transit',
  不使用在途库存: 'Not using inventory in transit',
  处理中库存提醒: 'Inventory in processing reminder',
  '以下商品有正在处理中的库存，请选择处理方式：': 'The following products have in-process inventory, please select the processing method:',
  '不使用在途库存，直接下单重新采购': 'Without using the in-transit inventory, place an order directly for re-purchase',
  '使用处理中库存进行下单（无需支付商品费用，处理中库存成品上架后即可发货）': 'Use the inventory in processing to place an order (no need to pay the cost of goods, the finished product of the inventory in processing can be shipped after the shelves)',
  '请选择是否使用在途库存进行下单处理方式：': 'Please select whether to use in-transit inventory for order processing method:',
  批量优先发货: 'Batch Priority Shipping',
  请将优先发货筛选项改为是后操作: 'Please change the priority shipment filter to yes and then operate.',
  请将优先发货筛选项改为是后操作1: 'Please change the priority shipment filter to yes and then operate.',
  '批量优先发货中，请稍等1-3分钟，期间请勿重复操作': 'Please wait for 1-3 minutes for batch priority shipment, please do not repeat the operation during this period.',
  在途: 'in transit',
  在途抵用: 'credit in transit',
  等待采购: ' Waiting for procurement',
  采购处理中: 'Procurement processing',
  采购完成: 'Purchase completed',
  国内运输中1: 'Domestic transportation',
  已入库1: 'In storage',
  质检中1: 'Quality inspection',
  异常处理中: 'Abnormal processing',
  同意1: 'Agree',
  购买数: 'Order Required Quantity',
  处理中库存使用数: 'Quantity in Process',
  是否确认批量优先发货: 'Confirm if batch priority shipment?',
  '※処理中＝ 国内運送中＋入庫済み＋検品中': 'Processing＝ In Domestic Transit＋Received＋Under Inspection',
  已经存在提前发货任务: 'There is already an early shipment task',
  '按手起批 1手={num}双': 'Purchase quantity by set, 1 set = {num} pairs',
  商品数量选择不正确: 'Incorrect selection of product multiples',
  '此商品附加项只对该订单中需采购的商品生效，对库存商品不生效': 'This add-on service only valid for the items in this order, not valid for others stock.',
  选择订单数: 'Order Quantity',
  确认分纳发送吗: 'Do you want priority shipment in bulk?',
  发送确认: 'end Confirmation',
  // sku一对多翻译
  '关联商品可以支持(1对多)的绑定啦！': 'Linkage products can support (one-to-many) binding!',
  供货商品数: 'Number of linked SKUs',
  api商品: 'products',
  选择已同步商品: 'Select the synchronized product',
  创建关联商品: 'Create related linkage products',
  选择外部销售商品: 'Select shopify sell product',
  选择供货商品: 'select the kinkage supply product',
  选择关联的规格: 'select the sku to be linkage',
  保存即关联成功: 'and save to linkage successfully',
  销售商品: 'Sell products',
  请输入商品名2: 'Please enter the product name',
  '当前店铺未绑定API，授权后可绑定商品，享受自动下单功能': 'The current store is not linkage the API, after linkage, you can bind the products and access to the automatic order function.',
  去授权: 'Go linkage my store',
  请先去授权: 'Please linkage with your store first',
  '当前店铺已绑定API，去选择要绑定的商品': 'The current store has bound the API, go to select the products need to bound',
  选择销售商品: 'Selecting your selling product',
  重置2: 'Reset',
  选择2: 'Select',
  绑定中: 'Bound in Progress',
  已关联: 'Bounded',
  未关联: 'Not Bound',
  供货商品: 'Supply Products',
  '选择OEM、组合商品': 'Select OEM, combine products',
  '绑定成功后，多个供货商品之间的库存可共用！下单时会按照顺位进行依次扣除': 'After successful binding, inventory can be shared among multiple supplied products! It will be deducted in order when you place an order.',
  '请输入URL、商品名、THE CKB SKU': 'Please enter the URL, product name, and THE CKB SKU.',
  主2: 'Main',
  商品: 'product',
  '所有供货商品库存不足时，将会采购主商品': 'If all the supplied products are out of stock, the main product will be purchased.',
  次: 'Secondary',
  '第{num}顺位商品': '{num} order product',
  设为主商品: 'set as main product',
  规格2: 'Specification',
  去选择要绑定的供货商品: 'Go to select the product to be bound',
  '可支持绑定多个商品，建议前往绑定库存商品': 'Binding multiple items is supported, recommend to go to binding inventory items',
  库存商品: 'inventory goods',
  是否确认删除2: 'Confirm deletion or not',
  删除后将自动解绑该商品下已绑定的SKU: 'After deletion, the SKUs bound to the product will be automatically unbound.',
  绑定成功2: 'Binding success',
  '抱歉，绑定失败': 'Sorry, binding failed',
  '原因：该商品已被其他销售商品绑定，需要先解绑后才能绑定该商品。': 'Reason: This product has been bound to another product, you need to unbind it before rebind.',
  当前被该商品绑定: 'Currently bound to this product',
  解绑并绑定到当前商品上: 'Unbind and bind to the current product.',
  最多只能绑定3个商品: 'Bundle up to 3 products',
  最多只能绑定30个商品: 'Bundle up to 30 products',
  供货商品库存: 'Inventory of goods supplied',
  销售商品库存: 'Inventory of goods for sale',
  '当前售卖商品库存为关联的所有供货商品的库存总和，以便您进行销售库存的预估和管理': 'The current inventory of sell items is the sum of the inventory of all supplied items, so that you can estimate and manage the sales inventory.',
  销售sku: 'sales sku',
  销售SKU: 'sales sku',
  去绑定: 'Bind my store ',
  修改绑定: 'Modify Binding',
  当前商品绑定关系: 'Current product binding',
  '当前商品未绑定Amazon sku，请在下方搜索进行绑定': 'The current product is not bound to Amazon sku, please search below to bind it.',
  平台2: 'Platform',
  '请输入要绑定的Amazon sku': 'Please enter the Amazon sku you want to bind.',
  '已绑定Amazon sku': 'Bound to Amazon sku',
  查看商品绑定关系: 'View product binding relation',
  我知道了3: 'Informed',
  '当所有供货商品库存不足，将会采购主商品': 'When all supplied items are out of stock, the main item will be purchased.',
  是否设为主商品: 'Set as main product or not',
  是否解绑: 'Unbundle or not',
  编号: 'Sku',
  '暂无商品，请先去搜索商品': 'No products please go to search the products ',
  '当前店铺未授权同步数据功能，授权后可绑定商品，享受自动下单功能': 'The current store is not authorized to synchronize the data function, can bound goods after the authorization, get the automatic order access',
  '当前店铺已授权同步数据功能，去选择要绑定的商品': 'The current store has been authorized to synchronize the data function, select the products to be bound',
  去选择: 'Go to Select Product',
  去选择3: 'Go to Select Product',
  去选择2: 'Go to Select Product',
  '请点击“同步商品”': 'Please click "Synchronize Products".',
  '可支持绑定多个商品，前往去绑定库存商品': 'Bind multiple products, bind inventory products.',
  '当前商品未绑定Amazon sku,请在下方搜索Amazon sku进行绑定': 'The current product is not bound to Amazon sku, please search on below and bind it.',
  当前sku已绑定: 'Current sku is bound',
  是否解除绑定: 'Unbind or not',
  三方商品关联不允许多对多: 'Do not allow many-to-many product linkage',
  黑名单商品不允许关联商品: "Blacklisted products can't bind with products",
  '该商品不在该店铺内，请重新操作': 'The product is not in the store, please try again.',
  '请先选择三方商品后，再添加此商品来绑定吧！': 'Please select the third platform product first, then add and bind it!',
  一键添加: 'One click to add',
  失效商品不允许关联商品: 'Related items are not allowed for expired items',
  易燃易爆物品: 'flammable substances',
  粉末: 'Powders',
  液体: 'liquids',
  保管费计费尺寸: 'Product Size',
  // 库存保管费: 'Stock Keeping Fee',
  尺寸规格: 'Size',
  '3边总尺寸': 'Total size of 3 sides',
  库存保管天数: 'Inventory storage days',
  // 单价: '단가',
  '0-180日': '0-180Days',
  '181日以上': 'More than 180 days',
  '141cm以上': 'More than 141cm',
  '{price}元/点/日': '{price}CNY/pc/day ',
  // 成本计算器
  总预估成本价: 'Total estimated price',
  请先在下方选择SKU: 'Please select sku below first',
  成本计算: 'Cost Calculation',
  应用工具: 'Application tools',
  成本计算器: 'Cost calculator',
  运输公司: 'Shipping company',
  预估运输费用: 'Estimated shipping costs',
  运输时效: 'Shipping time',
  费用暂时无法预估: 'Costs cannot be estimated at this time',
  运费估算: 'Freight estimates',
  展开1: 'Expand',
  更多: 'More',
  支持表格字段自定义展示: 'Support custom display of form fields',
  表格筛选: 'Table filter',
  标题1: 'Title',
  明细1: 'Details',
  表格恢复为初始状态: 'Restore to initial state',
  表格已恢复为初始状态: 'Restored',
  约: 'about',
  寄往国家: 'Shipping destination country',
  运送会社: 'Shipping Company',
  '补充手机号，获得担当优先服务!': 'Add your mobile phone number to get priority service',
  立即填写: 'Fill in now',
  主账号余额: 'Main account balance',
  主账号余额1: 'Main account balance',
  立即处理: ' Deal with it immediately',
  API自动下单异常: 'API order exception',
  待支付账单: 'Bills to be paid',
  OEM待确认报价: 'OEM quotation to be confirmed',
  常用功能: 'Commonly used functions',
  全部功能: 'All functions',
  '有包裹因欠费而无法发货，请尽快转账': 'Some packages cannot be shipped due to insufficient balance, please help top up for normal shipment as soon as possible.',
  自定义常用功能: 'Common customize  functions',
  待处理异常订单: 'Abnormal orders to be processed',
  组合商品落单: 'Place orders for combined products',
  重要公告: ' Important Announcements',
  热门活动: 'Popular activities',
  功能更新: 'Function updates',
  暂无公告: 'No announcement',
  会员自动续费: 'Automatic membership renewal',
  '条(未读)': 'unread messages',
  'X个包裹因欠费而无法发货，请尽快充值': 'X个包裹因欠费而无法发货，请尽快充值',
  请添加常用功能: 'Please add common functions',
  最多添加5个常用功能: 'Add up to 5 common functions',
  在库商品: 'Products in stock',
  原因: 'Explanation',
  当前店铺: 'Current Store',
  '标准舱客户可以提供OEM资材服务。商务舱及以上客户可以提供服装，杂货OEM服务': 'OEM (accessories) service is only available for Business plan members and diamond plan members. Customers who want to use it should update their membership level first.\nNote: Business plan members can only produce accessories (such as special OPP bags/personal brand labels), and the Diamond plan members can produce all OEM (including all production and accessories based on samples or links)!',
  // 清野
  水洗标名称: 'Care label name',
  '在下单时，如未主动选择水洗标，将全部设为默认水洗标': 'When placing an order, if you do not actively select a washable label, all washable labels will be set as the default.',
  设为默认水洗标: 'Set as default care label',
  请输入水洗标名称: 'Please enter the care label name',
  填写的客户商品规格将打印在水洗标上: 'The filled-in customer product specifications will be printed on the care label',
  '示例：L码，红色等': 'Example: L size, red, etc.',
  '请输入客户商品规格  示例：L码，红色等': 'Please enter product specifications. Example: L size, red, etc.',
  '日本工业标准法要求产品上需要标注商品规格信息，若无规格信息，您的商品售卖可能受到影响': 'The Japanese Industrial Standards Act requires product specification information to be marked on products. Without specification information, your product sales may be affected.',
  水洗标图片: 'Care label picture',
  '您填写的规格信息将打印在该商品的水洗标上，请您再次确认规格信息是否正确,确认后规格信息将作用在该SKU所有订单上': 'The specification information you fill in will be printed on the care label of the product. Please confirm again whether the specification information is correct. After confirmation, the specification information will be applied to all orders of this SKU.',
  '打印水洗标，需确认客户商品规格信息': 'To print care labels, you need to confirm the product specification information first.',
  批量导入规格: 'Table import modification information',
  客户商品规格只用于在水洗标上打印: 'Product specifications are only used for printing on care labels',
  在库管理编辑: 'Manage the storage information',
  订单编辑: 'Manage the order information',
  组合商品编辑: 'Manage the combined products information',
  购物车下单: 'Order by the cart',
  场景: 'Scene',
  '客户商品规格/客户SKU': 'Product specifications/customer SKU',
  修改客户商品规格为: 'Modify product specifications to:',
  修改客户SKU为: 'Modify the customer SKU to:',
  '3.导入成功后将更改客户商品SKU及客户商品规格信息': '3. After the import is successful, the product SKU and product specification information will be changed.',
  '4.THE CKB SKU为必填项，客户商品SKU及客户商品规格不填写默认不修改': '4. Required content. If the customer product SKU and customer product specifications are not filled in, it will be cleared by default.',
  '存在多个一样ckb sku: {sku}': 'There are multiple identical CKB SKUs. sku: {sku}',
  '{sku} 该ckb sku不存在': '{sku} The CKB SKU does not exist',
  客户sku过长: 'The customer SKU is too long',
  商品规格过长: 'Product specifications are too long',
  选择水洗标: 'Select the care label',
  水洗标: 'The care label',
  请选择水洗标: 'Select the care label',
  默认水洗标: 'The default care label',
  请填写水洗标名称: 'Please enter the care label name',
  商品未填写客户商品规格: 'The product does not have the customer product specifications filled in',
  水洗标信息: 'The care label information',
  '读取文件中，即将更新数据': 'Reading the file, the data is about to be updated',
  '商品规格/客户SKU': 'Specifications/Customer SKU',
  部分商品未关联采购链接: "There are goods that are not related to the ckb's goods.",
  导出SKU费用明细: 'Export SKU cost details',
  sku费用明细: 'SKU cost details',
  导入: 'Table import',
  '材质为自动读取，不可编辑': 'The material is automatically set and cannot be edited.',
  '商品的规格，请从选项设定画面进行编辑。未输入的情况下不显示': 'Please edit the specifications in the product additional items interface. If you do not enter them, they will not be displayed.',
  待处理异常: 'Unprocessed exceptions',
  有1: 'Yes',
  无1: 'No',
  是1: 'Yes',
  否1: 'No',
  到货延迟: 'Arrival delay',
  预计发货时间: 'Estimated delivery time',
  X件: 'X pieces',
  预计到货时间: 'Estimated arrival time',
  跟单进度: 'Order progress',
  跟单反馈时间: 'Order feedback time',
  '预计发货时间：<br/>无': 'Estimated delivery time: <br/>None',
  无2: 'None',
  中国国内运输物流编号: 'China domestic transportation logistics number',
  点击查看物流状态: 'Click to view logistics status',
  '已到货，入库中': 'Arrived and in storage',

  '商品为预售商品，商家回复预计X发货': 'Pre-sale item,estimated delivery time is X.',
  '商家还在生产中，商家回复预计X发货': 'Goods in production estimated delivery time is X',
  '遇到节假日（工厂放假），商家延迟到X发货': 'Holiday (factory holiday) the supplier delays delivery to X',
  '商家预计X发货，有可能会分批次发货': 'supplier expects to ship by X, possibly deliver in batches',
  '该商品正在生产中，不确认出货时间': 'This item is in production and shipment time is not confirmed.',
  '已跟商家确认最新发货时间，商家未回复': 'The latest delivery time has been confirmed with the supplier, but the supplier has not replied.',
  '无预计发货时间，正在与您确认商品详细中': 'We are confirming the product details with you.',
  '商品为预售商品，商家回复预计延迟到X发货': 'Pre-sale item, the delivery is expected to be delayed until X',
  '商家还在生产中，商家回复预计延迟到X发货': 'Goods in production-the delivery is expected to be delayed until X',
  '遇到节假日（工厂放假），商家回复预计延迟到X发货': 'Holiday (factory holiday)-the delivery is expected to be delayed until X',
  '商家预计延迟到X发货，有可能会分批次发货': 'supplier expects to delay delivery until X possibly in batches',
  '出货时间变更，询问商家未回复出货时间，会持续跟进': 'Shipment time change,supplier has not responded with a shipping time and will continue to follow up.',
  '询问商家未回复出货时间，会持续跟进': 'supplier has not responded with a shipping time and will continue to follow up.',
  '出货时间变更，正在与您确认商品详细中': 'Shipment time change,confirming product details with you',
  '经再次跟卖家确认发货时间，因为产品还在生产中，发货时间延迟至X': 'We have reconfirmed the delivery time with the supplier, due to the product is still in production, the delivery time is delayed to X',
  '已经再次跟卖家确认发货时间，发货时间提前至X': 'We have reconfirmed the shipping time with the supplier, and the shipping time has been pull in to X',
  '已和商家核实是否按原计划发出，发货时间未变': 'Verified, delivery time unchanged',
  '已和商家核实是否按原计划发出，卖家暂未回复，明日会继续跟进': 'Verified, supplier has not replied yet, will continue to follow up tomorrow',
  '跟卖家确认，卖家扔未回复，卖家除预计发货时间X之外，未给到新的发货信息，若预计发货时间未发货，我司会继续确认': 'No reply, the supplier has no new shipping,If the expected delivery time is not shipped, we will continue to confirm the',
  '遇到节假日（工厂放假），商家延迟到X': 'Holiday (factory holiday) the supplier delays delivery to X',
  '商家回复产品还在生产中，预计X发货': 'The product is still in production and is expected to be shipped on X',
  '已跟商家确认最新发货时间，商家暂无法提供准确的发货时间': 'The latest delivery time has been confirmed with the supplier,The supplier is unable to provide an accurate delivery time',
  '商家会分批发货，首次发货时间为X': 'The supplier will ship in batches, and the first shipment will be on X',
  正在与您确认商品详细中: 'We are confirming the product details with you.',
  '确认到最新状态为未发货，原因是之前商家虚假发货，预计最新发货时间为X': 'Confirmed that the latest status is not shipped. The reason is that the supplier previously made a fake shipment. The latest estimated delivery time is X',
  '确认到最新状态为分批次发货，预计剩余商品最新发货时间为X': 'Confirming that the latest status is partial shipments, with the estimated remaining items expected to be shipped by X',
  '确认到最新状态为未发货，原因包裹丢失，预计最新发货时间为X': 'Confirmed that the latest status is not shipped. The reason is that the package was lost. The latest estimated delivery time is X',
  '确认到最新状态为未发货，商家出货时间变更': "Confirmed that the latest status is not shipped, and the supplier's shipping time has changed",
  '确认到最新状态为未发货，原因是之前商家虚假发货，目前暂无预计发货时间，会持续跟进': 'Confirmed that the latest status is not shipped, the reason is that the supplier previously shipped falsely, there is currently no estimated shipping time, and will continue to follow up',
  '确认到最新状态为未发货，原因包裹丢失，目前暂无预计发货时间，会持续跟进': 'Confirmed that the latest status is not shipped, the reason is that the package is lost, there is currently no estimated shipping time, and will continue to follow up',
  '确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，目前暂无预计发货时间，会持续跟进': "Confirmed that the latest status is not shipped, the supplier's shipping time has changed-the supplier replied that the product is still in production, there is currently no estimated shipping time, and will continue to follow up",
  '确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，预计X发货': " Confirmed that the latest status is not shipped, the supplier's shipping time has changed-the supplier replied that the product is still in production and is expected to be shipped at X",
  '确认到最新状态为未发货，商家未回复，目前暂无预计发货时间，会持续跟进': 'Confirmed that the latest status is not shipped, the supplier has not replied, and there is no estimated shipping time at present, and will continue to follow up',
  '已为您中途确认，商家生产计划有调整，预计X发货': "It has been confirmed for you midway that the supplier's production plan has been adjusted , expected to be shipped in X days",
  '已和商家核实是否按原计划发出，发货时间未变，X': 'The supplier has been verified with whether it is shipped according to the original plan, and the shipping time has not changed, X',
  '已经连续Y次（读取采购确认最近连续次数“需持续确认预计发货时间”）跟卖家确认，卖家扔未回复，卖家除预计发货时间X之外，未给到新的发货信息 若预计发货时间未发货，我司会继续确认': 'The supplier has been confirmed for X consecutive times (read the latest consecutive number of purchase confirmations "need to continue to confirm the estimated shipping time"), and the supplier has not replied. The supplier has not given any new shipping information except the estimated shipping time X. If the estimated shipping time is not shipped, our company will continue to confirm',
  '确认到最新状态为入库少件，剩余商品预计X到仓（预计到仓时间规则=预计发货时间+3天同现在）': 'Confirmed that the latest status is less items in the warehouse, and the remaining goods are expected to arrive at the warehouse in X (estimated arrival time rule = estimated delivery time + 3 days)',
  '确认到最新状态为入库少件，剩余商品，商家未回复，目前暂无预计发货时间，会持续跟进': 'Confirmed that the latest status is less items in the warehouse, and the remaining goods, the supplier has not responded, and there is currently no estimated delivery time, and will continue to follow up',
  '确认到最新状态为入库少件，剩余商品，商家回复暂无预计发货时间，会持续跟进': ' Confirmed that the latest status is less items in the warehouse, and the remaining goods, the supplier replied that there is currently no estimated delivery time, and will continue to follow up',
  '尚处在中国国内运输中，之前商家提供的物流单号有误，现已更正，预计X到仓': 'It is still in the process of domestic transportation in China. The logistics order number provided by the supplier is incorrect. Now it is corrected. It is expected to arrive at the warehouse on X',
  '尚处在中国国内运输中，因运输途中包裹丢失，商家已补发，预计X到仓': 'It is still in the process of domestic transportation in China. The package was lost during transportation, and the supplier has reshipped it. It is expected to arrive at the warehouse on X',
  '尚处在中国国内运输中，确认因物流公司运力不足，物流缓慢，预计X到仓': 'Still in domestic transportation in China. Confirmed that due to insufficient transportation capacity of logistics companies, logistics is slow. It is expected to arrive at the warehouse in X',
  '尚处在中国国内运输中，确认因天气因素，物流缓慢，预计X到仓': 'Still in domestic transportation in China. Confirmed that due to weather factors, logistics is slow. It is expected to arrive at the warehouse in X',
  '尚处在中国国内运输中，确认因中国节日因素，物流缓慢，预计X到仓': 'Still in domestic transportation in China. Confirmed that due to Chinese holidays, logistics is slow. It is expected to arrive at the warehouse in X',
  '包裹已签收，正在紧急入库中': 'The package has been signed and is being urgently put into storage',
  '确认到最新状态为中国国内运输中，商家分批次发，分包物流已新增，预计X到仓': 'Confirmed that the latest status is in domestic transportation in China, and the supplier will ship in batches , subcontracted logistics has been added, and it is expected to arrive at the warehouse on X',
  '确认到最新状态为入库少件，剩余商品预计X到仓': ' Confirmed that the latest status is less items in the warehouse, and the remaining goods are expected to arrive at the warehouse in X',
  '确认到最新状态为中国国内运输中，预计X到仓': 'Confirmed that the latest status is in domestic transportation in China. The remaining goods are expected to arrive at the warehouse on X',
  '根据商品上款量、收藏量、销量等数据计算': "Boutique Men's Clothing, Source Direct, Wide Speed Shipping",
  '网商园商品涵盖男装全品类，款式多更新快，为商家和买家提供了极大的便利。': 'A wholesale platform for online retailers in Hangzhou, China. As an official Taobao partner, we can offer a wide range of products.',
  筛选: 'Category Filter',
  找商品: 'Finding merchandise',
  找档口: 'Finding stalls',
  热卖商品: 'Hot-selling property',
  源头直发: 'direct sourcing',
  发货快: 'fast delivery',
  商品丰富: 'rich merchandise',
  档口排序: ' Stall Sort',
  默认排序: 'default sorting',
  今日新品: "Today's New Products",
  每周爆款: 'Weekly Pop-Up',
  七日爆款: 'Seven-day pop-ups',
  热销榜单: 'hot lists',
  行业精品: 'industry gems',
  平台销售额: 'Platform Sales',
  实力档口: 'Power Stalls',
  '根据档口的缺货率、次品率、发货到仓及时率得出的评分较高的档口': 'Stalls with higher ratings based on their stock-out rate, defective product rate, and timely delivery to warehouse rate',
  一级分类: 'Primary categorization',
  二级分类: 'secondary categorization',
  排序方式: 'Sorting method',
  价格排序: 'price sorting',
  现货专区: 'Spot Zone',
  '搜款网聚焦女装潮流，针对年轻都市丽人，提供性价比高、款式前沿的优质服装配饰。': 'It features specialized wholesale of clothing, providing products for more than 6 million brick-and-mortar and online sellers.',
  每日新品: 'Daily New Products',
  七日热卖: 'Seven Day Sale',
  商品榜: 'Product list',
  '这就是市场购！': 'This is a market purchase!',
  '用户下单即采，采购人员当天直接前往源头采购并检品，最快当天发货，避免国内运输耗时和中间商层层加价，有效控制成本，为客户提供优质货品。': 'Users order that procurement, procurement staff directly to the source on the same day to purchase and inspection of goods, the fastest day delivery, to avoid the domestic transportation time-consuming and intermediary layers of price increases, effective control of costs, to provide customers with high-quality goods.',
  视频了解: 'Video Understanding',
  代采平台: 'Surrogate platforms',
  '以下平台支持直接采购，快挑选您心仪的商品吧！': 'The following platforms support direct purchasing, so pick your favorite items!',
  中国杭州第一家获淘宝官方正式授权的批发平台: 'The first wholesale platform officially authorized by Taobao in Hangzhou, China.',
  精品男装: "Boutique Men's Clothing",
  源头直采: 'Source Direct',
  快速发货: 'Wide Speed Shipping',
  采购商品2: 'Purchase goods',
  了解网站: 'learn about the site',
  '中国广州市最大的服装批发平台。': 'The largest clothing wholesale platform in Guangzhou, China',
  精品女装: "Boutique women's clothing",
  一手货源: 'first-hand source',
  真实档口: 'real stalls',
  采购流程: 'Procurement process',
  平台采购将通过以下流程高效且便捷地完成: 'Platform purchases will be efficiently and easily accomplished through the following processes',
  代采优势: 'Strengths of THE CKB',
  '直行便提供信息透明、交易高效、服务完善的采购环境，买家可以更方便、快捷地完成采购': 'CKB provides a purchasing environment with transparent information, efficient transactions and complete services so that buyers can complete their purchases more conveniently and quickly.',
  丰富的款式: 'Abundant styles',
  '直接从中国各地主要批发市场采购，实时更新商品，紧跟最新潮流趋势。': 'Sourced directly from major wholesale markets across China, we update our products in real time to keep up with the latest trends.',
  极高的性价比: 'Extremely high price-performance ratio',
  '提供比阿里巴巴价格低一半以下的商品。通过直接采购，大幅降低中间成本。': 'We offer products that are less than half the price of Alibaba. Significantly reduce intermediate costs through direct sourcing.',
  独特的商品: 'Unique Merchandise',
  '大量未在网上销售的独家商品，提供与众不同的独特商品选择。': 'A large number of exclusive items that are not sold online, offering a distinctive and unique selection of merchandise.',
  常见问题: 'Common problems',
  '以下是一些常见问题，看能不能帮您解决问题': 'Here are some frequently asked questions to see if we can help you solve your problem',
  了解详情: 'Learn more',
  '您的浏览器未安装商品导入插件，安装插件后，您才可以把找到的商品一键导入到CKB。': 'Your browser does not have the plugin installed, and only after installing the plugin will you be able to one-click add-ons to CKB for the items you find.',
  搜款网小技巧: 'Tips and tricks for VVIC',
  用户当天下午2点前下单: 'Users place orders before 2pm on the same day',
  当天线下采购并检品出库: 'Same day offline purchasing and inspection of products out of the warehouse',
  商品送达: 'Delivery of goods',
  爆款分类: 'Explosive classification',
  轻度: 'Mildly',
  中度: 'Moderately',
  重度: 'Heavily',
  关税报销: '',
  '10cm以上': '10cm or more',
  自动处理剩余时间: 'Automatic processing of remaining time',
  最新问题时间: 'Latest issue time',
  自动处理时间: 'Automatic processing time',
  异常情形: 'Abnormal circumstances',
  异常图片: 'Abnormal Pictures',
  异常数量: 'Number of exceptions',
  '遇到需要选择良品入库或次品退货异常需要您确认时，请在72小时内确认，超过72小时系统将自动选择次品退货': 'When you encounter the need to select the good goods into the warehouse or defective products return abnormalities need to confirm, please confirm within 72 hours, more than 72 hours the system will automatically select the defective products return.',
  $通电不良$9: 'Poor electrical',
  '$材质、面料差异$9': 'Different fabric',
  $设计差异$9: 'Different design',
  $尺码差异$9: 'Wrong size',
  $logo差异$9: 'Logo is different',
  $配件差异$9: 'Different accessories',
  $商品上有中文$9: 'Chinese language',
  $颜色差异$9: 'Color difference in products',
  'Paypal入金后，如果返金情况，手续费扣除不能返还': 'After PayPal transfer, if there is a refund, the service fee deducted cannot be refunded.',
  修改手机号: 'Change the mobile phone number',
  '※多次更换变成了同样的不良品。即使重新更换也没有改善不良品的可能性(因为是批量生产)。不良在容许范围内的情况下，建议允许入库': 'No possibility of improvement of defective products even if exchanged (due to lot production)',
  '※问题商品数量多，交货期延迟的可能性大。不良在容许范围内的情况下，建议允许入库': '* Large number of problem products, large possibility of delay in delivery',
  自动退货: 'Automatic Return',
  注意4: 'Notice',
  重新上传: 'Re-upload',
  继续上传: 'Continue uploading',
  重复信息: 'Duplicate information',
  '请确认重复信息，若确认请点击继续上传，否则请重新上传修改后的文件。': 'Please confirm the duplicate information. If confirmed, please click Continue to upload. Otherwise, please re-upload the modified file.',
  存在重复的乐天SKU: '存在重复的乐天SKU',
  存在重复JANcode: '存在重复JANcode',
  存在重复商品SKU: 'Duplicate product management system',
  去原网站选品2: 'Go to the original site',
  去原网站选品: 'Go to the original site',
  //   韩国仓
  品牌所在地: 'Brand Location',
  'THECKB系统默认入金领收书和领收书上的抬头为您的账户名称，前述文件仅证明与该账户相关的入金和订单情况。如您有正当理由需要将抬头修改为个人名称或法人名称，请您自行修改。修改之前，请您仔细阅读并确认以下内容：': 'THE CKB系统默认入金领收书和领收书上的抬头为您的账户名称，前述文件仅证明与该账户相关的入金和订单情况。如您有正当理由需要将抬头修改为个人名称或法人名称，请您自行修改。修改之前，请您仔细阅读并确认以下内容：',
  '本公司和THE CKB因信息保护原因无权对您提供的个人名称或法人名称进行审查。': '本公司和THE CKB因信息保护原因无权对您提供的个人名称或法人名称进行审查。',
  '您承诺您提供的抬头内容（个人名称或法人名称）准确无误，并符合相关法律法规的规定。': '您承诺您提供的抬头内容（个人名称或法人名称）准确无误，并符合相关法律法规的规定。',
  '您承诺更改抬头后的领收书和入金领收书不会用于任何虚假计账、逃税或其他违法行为。': '您承诺更改抬头后的领收书和入金领收书不会用于任何虚假计账、逃税或其他违法行为。',
  '因由您自行更改抬头的入金领收书和领收书导致的任何法律、税务或其他相关问题，均由您自行承担全部贵任。本公司对由您自行更改抬头的入金领收书和领收书引发的任何直接或间接损失概不负责。': '因由您自行更改抬头的入金领收书和领收书导致的任何法律、税务或其他相关问题，均由您自行承担全部贵任。本公司对由您自行更改抬头的入金领收书和领收书引发的任何直接或间接损失概不负责。',
  '因由您自行更改抬头的入金领收书和领收书导致本公司受到任何形式的税务检查、法律追诉、罚款或其他损失，您将承担所有赔偿责任（包括直接损失和预期利益损失）。': '因由您自行更改抬头的入金领收书和领收书导致本公司受到任何形式的税务检查、法律追诉、罚款或其他损失，您将承担所有赔偿责任（包括直接损失和预期利益损失）。',
  '请在继续操作前，勾选以下选项以确认您已阅读并同意上述免责声明': '请在继续操作前，勾选以下选项以确认您已阅读并同意上述免责声明',
  '我已阅读并同意上述免责声明的内容，并确认由我自行承担更改领收书抬头所引发的所有法律和财务责任。': '我已阅读并同意上述免责声明的内容，并确认由我自行承担更改领收书抬头所引发的所有法律和财务责任。',
  '设置完后，每次下载都使用该抬头，不再询问': '设置完后，每次下载都使用该抬头，不再询问',
  领受书抬头设定: '领受书抬头设定',
  同意免责声明并保存: '同意免责声明并保存',
  免责声明: '免责声明',
  保存前请先阅读免责声明: '保存前请先阅读免责声明',
  不询问: '不询问',
  请输入内容: '请输入内容',
  领授书抬头: '领授书抬头',
  请输入领授书抬头: '请输入领授书抬头',
  免责声明标题: '免责声明标题',
  同意免责声明: '同意免责声明',
  '口每次下载都使用该抬头，下次不再询问。': '口每次下载都使用该抬头，下次不再询问。',
  费用说明: 'Details',
  您获得X笔返金: 'You have got the rebate money.',
  金额1: '金額',
  立即查看: 'View Now',
  '超过60天用户未处理，系统已自动处理': 'User not processed for more than 60 days, the system has been processed automatically',
  '采购中发起异常，请在60个自然日处理，超时系统将自动处理为取消。': 'Exception initiated during purchase, please process within 60 natural days, the timeout system will be automatically processed as cancellation',
  发货地: 'place of delivery',
  韩国: 'Korea',
  中国: 'China',
  系统异常: 'Error, please contact customer service center',
  重新加购: 'Add to cart',
  原商品尺码: 'Original Product Size',
  购买链接: 'Commodity URL',
  详细地址不能超过40个字符: 'The detailed address cannot exceed 40 words.',
  结算金额: 'Payment amount',
  '待支付的订单才能重新支付，请确认后重新选择': 'Only orders that are waiting to be paid can be repaid',
  商品材质: 'Product material',
  春节前纳品oem商品截单日: '< Napin OEM Commodity Cut-off Day Before Spring Festival >',
  服装杂货: 'Clothing and groceries',
  '★12/25（水）': '★ 12/25',
  '辅料（纸盒，特殊纸袋，opp袋）': 'Accessories (paper box, special paper bag, opp bag)',
  '★1/5（日）': '★ 1/5 ',
  '★1/15（水）': '★ 1/15 ',
  '辅料（布标，纸标，说明书）': 'Accessories (cloth label, paper label, instruction manual)',
  'oem订单请尽快下单！': 'oem Please place an order as soon as possible!',
  '※oem工厂春节休息时间：约1月初~2月中旬': '※OEM factory is closed during the Lunar New Year holidays: from early January to mid-February',
  '※截单日之后也可以下单，但是工厂发货基本会延迟到2月下旬及以后~2月中旬': '※ Orders can be placed after the cut-off date, but factory shipments will be delayed until late February or later.',
  '※每个工厂的情况不同，截单日之前的订单也会有春节后发货的可能性': '※Depending on the factory situation, orders placed before the deadline may be shipped after the Lunar New Year.',
  成品采购春节停止下单时间: '< Order suspension time for purchase Lunar New Year >',
  '１月２２日（水）~２月４日（火）': 'January 22nd to February 4th',
  建议春节前尽快囤货: 'I suggest that you stock up as soon as possible before Lunar New Year.',
  '※由于部分店铺已经开始休业，1月22日之前下单的商品也有节前发不出货的可能，商品状态会停滞在：***，请谅解！有需要取消的可以联系客服确认': '※Please understand that due to some store closures, products ordered by January 22 may not be shipped before the holiday, and the condition of the product may stagnate!',
  '※１月２２日（水）~２月４日（火）的订单我们也受理，统一在2月4日之后采购': '※We also accept orders from January 22nd to February 4th and collectively purchase them after February 4th.',
  春节前希望发货的发货委托制作的推荐期间: '<About International Logistics >',
  船运节前出货发货依赖截单时间: 'Shipping before the festival depends on the cut-off time',
  空运节前出货发货依赖截单时间: 'Air shipment before the festival depends on the cut-off time',
  '1月20日（月）18时': 'January 20th  18:00',
  '1月24日（金）12时': '24 January  12:00 p.m.',
  请提前安排发货: 'Please arrange shipment in advance.',
  市场购春节停止拿货时间: '< Market buying Spring Festival stop pick up time >',
  '1月18日（土）~2月4日（火）': 'January 18 to February 4 ',
  市场购商品请在1月27日之前囤货: 'Please stock up until January 27th for market purchases.',
  '※由于部分市场已经开始休业，1月18日之前下单的市场购商品也有拿不到货的可能，商品状态会停滞在：***，请谅解！有需要取消的可以联系客服确认': '※Some markets are closed, so please understand that there is a possibility that you will not be able to get the products you ordered before January 18th.',
  '※1月18日（金）~2月4日（火）休的市场购订单，统一在2月4日之后拿货': '※Market orders closed from January 18th  to February 4th  will be collected after February 4th.',
  '（注文，寻源）工厂停止生产': '< Factory closure time >',
  '1月16日（水）~2月4日（火）休': 'January 16th to February 4th ',
  '由于OEM商家基本已经开始休业，1月16日（水）~2月4日（火）休的oem寻源和订单，基本会在2月4日之后出货': 'OEMs are basically shut down, so from January 16 to February 4, OEM suppliers and orders will be shipped after February 4 by default.',
  '承接订单，提前咨询，提前沟通，锁定库存，准备材料': '',
  '商家提前排期，先下单先出货': '',
  '成品订单 停止采购！': '< Order for ready-made products >',
  '※由于商家已经开始休业，２月10日（火）~２月23日（月）的订单，统一在2月24日之后采购。': '※Due to the closure of the factory, orders from January 22nd to February 4th will be purchased in batches after February 4th.',
  '※由于商家恢复营业的时间不同，2月24日营业再开后，部分商品也有可能在3月中旬才能发货，请谅解': '※Please understand that some products may not be shipped until mid-February after the factory resumes business on February 4th due to the different timing of the factory\'s resumption.',
  '不能采购，但是承接订单，提前咨询，提前沟通，锁定库存': 'No purchase is possible, but order acceptance, advance inquiry, advance communication, stock lock!',
  直行便仓库休息时间: '< THE CKB Warehouse Humu Time >',
  'D2C（仓库发货停止）': 'D2C',
  '2月15日（日）~2月18日（水）': 'January 28th to February 2nd',
  'B2B（仓库发货停止）': 'B2B',
  '2月13日（金）~2月23日（月）': 'January 27th to February 4th',
  '发货依赖正常受理，节后顺次发货': 'Delivery depends on normal reception and sequential delivery after holidays',
  '订单正常受理，采购和发货在2月中旬顺时恢复': 'Orders will be accepted normally, and purchases and shipments will resume in mid-February.',
  公告: 'Notification',
  /** 新会员 */
  免费会员: 'Non-members',
  '参考购买金额：每月不超过2万日元': '',
  免费: 'Free of charge',
  'EC 网站商品采购': 'Purchase products on the EC website',
  '2次/月': '2 times/month',
  '4次/月': '4 times/month',
  '6次/月': '6 times/month',
  类似图片搜索: ' Search for similar images',
  类似图片搜索2: ' Search for similar images',
  '3次/天': '3 times/day',
  无限制: 'no limit',
  日本标准质检: '',
  品牌代理销售权: 'wholesale products and brand agency',
  '与日本 EC 网站系统联动和代发货服务': '',
  自定义选项和材料使用: 'Using Optional Services',
  '简单 OEM 支持': '',
  系统聊天支持: 'System Chat Support',
  '如果需要体验更多特典，可以在这里升舱为': 'さらに多くの特典を体験するには',
  推荐: 'recommended',
  '参考购买金额：30万～100万日元/月': '',
  商业和企业客户的费率计划: 'Rate plan for commercial and corporate customers',
  '商业计划和付费的第一计划提供的服务没有太大区别，但根据购买金额的不同，费用差异很大。 查看这两个计划的基本费用和成本，以找到更有效地支持您的业务的最佳计划。': 'Although the services offered by the business plan and the first plan are not very different, the cost varies greatly depending on the purchase amount. Check the basic costs and costs of the two programs to find the best members who can help your business more effectively.',
  '参考购买金额：每月100万~300万日元': '',
  '参考购买金额：每月300万日元以上': '',
  稍后处理: 'later',
  包含标准计划的所有服务: 'All services including Economy Plan',
  '完全支持OEM/ODM1': 'Supplementary materials OEM support',
  '完全支持OEM/ODM': 'OEM support for groceries or clothing',
  免费样品提供: '',
  '1对1特别商品提案': '',
  系统聊天及专属Chatwork群组: 'System Chat and Exclusive KakaoTalk Manager',
  品牌独占销售权及优惠价格采购: 'Brand Exclusive Sale and Preferential Price Purchase',
  首月0元: 'First month $ 0',
  '原价9800元/月': 'cost $ 9.9/month',
  '系统聊天和 LINE 专属支持': 'System chat and KakaoTalk only support',
  试用1个月免费: 'Free for 30 days',
  '已为您自动创建店铺，如有需要，您可自行修改店铺信息': 'Store created automatically. Store information can be changed as needed.',
  下单成功2: 'Order completed',
  '请及时留意订单发货情况。商品到达仓库后，您可创建国际发货单，将商品发送至您的地址。': 'Thank you for your order. Once the item has arrived at our warehouse, you can make an international shipping request and ship it to the designated address',
  CKB执行: 'THE CKB',
  采购: 'Purchase',
  CKB仓库: 'CKB warehouse/in',
  检品上架: ' inspection',
  用户执行: 'Customer',
  创建国际发货单: 'international',
  运输: 'delivery',
  收货: 'Receipt of goods',
  查看订单: 'prepared',
  '如何创建国际发货单？': 'How do you create an international shipping order?',
  '很抱歉，本月采购次数已用完': 'sorry, I\'ve used up this month\'s number of purchases',
  '非会员每月仅限2次采购机会，升级会员后不限次数。': 'Non-members can purchase up to twice a month. After membership upgrade, you can use it unlimitedly.',
  '非会员首次开通9800标准仓会员，首月仅需0元。': '※ We\'re running a campaign where you can join economy members for W10 per month! Please review it!',
  业务模式选择: 'Select Business Mode',
  店铺设置: 'Set Store',
  '请选择您首先要尝试的业务模式，后续可切换': 'Please choose the mode of work you want to try. You can change it later.',
  'b2b 我们支持持有库存并将其运送到您的家庭、内部仓库或国内电子商务仓库的操作。': 'B2B: Goods can be shipped to CKB in-house warehouse, home, or other Korean domestic addresses.',
  'd2c 支持从一点到直接交付给最终用户的操作': 'D2C: Can be delivered directly to end users in 1 case',
  'THE CKB（直行便）标准会员计划.随心采购': 'Standard membership plan, purchasing at will',
  '为个人到法人寻找符合需求的采购服务的最佳选择。从免费计划到免手续费的标准会员计划，提供丰富的福利以支持业务发展。': 'The best choice for individuals to legal persons to find procurement services that meet their needs. From free plans to standard fee-free membership plans, we offer a wealth of benefits to support business growth.',
  当前等级: 'Current Level',
  免费寻源: 'Request for free quotation',
  个人客户: 'Individual',
  企业客户: 'Corporate Clients',
  '个人客户（主要是个体工商户）的费率计划': '',
  '免费计划和付费标准计划中提供的服务和福利的详细比较，': '',
  '找到支持您业务增长的最佳计划。': '',
  基本功能: 'Basic functions',
  去升舱: 'Upgrade',
  首月免费: 'Free for 30 days',
  基本手续费: '',
  '采购手续费（市場购商品）': '',
  '次品自动再次购买（市場购商品）': '',
  OEM采样费用: '',
  検品附加项: '',
  '去布标・去水洗标・去吊牌': '',
  制作并缝制水洗标: '',
  普通发货袋: '',
  成为标准会员的三大优势: 'Three Advantages of Becoming a Standard Member',
  '作为标准会员，您将享受加速业务发展的三大主要优势：节省成本、差异化竞争和独特的产品开发。': '',
  免手续费和采购次数无限制: 'Free handling fee and unlimited number of purchases',
  '可无限次采购 EC 网站商品，免手续费，降低采购成本，最大化利润率。': 'Can purchase EC website goods unlimited times, no commission, reduce procurement costs, maximize profit margins.',
  独特产品开发和竞争差异化: 'Unique product development and competitive differentiation',
  '批发商专属商品和品牌代理销售，加上简单 OEM 支持，帮助您与竞争对手区别开来，强化自有品牌。': 'Wholesalers\' exclusive merchandise and brand agency sales, coupled with simple OEM support, help you differentiate yourself from your competitors and strengthen your own brand.',
  过代发货实现业务自动化: 'Automate business with over-the-counter shipments',
  '与日本电商网站（如 Amazon、BASE、Shopify 等）系统联动，无需库存管理，实现业务自动化。通过自动同步商品信息和自动订单处理，大大节省时间和精力。': '',
  企业会员计划的四大优势: 'Three Advantages of Corporate Membership Programs',
  '商务会员和头等会员提供个人计划无法享受的特别支持和丰富特权，为业务扩展和增长提供助力。以下是三个主要优势，请根据需求选择适合您的计划。': 'Business and First Members help you expand and grow your business by providing special support and rich privileges that individual programs can\'t enjoy. Here are some of the key advantages and choose the right plan as needed.',
  '高效管理，减轻工作负担': 'Reduce workload with efficient management',
  '商务会员最多支持10家店铺，头等会员则可不限店铺数量使用！通过优化采购到销售的业务流程，帮助您以更少的精力扩大业务。': 'Business members support up to 10 stores, and First members have unlimited access to them! Optimizing business processes from purchase to sale helps you expand your business with less energy.',
  专业支持体系: 'Professional Support System',
  '提供在线聊天支持，以及由专业负责人提供的Chatwork支持，确保高效、快速的业务运营。': 'Provides online chat support and professional support for efficient and rapid business operations.',
  全面支持品牌成长: 'Full support for brand growth',
  '通过OEM/ODM的全面支持，轻松开发定制商品或自主品牌。品牌独占销售权和优惠价格商品助力差异化竞争，提升品牌价值。': 'With the full support of OEM/ODM, it is easy to develop customized products or their own brands. Branded proprietary rights and preferential pricing promote differentiated competition and increase brand value.',
  '根据您的品牌和需求，专属采购员1对1推荐特殊商品。此外，每月可免费获得⚪︎万日元以内的样品，帮助您在低风险下把握市场机会。': '',
  面向法人的收费计划: 'Fee Plan for Corporations',
  '我们不仅提供个体经营者，也为法人提供收费计划。提供 OEM 和 ODM 支持及周末客户服务，选择适合您业务规模和需求的最佳计划': 'We offer not only self-employed businesses, but also charging schemes for legal persons. Provide OEM and ODM support and weekend customer service to choose the best plan for your business size and needs',
  '法人和企业客户请点此 >': 'Corporate and corporate clients please click here >',
  个人及个体户的收费计划: 'Individual and self-employed pricing plan',
  '我们还为个体户和个人用户提供会员计划。适合业务起步阶段的新人或希望尝试新挑战的人群，助力他们迈向更高的业务台阶。': 'It also offers membership programs for self-employed and individual users. It is suitable for new employees at the start of their business or those who want new challenges, and helps them move to a higher level of business.',
  '个人用户请点击此处 >': 'For individual users, click here >',
  常见的问题: '',
  免费咨询2: 'Free consultation',
  '若对选择合适的计划有疑问，请随时联系我们。THECKB（直行便）的专业人员将根据您的业务需求为您提供免费咨询。': 'If you have any questions about your choice, please feel free to contact us. Our professional team will recommend the best option for you based on your business needs for free.',
  免费咨询: 'Free consultation',
  上一步: 'prev',
  仅限在线聊天: 'For online chat only',
  '申请前，请先升级至商务舱会员及以上。': 'Please upgrade to a business member first before applying.',
  '下单次数超出限制，请升级会员': 'Order count exceeds the limit. Please upgrade your membership.',
  '剩余可新增子店铺数量：X个': 'Number of stores that can be created: remaining X',
  '您的会员仓位可创建的店铺个数上限为{x}个': 'In the current member plan, the number of stores you can create is up to {x}.',
  '您的会员仓位可创建的店铺个数上限为{x}个(2b+2c)': 'In the current member plan, the number of stores you can create is up to {x}.',
  '您的会员仓位可创建的店铺个数上限为{x}个，如需新增，请升级会员等级。': 'In the current member plan, the number of stores you can create is up to {x}. To add new stores, you need to upgrade your member plan.',
  '订单已生成，部分订单支付失败，': 'The order has been generated, but some orders have failed to be paid. ',
  '非会员只能下单普通商品,请升级会员': 'Non members can only place orders for regular products. Please upgrade to a member',
  包含商务计划的所有服务: 'All services including business plan',
  店舗商品名: 'Store product name',
  清空失效商品: 'Clear expired products',
  失效商品: 'Expired products',
  是否清空失效商品: 'Do you want to clear expired products?',
  '无法批量操作，请去单个商品上维护': 'Unable to operate in bulk. Please maintain it on individual items.',
  '注意：批量水洗标模版功能，只对未下过单的商品生效': 'Note: The batch wash label template function is effective only for items that have not been ordered.',
  批量编辑子商品附加项: 'Batch edit sub-product add-ons',
  请选择相同国家商品: 'Please select the same country\'s products.',
  '注意：如需修改水洗标模版，请加入购物车后修改': 'If you need to modify the wash label template, please add it to your cart and make the changes.',
  '国际送料（含远方送料手续费）': 'International shipping (including remote areas)',
  请确认采购商品信息: 'Please confirm the purchase product information.',
  '国际物流费用(含偏远地区附加费)退回': 'International shipping (including remote areas) refund',
  尺码差异2: 'Reason for defect: Wrong size<br/>Deemed defective according to inspection standards<br/>Please specify what to do in case of defect',
  配件差异2: 'Reason for defect: Different accessories<br/>Deemed defective according to inspection standards<br/>Please specify what to do in case of defect',
  设计差异2: 'Reason for defect: Different design<br/>Deemed defective according to inspection standards<br/>Please specify what to do in case of defect',
  染色不良: 'Reason for defect: Poor dyeing<br/>Deemed defective according to inspection standards<br/>Please specify what to do in case of defect',
  抽绳不良: 'Reason for defect: Poor rope pulling<br/>Deemed defective according to inspection standards<br/>Please specify what to do in case of defect',
  '从策划提案到采购、OEM/ODM、质量管理、物流等全流程，提供一站式全方位支持。': 'It provides one-stop all-round support throughout the entire process, from offer to purchase, OEM/ODM, quality control, and logistics.',
  '海外からの輸入・仕入れ・OEMならTHE CKB（直行便）': 'For overseas imports, purchases, or OEMs, THE CKB (direct delivery)',
  用户数: 'Number of users in',
  商品数: 'Number of products',
  什么是直行便: 'What is the CKB?',
  '专注于海外商品批发采购及OEM生产的全方位采购服务。': 'Focused on comprehensive procurement services for wholesale purchases of overseas goods and OEM production.',
  '通过线上线下双渠道确保高质量且低成本的采购渠道，依托自有OEM工厂、物流网络及专有系统，实现从订单下达至交付的全流程高效运作。': 'Ensure high-quality and cost-effective procurement channels through both online and offline channels, leveraging our own OEM factories, logistics network, and proprietary systems to achieve efficient operation from order placement to delivery.',
  '不仅优化日常采购流程，更全程支持原创品牌创建，致力于为客户实现利益最大化。': 'Not only does it optimize daily procurement processes, but it also fully supports the creation of original brands, committed to maximizing benefits for customers.',
  选择CKB的理由: 'Why did you choose CKB',
  '通过多样化的采购渠道，提供丰富多样的商品阵容。': 'We offer a rich and diverse product lineup through a variety of purchase routes.',
  '日本标准的严格检验，品质有保障。': 'Strict inspection of Japanese standards ensures quality.',
  通过自有OEM工厂支持品牌创建: ' Support brand creation through its own OEM factory',
  '独自開発のシステムで仕入れ〜出荷を効率化': 'The developed purchase system has increased efficiency from purchase to shipment.',
  电话联系时间: 'Consultation Hours (10:30 - 19:30, 13:00 - 14:15 lunchtime)',
  其他登录方法: 'Other login methods',
  品牌成长的全方位支持: 'Comprehensive support for brand growth',
  'THE CKB（直航）付费会员': 'THE CKB paid members',
  '【专属的商品提案】': 'Exclusive Product Proposal',
  '通过提出差异化产品及未在阿里巴巴平台上架的商品，实现摆脱低价竞争的战略。': 'By proposing differentiated products and items not listed on the Alibaba platform, we achieve a strategy to price competition.',
  '【品牌代理销售权及折扣价采购】': 'Brand Agency Sales Rights and Discount Price Procurement',
  '付费会员专享！通过品牌代理销售或独家销售实现与竞争对手的差异化，获得品牌代理销售权及折扣价采购。': 'Exclusive for paying members! Through brand agency sales or exclusive sales, differentiate yourself from competitors and obtain brand agency sales rights and purchase at discounted prices.',
  '【OEM/ODM服务及产品选项】': 'OEM/ODM Services and Product Options',
  '丰富的定制选项和OEM服务，助力您打造自有品牌。': 'A wide range of customization options and OEM services to help you build your own brand.',
  '【通过dropshipping实现效率化】': '',
  '日本のECサイトと連携し、在庫なしで自動発注・発送が可能！': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  /** 新会员end */
  下单失败2: 'Order failed',
  '您的订单需要“子店铺口座”的余额支付': 'Your order requires payment from the balance of the "Select Sub-account."',
  '目前，主账户中有余额，但尚未转入子店铺口座。': 'Currently, there is a balance in the Master account but it has not yet been transferred to the Select Sub-account.',
  '主账户余额：X元（可转账）': 'Master account balance: X (transferable) ',
  '主账户余额：X元': 'Master account balance: X ',
  '请先从以下按钮进行转账，然后再下单。': 'Please transfer the funds using the button below before placing your order.',
  去转账给子店铺: 'Go transfer money to the Select Sub-account',
  确认账户余额: 'Check your account balance',
  '目前，主账户中有审核中的余额，但是还不能转账。': 'There is a balance currently under review in this account, but the transfer is not possible yet.',
  审核结束后可以转账: '※ Transfer is possible after the review is completed. Please wait a moment.',
  此设置只针对代采商品生效: 'This setting is effective only for procurement products.',
  发往的国家: 'Countries to be shipped to',
  发货仓库: 'Shipping warehouse',
  采购国家: 'Procurement Country',
  '不能接受该不良，希望同商品换货（该换货无需重新冻结费用，如供应商无货，则系统会自动取消）': 'Cannot accept this issue and wishes to exchange it with the same item (this exchange does not require re-freezing fees; if the supplier is out of stock, the system will automatically cancel it).',
  换货中: 'Exchange in progress',
  换货记录: 'Return records',
  换货时间: 'Return time',
  换货数量: 'Return quantity',
  '根据shopify最新要求，2026/1/1起，需提供以上内容进行授权': 'According to Shopify\'s latest requirements, starting from January 1, 2026, the above information must be provided for authorization purposes.',
  汇款证明: 'Transfer proof',
  '转账完成后，请输入以下信息并提交。': 'After the transfer is completed, please enter the following information and submit.',
  不设置: 'Do not set',
  已设置: 'Configured',
  未设置: 'Not set',
  设置: 'Configure',
  选项确认: 'Confirm Options',
  商品采购状态: 'Product Procurement Status',
  商品发货状态: 'Product Shipping Status',
  发货国家: 'Shipping Country',
  一口价: 'All-Inclusive Price',
  '直发订单(一口价)': 'Direct purchase orders (All-Inclusive Price)',
  商品采购国家: 'Product Procurement Country',
  供应商是否为空: 'Supplier Information Availability',
  供应商信息: 'Supplier Information',
  待匹配: 'Pending Matching',
  匹配良品: 'Matched Good Products',
  发货完了: 'Shipment Completed',
  处理中明细: 'Processing Details',
  历史已采购数量: 'Historical Purchased Quantity',
  心愿清单: 'Wishlist',
  当前可购买: 'Currently Available for Purchase',
  '': ''
}
